import React, { useState, useRef, useEffect, useMemo, useLayoutEffect } from "react"
import {
  CardBody,
  Col,
  Container,
  Row,
  // Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap"
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from "primereact/tabview"
import { Link, useLocation } from "react-router-dom"
import moment from "moment";
import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import { Chips } from "primereact/chips";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import { MultiSelect } from 'primereact/multiselect'; // Make sure to import MultiSelect correctly
import 'jspdf-autotable';
import { Calendar } from 'primereact/calendar';
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import axios from "axios"
import { setPageData } from "store/actions"
// import { Toast } from 'primereact/toast';
import { Accordion, AccordionTab } from "primereact/accordion";
import { Badge } from 'primereact/badge';
import { TreeTable } from 'primereact/treetable';
import { Card } from 'primereact/card';
import { CascadeSelect } from 'primereact/cascadeselect';
import { Tooltip } from 'primereact/tooltip';
import { triggerAlert } from "utils/CommonFunctions";
import { ProgressSpinner } from "primereact/progressspinner"
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { emailValidation,MaxLengthValidation, MinLengthValidation, onlyNumbers, onlyAlphabetsandSpaces } from "../../utils/Constants";


import { Toast } from "primereact/toast";
import { ContextMenu } from "primereact/contextmenu";
import { useNavigate } from "react-router-dom";
import { TreeSelect } from 'primereact/treeselect';

import { FileUpload } from "primereact/fileupload";
import { Controller, } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux"
import { menuIdData } from "../../utils/Constants"
import { get_user_menu_permission } from "../../utils/CommonFunctions"
import { setJobSidebarVisible, setCandidateSidebarVisible } from "store/actions";


const JobAllActive = ({ type, param }) => {
  const dispatch = useDispatch();
  const jobSidebarVisible = useSelector(state => state.calendar.jobSidebarVisible);
  const candidateSidebarVisible = useSelector(state => state.calendar.visible);
  const { first, rows, totalRecords } = useSelector(
    state => state.calendar.pagination
  )

  // Candidate form states
  const archived_only = param === 'archived_only=true';
  const [visibleViewRight, setVisibleViewRight] = useState(false);
  // Dedicated job form instance to isolate job creation fields from other forms (candidate, etc.)
  const jobForm = useForm();
  const { register: registerJob, handleSubmit: handleSubmitJob, reset: resetJob, trigger: triggerJob, clearErrors: clearErrorsJob, formState: { errors: errorsJob }, setValue: setValueJob, getValues: getValuesJob, control: controlJob } = jobForm;
  // Restore general form helpers for other forms in this component
  const { register, handleSubmit, reset, trigger, clearErrors, formState: { errors }, setValue, getValues, control } = useForm();
  const { register: register1, formState: { errors: errors1 }, handleSubmit: handleSubmit1, getValues: getValues1, setValue: setValue1, trigger: trigger1, reset: reset1, } = useForm({ mode: "onBlur" });
  const [disable, setDisable] = useState(false);
  const { register: registerView, handleSubmit: handleSubmitView, reset: resetView, trigger: triggerView, clearErrors: clearErrorsView, formState: { errors: errorsView }, setValue: setValueView, getValues: getValuesView, control: controlView } = useForm();
  const { register: register2, formState: { errors: errors2 }, handleSubmit: handleSubmit2, getValues: getValues2, setValue: setValue2, trigger: trigger2, reset: reset2, } = useForm({ mode: "onBlur" });
  const { register: register3, formState: { errors: errors3 }, handleSubmit: handleSubmit3, getValues: getValues3, setValue: setValue3, trigger: trigger3, reset: reset3, } = useForm({ mode: "onBlur" });
  const { register: register4, formState: { errors: errors4 }, handleSubmit: handleSubmit4, getValues: getValues4, setValue: setValue4, trigger: trigger4, reset: reset4, } = useForm({ mode: "onBlur" });
  const { register: register5, formState: { errors: errors5 }, handleSubmit: handleSubmit5, getValues: getValues5, setValue: setValue5, trigger: trigger5, reset: reset5, } = useForm({ mode: "onBlur" });
  document.title = "ATS"
  const [visibleRight, setVisibleRight] = useState(false);
  const [jobLocationview, setJobLocationview] = useState(null);
  const [jobLocations, setjobLocations] = useState([])
  const [fileDataattach, setfileDataattach] = useState([])
const [showNoSubjectConfirm, setShowNoSubjectConfirm] = useState(false);
const [pendingSubmitType, setPendingSubmitType] = useState(null);
const [allDocumentTypes, setAllDocumentTypes] = useState([]);
const [headerJobStatusOptions, setHeaderJobStatusOptions] = useState([]);
const [selectedHeaderJobStatus, setSelectedHeaderJobStatus] = useState(null);
const [hiringManagers, setHiringManagers] = useState([]);
const [stages, setStages] = useState([]);

const selectedJobStatusLabel = useMemo(() => {
  const selected = headerJobStatusOptions.find(opt => opt.value === selectedHeaderJobStatus);
  return selected ? selected.label : "";
}, [headerJobStatusOptions, selectedHeaderJobStatus]);

const isApprovedOpenStatus = useMemo(() => {
  const selected = headerJobStatusOptions.find(opt => opt.value === selectedHeaderJobStatus);
  return selected && selected.label === "Approved / Open";
}, [headerJobStatusOptions, selectedHeaderJobStatus]);


useEffect(() => {
  const fetchHeaderJobStatus = async () => {
    try {
      const endpoint = type === 'closed-jobs' 
        ? `/api/v1/get-all-Job-status/?type=closed-jobs`
        : `/api/v1/get-all-Job-status/`;
      
      const response = await axios.get(endpoint);
      const options = response?.data?.results?.map(item => ({
        label: item.job_status,
        value: item.id,
        description: item.description,
      }));
      setHeaderJobStatusOptions(options);

      if (type === 'closed-jobs') {
        const closedFilled = options.find(opt => opt.label === "Closed - Filled");
        if (closedFilled) setSelectedHeaderJobStatus(closedFilled.value);
      } else {
        const approvedOpen = options.find(opt => opt.label === "Approved / Open");
        if (approvedOpen) setSelectedHeaderJobStatus(approvedOpen.value);
      }
    } catch (error) {
      setHeaderJobStatusOptions([]);
    }
  };
  fetchHeaderJobStatus();
}, []);

  // --- Pipeline Tab/Stage Auto-population ---
  // Track the active pipeline tab (e.g., 'Received', 'Potential', etc.)
  const [activePipelineTab, setActivePipelineTab] = useState('received');
  // Track active pipeline tab for each job in expanded rows
  const [jobActivePipelineTabs, setJobActivePipelineTabs] = useState({});

  // Handler to update active pipeline tab
  const handlePipelineTabChange = (e) => {
    // Get the stage name from the stages array using the tab index
    const selectedStage = stages?.[e.index]?.name || stages?.[e.index] || stages?.[0]?.name || stages?.[0] || 'Received';
    console.log('Tab changed to:', selectedStage, 'at index:', e.index);
    setActivePipelineTab(selectedStage);
    
    // Auto-populate stage field if candidate form is open
    if (candidateSidebarVisible) {
      setFormData(prev => ({
        ...prev,
        stage: selectedStage
      }));
      setFormErrors(prev => ({
        ...prev,
        stage: ""
      }));
    }
  };

  // Handler to update active pipeline tab for specific job
  const handleJobPipelineTabChange = (jobId, e) => {
    const selectedStage = stages?.[e.index]?.name || stages?.[e.index] || stages?.[0]?.name || stages?.[0] || 'Received';
    console.log('Job', jobId, 'tab changed to:', selectedStage, 'at index:', e.index);
    setJobActivePipelineTabs(prev => ({
      ...prev,
      [jobId]: selectedStage
    }));
    
    // Auto-populate stage field if candidate form is open and this is the selected job
    const currentJobId = selectedJobsData.length > 0 ? selectedJobsData[0]?.job_id : null;
    if (candidateSidebarVisible && String(currentJobId) === String(jobId)) {
      setFormData(prev => ({
        ...prev,
        stage: selectedStage
      }));
      setFormErrors(prev => ({
        ...prev,
        stage: ""
      }));
    }
  };

  // When opening candidate creation, auto-populate stage field
  const handleOpenCandidateForm = (jobId = null, activeStage = null) => {
    let stageToSet = null;
    
    if (activeStage) {
      // Use the provided active stage
      stageToSet = activeStage?.name || activeStage;
    } else if (jobId && jobActivePipelineTabs[jobId]) {
      // Use the active tab for this specific job
      stageToSet = jobActivePipelineTabs[jobId];
    } else if (activePipelineTab) {
      // Use the global active pipeline tab
      stageToSet = activePipelineTab;
    } else if (stages && stages.length > 0) {
      // Fallback to first stage
      stageToSet = stages[0]?.name || stages[0];
    }
    
    // Set the stage in form data
    setFormData(prev => ({
      ...prev,
      stage: stageToSet
    }));
    
    // Also clear any stage validation errors
    setFormErrors(prev => ({
      ...prev,
      stage: ""
    }));
    
    // Open the candidate sidebar
    dispatch(setCandidateSidebarVisible(true));
  };

    const openAddressDialog = () => {
    setTempAddressData({
      street_address: formData.street_address,
      street_address_line_2: formData.street_address_line_2,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      pincode: formData.pincode,
      label: formData.label,
    })
    setVisible(true)
  }
  
  const getcity = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-cities/`, {});

      // Transform data if needed to match the Dropdown format
      const transformedData = response?.data?.results?.map((city) => ({
        name: city?.name,
        id: city?.city_id,
      }));
      setjobLocations(transformedData);

    }
    catch (error) {
    }
  };

  const getHiringManagers = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-hiring-managers/?status=Active`);
      const transformedData = response?.data?.results?.map((hm) => ({
        name: `${hm.first_name} ${hm.middle_name || ''} ${hm.last_name || ''}`.trim(),
        id: hm.id,
      }));
      setHiringManagers(transformedData);
      // Auto-populate if logged-in user is a hiring manager
      const matchingHM = transformedData.find(hm => hm.id === loggedInUserId);
      if (matchingHM) {
        setHiringManager(matchingHM.id);
      }
    } catch (error) {
      setHiringManagers([]);
    }
  };

  const getRecruiterManagers = async () => {
    try {
      const response = await axios.get(`/api/v1/users/recruiting-managers/`);
      const transformedData = response?.data?.results?.map((rm) => ({
        name: rm.full_name,
        id: rm.id,
      }));
      setRecruiterManagerOptions(transformedData);
      // Auto-populate if logged-in user is a recruiter manager
      const matchingRM = transformedData.find(rm => rm.id === loggedInUserId);
      if (matchingRM) {
        setRecruiterManager(matchingRM.id);
      }
    } catch (error) {
      setRecruiterManagerOptions([]);
    }
  };

  const getRecruiterOptions = async () => {
    try {
      const response = await axios.get(`https://qaatsapi.pranathiss.com/api/v1/users/recruiters/`);
      const transformedData = response?.data?.results?.map((r) => ({
        name: r.full_name,
        id: r.id,
      }));
      setRecruiterOptions(transformedData);
    } catch (error) {
      console.error('Error fetching recruiters:', error);
      setRecruiterOptions([]);
    }
  };
  
  const [assignRecruitersAction, setAssignRecruitersAction] = useState(false);
  const [selectOnlyOneJob, setSelectOnlyOneJob] = useState(false);
  const [selectedRecruiters, setSelectedRecruiters] = useState([]);
  
  const getAssignedRecruiters = async (jobId) => {
    try {
      const response = await axios.get(`/api/v1/jobs/${jobId}/`);
      const job = response.data;
      setSelectedRecruiters(job.recruiters || []);
    } catch (error) {
      setSelectedRecruiters([]);
    }
  };

  // let userinfo = JSON.parse(sessionStorage.getItem('atsuser-info'))
  // alert(userinfo)
  const [experience, setExperience] = useState("")
  const [jobStartDate, setJobStartDate] = useState(null);
  const [jobEndDate, setJobEndDate] = useState(null);
  const [timetohire, settimetohire] = useState(null);

  useEffect(() => {
    if (jobStartDate && jobEndDate) {
      const start = new Date(jobStartDate);
      const end = new Date(jobEndDate);
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      settimetohire(diffDays);
    } else {
      settimetohire(null);
    }
  }, [jobStartDate, jobEndDate]);
  const [jobActualEnddate, setjobActualEnddate] = useState(null);
  const [primartkey, setprimartkey] = useState([]);
  const [successAlert, setSuccessAlert] = useState(false);
  const [deleteRowId, setDeleteRowID] = useState(null) // end date value
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [uniqueUserId, setUniqueUserId] = useState("");
  const [uniquemailID, setuniquemailID] = useState([]);
  const [errorjobs, seterrorjobs] = useState("");
  const [addPermission, setAddPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const getMinEndDate = () => {
    if (!jobStartDate) return null;
    const minDate = new Date(jobStartDate);
    minDate.setDate(minDate.getDate() + 1);
    return minDate;
  };

  useEffect(() => {
    if (type === "my-active") {
      const menu_id = menuIdData?.MyActiveJobs;
      setAddPermission(get_user_menu_permission(menu_id, 'add'));
      setEditPermission(get_user_menu_permission(menu_id, 'edit'));
      setDeletePermission(get_user_menu_permission(menu_id, 'delete'));
      setViewPermission(get_user_menu_permission(menu_id, 'view'));
    } else if (type === "?archived_only=true") {
      const menu_id = menuIdData?.ArchivedJobs;
      setAddPermission(get_user_menu_permission(menu_id, 'add'));
      setEditPermission(get_user_menu_permission(menu_id, 'edit'));
      setDeletePermission(get_user_menu_permission(menu_id, 'delete'));
      setViewPermission(get_user_menu_permission(menu_id, 'view'));
    } else if (type === "added_by_me") {
      const menu_id = menuIdData?.AddedbyMeJobs;
      setAddPermission(get_user_menu_permission(menu_id, 'add'));
      setEditPermission(get_user_menu_permission(menu_id, 'edit'));
      setDeletePermission(get_user_menu_permission(menu_id, 'delete'));
      setViewPermission(get_user_menu_permission(menu_id, 'view'));
    } else if (type === "assigned-to-me") {
      const menu_id = menuIdData?.AssignedtoMeJobs;
      setAddPermission(get_user_menu_permission(menu_id, 'add'));
      setEditPermission(get_user_menu_permission(menu_id, 'edit'));
      setDeletePermission(get_user_menu_permission(menu_id, 'delete'));
      setViewPermission(get_user_menu_permission(menu_id, 'view'));
    } else if (type === "closed-jobs") {
      const menu_id = menuIdData?.AllClosedJobs;
      setAddPermission(get_user_menu_permission(menu_id, 'add'));
      setEditPermission(get_user_menu_permission(menu_id, 'edit'));
      setDeletePermission(get_user_menu_permission(menu_id, 'delete'));
      setViewPermission(get_user_menu_permission(menu_id, 'view'));
    } else if (type === "activity-log") {
      const menu_id = menuIdData?.JobActivityLog;
      setAddPermission(get_user_menu_permission(menu_id, 'add'));
      setEditPermission(get_user_menu_permission(menu_id, 'edit'));
      setDeletePermission(get_user_menu_permission(menu_id, 'delete'));
      setViewPermission(get_user_menu_permission(menu_id, 'view'));
    } else {
      const menu_id = menuIdData?.AllActiveJobs;
      setAddPermission(get_user_menu_permission(menu_id, 'add'));
      setEditPermission(get_user_menu_permission(menu_id, 'edit'));
      setDeletePermission(get_user_menu_permission(menu_id, 'delete'));
      setViewPermission(get_user_menu_permission(menu_id, 'view'));
    }
  }, [])

  const [errmsgexperience, seterrmsgexperience] = useState("")
  const [errmsgcompanies, seterrmsgcompanies] = useState("")
  const [errmsghirring, seterrmsghirring] = useState("")
  const [errmsgrecruitermanager, seterrmsgrecruitermanager] = useState("")
  const [errmsgrecruiters, seterrmsgrecruiters] = useState("")

  const onSubmit = async (data) => {
    console.log('onSubmit invoked', { data });
    let isValid = true;

    // Run validation for form fields registered via react-hook-form
  const result = await triggerJob(); // Triggers full validation for job-specific registered fields

    // Custom validation for Experience
    if (!experience || experience <= 0) {
      seterrmsgexperience("Experience is required");
      isValid = false;
    } else {
      seterrmsgexperience(""); // Clear if valid
    }

    // Custom validation for Company
    if (!selectedCompany) {
      seterrmsgcompanies("Company is required");
      isValid = false;
    } else {
      seterrmsgcompanies(""); // Clear if valid
    }
    if (!hiringManager) {
      seterrmsghirring("Hiring manager is required");
      isValid = false;
    } else {
      seterrmsghirring(""); // Clear if valid
    }
    if (!recruiterManager) {
      seterrmsgrecruitermanager("Recruiter Manager is required");
      isValid = false;
    } else {
      seterrmsgrecruitermanager(""); // Clear if valid
    }

    // Stop submission if any validation fails — ensure UI is not stuck
    if (!result || !isValid) {
      console.log('Validation failed', { result, isValid });
      setLoading(false);
      setDisable(false);
      return;
    }
    setLoading(true);
    setDisable(true);
    // const formData = new FormData();
    const formattedFromDate = moment(jobStartDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const formattedtoDate = moment(jobEndDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const jobActualEnddateDate = moment(jobActualEnddate, "YYYY-MM-DD").format("YYYY-MM-DD");



    const req = {};

    if (data?.jobtitle) {
      req.job_title = data.jobtitle;
    }
    if (data?.job_number) {
      req.job_number = data.job_number;
    }
    if (timetohire) {
      req.time_to_hire_days = timetohire;
    }
    req.company_id = selectedCompany;
    req.hiring_manager = hiringManager;
    req.recruiting_manager = recruiterManager;
    req.recruiters = recruiters;
    req.required_experience = experience;

    req.job_closing_date = formattedtoDate && formattedtoDate !== 'Invalid date' ? formattedtoDate : null;
    req.job_posting_date = formattedFromDate && formattedFromDate !== 'Invalid date' ? formattedFromDate : null;
    // req.actual_end_date = jobActualEnddateDate && jobActualEnddateDate !== 'Invalid date' ? jobActualEnddateDate : null;

    req.job_start_date = formattedFromDate && formattedFromDate !== 'Invalid date' ? formattedFromDate : null;
    req.job_end_date = formattedtoDate && formattedtoDate !== 'Invalid date' ? formattedtoDate : null;

    req.location = jobLocationview;
    req.workplace_types = jobworkspace;

    req.required_skills = primarySkillsview && primarySkillsview.length > 0 ? primarySkillsview : null;


    req.job_description = text || null;

    req.categories = selectedNodeKeycat;

    req.groups = selectedgroupKey;
    req.user_ids = uniqueUserId;

    req.private = popchecked3;
    // req.time_to_hire_days = timetohire || null;



    try {
      console.log('About to call axios.post with req:', req);
      const response = await axios.post(`/api/v1/jobs/`, req, {});

      const page = Math.floor(first / rows) + 1
      getArchedjob(page, rows, type, param, selectedHeaderJobStatus);
      dispatch(setJobSidebarVisible(false));
      setHiringManager(null);
      setRecruiterManager(null);
      setRecruiters([]);
      setsuccessMatch(true)
      setsuccess('Job Added ');
      // window.location.reload();
    } catch (error) {
      if (error.response?.data?.error) {
        seterrorjobs(error.response.data.error)
      }

    } finally {
      setLoading(false);
      setDisable(false);
    }
  };

  const stripHtml = (htmlString) => htmlString.replace(/<[^>]*>/g, '');
  // const onSubmitJobStatus = async (data) => {
  //   let id = statusids
  //   const req = {
  //     status: Number(data.arcStatus) // This ensures it's a number
  //   };
  //   try {
  //     const response = await axios.patch(`/api/v1/jobs/${id}/change-status/`, req,);
  //     setChangeStatusAction(false);
  //     setsuccessMatch(true)
  //     setSelectedJobsData([])
  //     setSelectedScheduleOption("")

  //     const page = Math.floor(first / rows) + 1
  //     await getArchedjob(page, rows, type, param, selectedHeaderJobStatus);
  //   } catch (error) {

  //   }
  // };
  
    const onSubmitJobStatus = async (data) => {
    const jobIds = Array.isArray(selectedJobsData)
    ? selectedJobsData.map(job => job.job_id)
    : selectedJobForStatus
      ? [selectedJobForStatus.job_id]
      : [];

  if (jobIds.length === 0) return;

  const req = {
    status: Number(data.arcStatus)
  };

  setLoading(true);
     try {
    // Update status for each selected job
    await Promise.all(
      jobIds.map(id =>
        axios.patch(`/api/v1/jobs/${id}/change-status/`, req)
      )
    );
    setChangeStatusAction(false);
    setsuccessMatch(true);
    setSelectedJobsData([]);
    setSelectedScheduleOption("");
    const page = Math.floor(first / rows) + 1;
    await getArchedjob(page, rows, type, param, selectedHeaderJobStatus);
  } catch (error) {
    // handle error if needed
  } finally {
    setLoading(false);
  }
};

const onSubmitAssignRecruiters = async (e) => {
  e.preventDefault();
  const jobId = selectedJobsData[0]?.job_id;
  const req = {
    recruiters: selectedRecruiters
  };
  setLoading(true);
  try {
    await axios.patch(`/api/v1/jobs/${jobId}/`, req);
    setAssignRecruitersAction(false);
    setsuccessMatch(true);
    setsuccess("Assigned Recruiters ");
    setSelectedJobsData([]);
    setSelectedScheduleOption("");
    const page = Math.floor(first / rows) + 1;
    await getArchedjob(page, rows, type, param, selectedHeaderJobStatus);
  } catch (error) {
    // handle error
  } finally {
    setLoading(false);
  }
};

  const archivedHandler = async () => {
    const id = deleteRowId;
    console.log(deleteRowId)
    try {
      await axios.patch(`/api/v1/jobs/${jobidsslect}/archive/`);
      setSmShow(false);
      setsuccessMatch(true);
      setSelectedJobsData([]);
      setsuccess("Archived ");
      const page = Math.floor(first / rows) + 1
       await getArchedjob(page, rows, type, param, selectedHeaderJobStatus);
    } catch (error) {

    }
  };
  const unarchivedHandler = async () => {
    const id = deleteRowId;
    console.log(deleteRowId)
    try {
      await axios.patch(`/api/v1/jobs/${jobidsslect}/unarchive/`);
      setSmShowun(false);
      setsuccessMatch(true);
      setSelectedJobsData([]);
      setsuccess("UnArchived ");
      const page = Math.floor(first / rows) + 1
      getArchedjob(page, rows, type, param, selectedHeaderJobStatus);


    } catch (error) {

    }
  };

  const matchcandidateHandler = async () => {
    try {
      const response = await axios.get(`/api/v1/candidate-job-links/match-candidates/?job_id=${jobidsslect}`, {});
      if (response.data) {
        let results = response.data.results;
        setsmShowmatchcond(false);
        setsuccessMatch(true)
        setSelectedJobsData([])
        setsuccess("Matched Candidates ");
        setSelectedScheduleOption("")
        // setSuccessAlert(true)
      }
    } catch (error) {

    }
  };


  const [selectoneemp, setselectoneemp] = useState(false);

  // jobs datatable
  const [filtersjoball, setfiltersjoball] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_number: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_status_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    openings: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    hiring_manager_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    location_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    workplace_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_type_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    required_skill_names: { value: null, matchMode: FilterMatchMode.CONTAINS },
    required_experience: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    salary_min: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    salary_max: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    department_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    hiring_goals: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_function_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    seniority_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    category_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    groups_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    created_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    updated_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    created_by_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    description: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    ip_address: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    action_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    action_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

    event_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });
  const [jobsDataArchirved, setjobsDataArchirved] = useState([])
  const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
  const [lazyParamslist, setlazyParamslist] = useState({ page: 0, rows: 10 });
  const [totalRecordslist, setTotalRecordslist] = useState(0);
  // const [totalRecords, setTotalRecords] = useState(0);

  const [filters, setFilters] = useState({});

  const [filteredData, setFilteredData] = useState([]);

  const filterKeys = [
    'job_number', 'job_title', 'job_status_name', 'openings', 'hiring_manager_name', 'company_name', 'location_name', 'workplace_name',
    'job_type_name', 'required_skill_name', 'required_experience', 'salary_min', 'salary_max',
    'department_name', 'job_start_date', 'job_end_date', 'hiring_goals', 'job_function_name', 'seniority_name',
    'category_name', 'groups_name', 'created_at', 'updated_at', 'created_by_name', 'description', 'ip_address', 'action_type', 'action_date'
  ];




  useEffect(() => {
    // Dummy data — replace this with your real API data

    // setJobsData(filteredData);
    // setjobsDataArchirved(filteredData);
    // setFilters(initialFilters);
  }, []);


  const onFilter = (e) => {
    const updatedFilters = {};

    Object.keys(e?.filters)?.forEach((key) => {
      const filter = e?.filters[key];
      if (filter?.value !== undefined && filter?.matchMode !== undefined) {
        updatedFilters[key] = filter;
      }
    });

    setFilters(updatedFilters);

    const filtered = applyClientSideFilters(jobsData, updatedFilters);
    setFilteredData(filtered);
  };



  const applyClientSideFilters = (data, filters) => {
    return data?.filter((row) =>
      filterKeys?.every((key) => {
        const filter = filters[key];

        // If filter doesn't exist or has no value or no matchMode, skip it
        if (!filter || !filter?.value || !filter?.matchMode) return true;

        const filterValue = filter?.value?.toString()?.toLowerCase();
        const rowValue = (row[key] ?? '')?.toString()?.toLowerCase();

        switch (filter?.matchMode) {
          case FilterMatchMode.STARTS_WITH:
            return rowValue.startsWith(filterValue);
          case FilterMatchMode.ENDS_WITH:
            return rowValue.endsWith(filterValue);
          case FilterMatchMode.EQUALS:
            return rowValue === filterValue;
          case FilterMatchMode.NOT_EQUALS:
            return rowValue !== filterValue;
          case FilterMatchMode.CONTAINS:
          default:
            return rowValue.includes(filterValue);
        }
      })
    );
  };
  // useEffect(() => {
  //   getArchedjob(type);
  // }, [lazyParamslist, type]);

  const onPageChangelist = (event) => {
    setlazyParamslist({ page: event.page, rows: event.rows });
  };
  const onPageChange = (event) => {
    setLazyParams({ page: event.page, rows: event.rows });
  };



  const getArchedjob = async (page, size, selectedPlan = '', param = '' , statusId) => {
setLoading(true);
    try {
      // const jobslistend = selectedPlan === 'activity-log' ? `/api/v1/activity-log/?module=Job&page=${page}&size=${size}`
      //   : `api/v1/jobs${selectedPlan ? '/' + selectedPlan : ''}/?${param ? param + '&' : ''}page=${page}&size=${size}`;


      const jobslistend =
        selectedPlan === 'activity-log' ? `/api/v1/activity-log/?module=Job&page=${page}&size=${size}${statusId ? `&status=${statusId}` : ''}` :
          `/api/v1/jobs${selectedPlan ? '/' + selectedPlan : ''}/?${param ? param + '&' : ''}page=${page}&size=${size}${statusId ? `&status=${statusId}` : ''}`;

      const response = await axios.get(jobslistend);

      if (response.data) {
        let results = response.data.results;

        if (selectedPlan === 'activity-log') {
          results = results?.map((item) => ({
            calendar_id: item?.calendar_id,
            created_by_name_job: item?.created_by_name_job,
            ...item?.job,
            original: item
          }));
        }

        setjobsDataArchirved(results || []);
        setSelectedJobsData([])
        dispatch(setPageData({
          first: (page - 1) * size,
          rows: size,
          totalRecords: response?.data?.count || 0,
        }));

      } else {
        setjobsDataArchirved([]);

      }

      const transformedData = response?.data?.results?.map((cond) => ({
        name: cond?.job_number,
        id: cond?.job_id,
      }));

      settypeInterviewcondirec(transformedData)
      // setTotalRecordslist(response.data.count || 0)
    } catch (error) {

    }
     finally {
    setLoading(false); // Stop loader
  }
  };

  useEffect(() => {
    const page = Math.floor(first / rows) + 1
    getArchedjob(page, rows, type, param, selectedHeaderJobStatus);

  }, [first, rows, type, param, selectedHeaderJobStatus]);

  const [selectedJobsData, setSelectedJobsData] = useState([]);
  const [selectedactivity, setselectedactivity] = useState([]);
  const [jobidsslect, setjobidsslect] = useState([])
  const [candidateidsslect, setcandidateidsslect] = useState([])
  const [jobidsslectnames, setjobidsslectnames] = useState([])
  const [successAlertlink, setsuccessAlertlink] = useState(false);
  const [selectedJobListname, setselectedJobListname] = useState([])

  const [selectedJobForStatus, setSelectedJobForStatus] = useState(null);
  const [changeStatusAction, setChangeStatusAction] = useState(false)
  // const setSelectedJobsDataAcrhid = (e) => {
  //   const selected = e.value || [];
  //   setSelectedJobsData(selected)
  //   setjoblinkcon(selected)
  //   const selectedIds = selected.map((candidate) => candidate.job_id);
  //   setjobidsslect(selectedIds);
  //   const selectednames = selected.map((candidate) => candidate.job_title);
  //   setjobidsslectnames(selectednames)







  //   if (selected.length === 1) {
  //     setSelectedJobTitles(selected[0].job_title);
  //     setSelectedJobForStatus(selected[0]);
  //   } else if (selected.length > 1) {
  //     setSelectedJobTitles(selected.map(j => j.job_title).join(", "));
  //     setSelectedJobForStatus(null);
  //   } else {
  //     setSelectedJobTitles(""); // Clear if none selected
  //     setSelectedJobForStatus(null);
  //   }
  //   setselectedJobListname(selected);


  // }

  const setSelectedJobsDataAcrhid = (e) => {
    const selected = e.value || [];

    // Set main state values
    setSelectedJobsData(selected);
    setselectedJobListname(selected);

    // Set IDs and titles
    const selectedIds = Array.isArray(selected) ? selected?.map(item => item?.job_id) : [];
    const selectedTitles = Array.isArray(selected) ? selected?.map(item => item?.job_title) : [];
    setjobidsslect(selectedIds);
    setjobidsslectnames(selectedTitles?.join(', '));
    setjoblinkcon(selectedIds);


    // ????contact ids and hiring manager
    const selectedhiring_manager = selected?.map((item) => item?.hiring_manager);
    if (selectedhiring_manager && selectedhiring_manager?.length > 0) {
      setprioritycontact(selectedhiring_manager);
      setcontactinterview("");
    } else {
      setprioritycontact([]);
      setcontactinterview("");
    }

    // Display in input
    if (selected?.length === 1) {
      setSelectedJobTitles(selected[0]?.job_title);
      setSelectedJobForStatus(selected[0]);
    } else if (selected?.length > 1) {
      setSelectedJobTitles(selectedTitles?.join(", "));
      setSelectedJobForStatus(null);
    } else {
      setSelectedJobTitles("");
      setSelectedJobForStatus(null);
    }


  };

  const handleJobSelectionChange = (e) => {
    const selected = e.value || [];
    setselectedJobListname(selected);

    // Extract and set the job titles
    const titles = Array.isArray(selected) ? selected?.map(job => job?.job_title)?.join(', ') : '';
    setSelectedJobTitles(titles);
    // Extract and set the job numbers for header
    const numbers = Array.isArray(selected) ? selected?.map(job => job?.job_number)?.join(', ') : '';
    setjobidsslectnames(numbers);
  };





  useEffect(() => {
    if (selectedJobListname && selectedJobListname.length > 0) {
      const titles = Array.isArray(selectedJobListname) ? selectedJobListname?.map(item => item?.job_title)?.join(", ") : '';
      setSelectedJobTitles(titles);
    }
  }, [selectedJobListname]);
  useEffect(() => {
    if (changeStatusAction && selectedJobForStatus) {

      const selectedStatusName = selectedJobForStatus.job_status_name || selectedJobForStatus.job_status;
      const matchingStatus = jobStatusOptions?.find((status) => status?.job_status === selectedStatusName || status?.id === selectedJobForStatus?.status_id);
      if (matchingStatus) {
        setValue1("arcStatus", matchingStatus?.id?.toString());
      } else {

        setValue1("arcStatus", ""); // fallback
      }
    }
  }, [changeStatusAction, selectedJobForStatus, jobStatusOptions]);


  const [loading, setLoading] = useState(false);
  const [smShow, setSmShow] = useState(false);
  const [smShowun, setSmShowun] = useState(false);
  const [smShowdele, setSmShowdele] = useState(false);
  const [smShowmatchcond, setsmShowmatchcond] = useState(false);
  const dt = useRef(null);
  const navigate = useNavigate();
  const handleClearSearchJobs = () => {
    setSelectedJobsData([])
    setSelectedScheduleval(""); setSelectedScheduleOption("")
    setfiltersjoball({
      job_number: { value: "" },
      job_title: { value: "" },
      job_status_name: { value: "" },
      openings: { value: "" },
      hiring_manager_name: { value: "" },
      company_name: { value: "" },
      location_name: { value: "" },
      workplace_name: { value: "" },
      job_type_name: { value: "" },
      required_skill_name: { value: "" },
      required_experience: { value: "" },
      salary_min: { value: "" },
      salary_max: { value: "" },
      department_name: { value: "" },
      job_start_date: { value: "" },
      job_end_date: { value: "" },
      hiring_goals: { value: "" },
      job_function_name: { value: "" },
      seniority_name: { value: "" },
      category_name: { value: "" },
      groups_name: { value: "" },
      created_at: { value: "" },
      updated_at: { value: "" },
      created_by_name: { value: "" },
      description: { value: "" },
      ip_address: { value: "" },
      action_type: { value: "" },
      action_date: { value: "" },
      event_type: { value: "" },
      event_sub_type: { value: "" },
      event_priority: { value: "" },
      start_date: { value: "" },
      subject: { value: "" }
    });
  };


  // State to track the right-clicked job
  const toast = useRef(null); // Reference for Toast notifications
  const cm = useRef(null); // Reference for ContextMenu
  const [receivedJobs, setreceivedJobs] = useState([])
  const [potentialJobs, setpotentialJobs] = useState([])
  const [submittedJobs, setsubmittedJobs] = useState([])
  const [offerJobs, setofferJobs] = useState([])
  const [interviewJobs, setinterviewJobs] = useState([])
  const [rejectedJobs, setrejectedJobs] = useState([])
  const [placedJobs, setplacedJobs] = useState([])
  const [badgeCounts, setBadgeCounts] = useState({
    Received: 0,
    Potential: 0,
    Submitted: 0,
    Interview: 0,
    Offer: 0,
    Placed: 0,
    Rejected: 0
  });
  const getAllActiveReceived = async (deleteRowId) => {
    try {
      const response = await axios.get(`/api/v1/stages/job_candidates_by_stage/?job_id=${deleteRowId}`, {});
      if (response.data) {
        const stages = response.data.results;
        setBadgeCounts({
          Received: stages?.find(stage => stage.stage_name === "Received")?.count || 0,
          Potential: stages?.find(stage => stage.stage_name === "Potential")?.count || 0,
          Submitted: stages?.find(stage => stage.stage_name === "Submitted")?.count || 0,
          Interview: stages?.find(stage => stage.stage_name === "Interview")?.count || 0,
          Offer: stages?.find(stage => stage.stage_name === "Offer")?.count || 0,
          Placed: stages?.find(stage => stage.stage_name === "Placed")?.count || 0,
          Rejected: stages?.find(stage => stage.stage_name === "Rejected")?.count || 0,
        });
        const transformCandidates = (job) =>
          job?.map((candidate) => ({
            status: candidate?.status,
            job_number: candidate?.job?.job_number,
            job_title: candidate?.job?.job_title,
            contact: candidate?.candidate_email,
            company: candidate?.current_company,
            date_time: candidate?.applied_date,
            user_ids: candidate?.user_ids,
          }));


        const receivedJobs = transformCandidates(
          stages?.find((stage) => stage?.stage_name === "Received")?.candidates || []
        );
        const potentialJobs = transformCandidates(
          stages?.find((stage) => stage?.stage_name === "Potential")?.candidates || []
        );
        const submittedJobs = transformCandidates(
          stages?.find((stage) => stage?.stage_name === "Submitted")?.candidates || []
        );
        const interviewJobs = transformCandidates(
          stages?.find((stage) => stage?.stage_name === "Interview")?.candidates || []
        );
        const offer = transformCandidates(
          stages?.find((stage) => stage?.stage_name === "Offer")?.candidates || []
        );
        const placed = transformCandidates(
          stages?.find((stage) => stage?.stage_name === "Placed")?.candidates || []
        );
        const rejected = transformCandidates(
          stages?.find((stage) => stage?.stage_name === "Rejected")?.candidates || []
        );
        setreceivedJobs(receivedJobs);
        setpotentialJobs(potentialJobs);
        setsubmittedJobs(submittedJobs);
        setinterviewJobs(interviewJobs);
        setofferJobs(offer);
        setrejectedJobs(rejected);
        setplacedJobs(placed);
      }
    } catch (error) {
    }
  };






  const [activitiesFilters, setActivitiesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_ids: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    action_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });


  const [activities, setactivities] = useState([])
  const [lazyParamsactive, setlazyParamsactive] = useState({ page: 0, rows: 10 })
  const [totalRecordsactive, settotalRecordsactive] = useState(0)
  const getsetactivities = async (job_id) => {
    try {
      const response = await axios.get(`/api/v1/activity-log/?job_id=${job_id}&page=${lazyParamsactive.page + 1}&size=${lazyParamsactive.rows}`, {});
      if (response.data) {
        let results = response.data.results;
        setactivities(results);
      }
      settotalRecordsactive(response.data.count || 0)
    } catch (error) {
    }
  };
  const onPageChangeactive = (event) => {
    setlazyParamsactive({ page: event.page, rows: event.rows });
  };

  useEffect(() => {
    if (visibleViewRight && selectedJobsData?.[0]?.job_id) {
      getsetactivities(selectedJobsData[0].job_id);
    }
  }, [visibleViewRight, selectedJobsData, lazyParamsactive]);


  const getCandidateIds = () => {
    setSmShowdele(true)

  };


  const deleteHandler = async () => {
  try {
    await axios.delete(`/api/v1/jobs/${jobidsslect}/`);
    setSmShowdele(false);
    setSelectedJobsData([]);
    setSelectedScheduleOption("");
    setSuccessAlert(true);

    // Immediately refresh the job list after deletion
    const page = Math.floor(first / rows) + 1;
    await getArchedjob(page, rows, type, param, selectedHeaderJobStatus);
  } catch (error) {
    // handle error if needed
  }
}

  const [selectedActivities, setSelectedActivities] = useState([]);
  const [isEditorVisible, setEditorVisible] = useState(false); // Manage editor visibility
  const [editorContent, setEditorContent] = useState(''); // Manage editor content
  const [editIndex, setEditIndex] = useState(null);
  const [candidateNotes, setCandidateNotes] = useState([]); // Store notes in an array

  const handleAddNotes = () => {
    setEditorVisible(true); // Show the editor
    setEditorContent(''); // Clear any previous content
    setEditIndex(null); // Reset editIndex when adding a new note
    setisEdited(false);
  };

  const [isEdited, setisEdited] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleSaveNotes = async (data) => {

    var req = {
      job_id: deleteRowId,
      notes: editorContent
    };
    if (!isEdited) {
      try {
        var notespost = await axios.post("/api/v1/notes/", req);
        if (notespost.data) {
          setEditorVisible(false)
          getallnotes(selectedJobsData[0].job_id)
          
          // setsuccessMatch(true)
          // setVisibleViewRight(false)
          // setSelectedJobsData([])
        }
      } catch (error) {
      }
    } else {
      try {
        var response = await axios.patch(`/api/v1/notes/${editId}/`, req);
        if (response.data) {
          setEditorVisible(false)
          getallnotes(selectedJobsData[0].job_id)
          // setsuccessMatch(true)
          // setVisibleViewRight(false)
          // setSelectedJobsData([])
        }
      } catch (error) {
      }
    }
  };

  const getallnotes = async (deleteRowId) => {

    try {
      const response = await axios.get(`/api/v1/notes/?job_id=${deleteRowId}`, {});
      if (response.data) {
        let results = response.data.results;
        setCandidateNotes(results);
      }
    } catch (error) {
    }
  };

  const handleCancelNotes = () => {
    setEditorContent(''); // Clear editor content
    setEditIndex(null); // Reset editIndex on cancel
    setEditorVisible(false)
  };
  const onloadvalues = async (data) => {
    setEditorContent(data);
  };

  const handleEditNote = (index) => {
    setEditorVisible(true);
    setEditorContent(candidateNotes[index].content); // Load the note content into the editor
    setEditIndex(index); // Set editIndex to edit the current note
  };

  const handleDeleteNote = async (note) => {
    let id = note
    await axios.delete(`/api/v1/notes/${id}/`)
      .then((resp) => {
        setEditorVisible(false)
        setVisibleViewRight(false)
        setSelectedJobsData([])
      })
      .catch((error) => {

      });
  }

  const [historyFilters, setHistoryFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.DATE_IS },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [history, sethistory] = useState([])


  const getprofilehis = async (deleteRowId) => {

    try {
      const response = await axios.get(`/api/v1/history/?job_id=${deleteRowId}`, {});
      if (response.data) {
        let results = response.data.results;
        sethistory(results);
      }

    } catch (error) {

    }
  };


  const [selectedHistory, setSelectedHistory] = useState([]);

  const [documents, setDocuments] = useState([]);
  const getprofiledoc = async (deleteRowId) => {

    try {
      const response = await axios.get(`/api/v1/documents/?job_id=${deleteRowId}`, {});
      if (response.data) {
        let results = response.data.results;
        setDocuments(results);
      }

    } catch (error) {

    }
  };

  const [selectedScheduleOption, setSelectedScheduleOption] = useState(null);
  const [statusids, setstatusids] = useState(null);
  const handleScheduleChangemore = (event) => {
    const value = event.value; // Extract the selected value properly
    setSelectedScheduleOption(value);
    setSelectedLinkCandidate(value)
    if (event.value && event.value.action) {
      event.value.action(); // Execute the custom action
    }
  };

  const [candilist, setcandilist] = useState([])

  const getlinkcandidates = async () => {

    try {
      const response = await axios.get(`/api/v1/get-all-stages/`, {});
      if (response?.data) {
        const transformedData = response?.data?.results?.map((cond) => ({
          name: cond?.name,
          id: cond?.id,
        }));

        setcandilist(transformedData)
      }

    } catch (error) {

    }
  };
  useEffect(() => {
    // getlinkcandidates()
    getschdule()
  }, []);



const moreoptions1 = useMemo(() => {
  if (isApprovedOpenStatus) {
    return [
      {
        name: 'Submit Job to Candidate',
        action: () => {
          if (!selectedJobsData || selectedJobsData.length === 0) {
            setselectoneemp(true);
          } else {
            onjobselect();
          }
        }
      },
      {
        name: 'Link Candidates',
        candidates: candilist?.map((item) => ({
          name: item?.name,
          action: () => {
            if (!selectedJobsData || selectedJobsData?.length === 0) {
              setselectoneemp(true);
              setChangeStatusAction(false);
            } else {
              seterrlinkjob("")
              setVisibleLinkCandidate(true);
              setSelectedCandidateNames(""); setselectedJobslink([]); setCurrentDateTime(new Date()); setSubject(""); setNotes("")
            }
          }
        }))
      },
      {
        name: 'Match Candidates',
        action: () => {
          if (!selectedJobsData || selectedJobsData.length === 0) {
            setselectoneemp(true);
            setChangeStatusAction(false);
          } else {
            setsmShowmatchcond(true)
          }
        }
      },
      {
        name: 'Change Status',
        action: () => {
          if (!selectedJobsData || selectedJobsData.length === 0) {
            setselectoneemp(true);
            setChangeStatusAction(false);
          } else {
            const jobId = selectedJobsData[0]?.job_id;
            setChangeStatusAction(true);
            setselectoneemp(false);
            setstatusids(jobId);
            getstatusval()
            reset1()
          }
        }
      },
      {
        name: 'Attachments',
        action: () => {
          if (!selectedJobsData || selectedJobsData.length === 0) {
            setselectoneemp(true);
            setChangeStatusAction(false);
          } else {
            const jobId = selectedJobsData[0]?.job_id;
            setIsAttachDocumentVisible(true);
            setstatusids(jobId);
            setDocSubject("")
            setSelectedDocumentType("")
            getdocumentTypes()
          }
        }
      },
      {
        name: 'Delete',
        action: () => {
          if (!selectedJobsData || selectedJobsData.length === 0) {
            setselectoneemp(true);
            setChangeStatusAction(false);
          } else {
            setSmShowdele(true);
          }
        }
      },
       {
         name: 'Assign Recruiters',
         action: async () => {
           if (!selectedJobsData || selectedJobsData.length !== 1) {
             setSelectOnlyOneJob(true);
           } else {
             const jobId = selectedJobsData[0]?.job_id;
             if (recruiterOptions.length === 0) {
               await getRecruiterOptions();
             }
             setAssignRecruitersAction(true);
             getAssignedRecruiters(jobId);
           }
         }
       }
    ];
  } else {
    // Only show Change Status for other statuses
    return [
      {
        name: 'Change Status',
        action: () => {
          if (!selectedJobsData || selectedJobsData.length === 0) {
            setselectoneemp(true);
            setChangeStatusAction(false);
          } else {
            const jobId = selectedJobsData[0]?.job_id;
            setChangeStatusAction(true);
            setselectoneemp(false);
            setstatusids(jobId);
            getstatusval()
            reset1()
          }
        }
      }
    ];
  }
}, [isApprovedOpenStatus, candilist, selectedJobsData]);

  const onjobselect = () => {
    if (!selectedJobsData || selectedJobsData.length === 0) {
      setselectoneemp(true);
      setSelectedJobsS([])
    } else {
      const jobId = selectedJobsData[0]?.job_id;
      setstatusids(jobId);
      setJobDetailsVisible(true);
      gettemplateitems()
      getsignatureitems()
      getsignatureitemsdefalt()
      getAllSmPtvalues()
      getAllSmPtvaluesprimary()

      getcondivalCCANDTO()
      getcondivalCCANDCC()
    }
    if (selectedJobsS > 0) {
      setcondihide(true); // Show buttons
    } else {
      setcondihide(false); // Hide buttons
    }

  }
  const [selectedScheduleval, setSelectedScheduleval] = useState(null);
  const [actScheduleOptions, setactScheduleOptions] = useState([]);
  const [sidebarScheduleOptions, setSidebarScheduleOptions] = useState([]);
  const [selectedSidebarSchedule, setSelectedSidebarSchedule] = useState(null);
  
  const getschdule = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-schedule-type/`, {});
      const transformedData = response?.data?.results?.map((workv) => ({
        name: workv?.schedule_type,
        id: workv?.id,
      }));
      setactScheduleOptions(transformedData);
      setSidebarScheduleOptions(transformedData);
    }
    catch (error) {
    }
  };

  const handleSidebarScheduleChange = (e) => {
    const selected = e.value;
    setSelectedSidebarSchedule(selected);
    
    if (selected?.name?.toLowerCase() === 'call' || selected?.name?.toLowerCase() === 'meeting') {
      setcallingtask(true);
    } else {
      setcallingtask(false);
    }

    if (!selectedJobsData || selectedJobsData.length === 0) {
      setselectoneemp(true);
      setChangeStatusAction(false);
    } else {
      const jobId = selectedJobsData[0]?.job_id;
      SetInterviewpop(true);
      getcontactsdata();
      getcondivalLIST();
      setstatusids(jobId);
      setSubtype(""); setPopTextares(""); setcondidatevalu(""); setPriority("");
      setSelectedJobTitles("");
      setsubjectval("");
      setselectedJobListname([]);
      setPopchecked(false);
      setsubTypeinterview("");
      setstartdateinterview("");
      setsenddateinterview("");
      setsendtimeinterview("");
      setcontactinterview("");
      setcandidateinterview("");
      setsubjectinterview("");
      setpopTextaresinterview("");
      setpriorityinterview("");
      setjobinterview("");
      setstarttimeinterview("");
      setrepeaterr(""); setremindererr(""); setfollowuperr("");
      setRepeat(""); setFollowup("");
      setSelectedCandidateNames("");
      setselectedJobslink([]);
    }

    if (selected?.id) {
      const id = selected?.id;
      getsdropdownsubtype(id);
    }
    if (selected?.name) {
      setIntertype(selected.name);
      setIsTypeDisabled(true);
    }
  };


  const handleScheduleChange = (e) => {

    const selected = e.value;
    setSelectedScheduleval(selected);

    if (e.value && e.value.action) {
      e.value.action(); // Execute the custom action
    }
    if (selected?.name?.toLowerCase() === 'call' || selected?.name?.toLowerCase() === 'meeting') {
      setcallingtask(true);
    } else {
      setcallingtask(false);
    }

    if (!selectedJobsData || selectedJobsData.length === 0) {
      setselectoneemp(true);
      setChangeStatusAction(false);
    } else {
      const jobId = selectedJobsData[0]?.job_id;
      SetInterviewpop(true)
      getcontactsdata()
      getcondivalLIST()
      setstatusids(jobId);
      setSubtype(""); setPopTextares(""); setcondidatevalu(""); setPriority("")
      setSelectedJobTitles("")
      setsubjectval("")
      setselectedJobListname([])
      setPopchecked(false)
      setsubTypeinterview("");
      setstartdateinterview("");
      setsenddateinterview("");
      setsendtimeinterview("");
      setcontactinterview("");
      setcandidateinterview("");
      setsubjectinterview("");
      setpopTextaresinterview("");
      setpriorityinterview("");
      setjobinterview("");
      setstarttimeinterview("")
      setrepeaterr(""); setremindererr(""); setfollowuperr("");
      setRepeat(""); setFollowup("");
      setSelectedCandidateNames("")
      setselectedJobslink([])

    }

    if (selected?.id) {
      const id = selected?.id
      getsdropdownsubtype(id)
    }
    if (selected?.name) {
      setIntertype(selected.name);
      setIsTypeDisabled(true);
    }
  };


  // interview popup starts
  const [interviewpop, SetInterviewpop] = useState(false)
  const [filteredcaondidates, setfilteredcaondidates] = useState([])

  const [selectedJobsS, setSelectedJobsS] = useState([])

  const [jobDetailsVisible, setJobDetailsVisible] = useState(false)
  const [condihide, setcondihide] = useState(false)
  const [intertype, setIntertype] = useState('');
  const [isTypeDisabled, setIsTypeDisabled] = useState(false);

  const [subTypeinterview, setsubTypeinterview] = useState("");
  const [startdateinterview, setstartdateinterview] = useState("");
  const [starttimeinterview, setstarttimeinterview] = useState("");
  const [senddateinterview, setsenddateinterview] = useState("");
  const [sendtimeinterview, setsendtimeinterview] = useState("");

  const [jobinterview, setjobinterview] = useState("");
  const [contactinterview, setcontactinterview] = useState("");
  const [candidateinterview, setcandidateinterview] = useState("");
  const [subjectinterview, setsubjectinterview] = useState("");
  const [popTextaresinterview, setpopTextaresinterview] = useState("");
  const [followuperr, setfollowuperr] = useState("");
  const [repeaterr, setrepeaterr] = useState("");
  const [remindererr, setremindererr] = useState("");
  const [priorityinterview, setpriorityinterview] = useState("");

  const getMinEndDatecon = () => {
    if (!startdate) return null;
    const minDate = new Date(startdate);
    minDate.setDate(minDate.getDate() + 1);
    return minDate;
  };


  const [callingtask, setcallingtask] = useState(false)

  useEffect(() => {
    const now = new Date();

    const startDate = new Date(); // today
    const endDate = new Date(); // today

    const startTime = new Date(); // current time
    const endTime = new Date(now.getTime() + 30 * 60000); // 30 minutes later

    setStartdate(startDate);
    setenddate(endDate);
    setStarttime(startTime);
    setendtime(endTime);
  }, []);

  const resetDefaultDateTime = () => {
    const now = new Date();
    const startDate = new Date(); // today
    const endDate = new Date(); // today
    const startTime = new Date(); // now
    const endTime = new Date(now.getTime() + 30 * 60000); // 30 minutes later

    setStartdate(startDate);
    setenddate(endDate);
    setStarttime(startTime);
    setendtime(endTime);

    setstartdateinterview('');
    setsenddateinterview('');
    setstarttimeinterview('');
    setsendtimeinterview('');
  };

  const onsubmitSedules = async () => {
    const startdateval = moment(startdate).format("YYYY-MM-DD");
    const enddateval = moment(enddate).format("YYYY-MM-DD");
    const starttimeval = moment(starttime, "HH:mm:ss").format("HH:mm:ss");
    const endtimeval = moment(endtime, "HH:mm:ss").format("HH:mm:ss");
    let hasError = false;

    // if (!subtype) {
    //   setsubTypeinterview("Enter SubType");
    //   hasError = true;
    // }

    // if (!startdate) {
    //   setstartdateinterview("Enter Start Date ");
    //   hasError = true;
    // }
    // if (!starttime) {
    //   setstarttimeinterview("Enter Start time ");
    //   hasError = true;
    // }

    // if (!enddate) {
    //   setsenddateinterview("Enter End Date");
    //   hasError = true;
    // }
    // if (!endtime) {
    //   setsendtimeinterview("Enter End time");
    //   hasError = true;
    // }

    // if (!selectedJobTitles || selectedJobTitles.length === 0) {
    //   setjobinterview("Enter Jobs");
    //   hasError = true;
    // }

    // if (!prioritycontact || prioritycontact.length === 0) {
    //   setcontactinterview("Enter Contact");
    //   hasError = true;
    // }

    // if (!selectedCandidateNames || selectedCandidateNames.length === 0) {
    //   setcandidateinterview("Enter Candidate");
    //   hasError = true;
    // }

    // if (!subjectval || subjectval.trim() === "") {
    //   setsubjectinterview("Enter Subject");
    //   hasError = true;
    // }

    // if (!popTextares || popTextares.trim() === "") {
    //   setpopTextaresinterview("Enter Description");
    //   hasError = true;
    // }
    // if (!followup || followup.trim() === "") {
    //   setfollowuperr("Enter followup");
    //   hasError = true;
    // }
    // if (!repeat || repeat.trim() === "") {
    //   setrepeaterr("Enter repeat");
    //   hasError = true;
    // }
    // if (!reminder || reminder.trim() === "") {
    //   setremindererr("Enter reminder");
    //   hasError = true;
    // }

    // if (!priority) {
    //   setpriorityinterview("Enter Priority");
    //   hasError = true;
    // }

    if (hasError) return;

    const payload = {
      // job_id: statusids,
      event_type: intertype,
      event_sub_type: subtype.name,
      start_date: startdateval,
      start_time: starttimeval,
      end_date: enddateval,
      end_time: endtimeval,
      status: subtypeget,
      contact_id: prioritycontact,
      candidate_id: candidateidsslect,
      job_id: jobidsslect,
      // jobs: selectedJobsData.map(job => job.value),
      subject: subjectval,
      description: popTextares,
      event_priority: priority,
      completed: popchecked,
      private: popchecked2,
      auto_followup: followup,
      repeat: repeat,
      reminder: reminder,
      // reminder: reminder,
      user_ids: uniqueUserId,
      // user_ids: userid  ,

    };

    try {
      const response = await axios.post('/api/v1/events/', payload);
      SetInterviewpop(false); // Close the dialog on success
      setVisibleViewRight(false); // Close the sidebar
      setSelectedJobsData([])
      setSelectedScheduleval("");
      setSelectedJob(null);
      setselectedJobListname([]);
      setjobidsslect([]);
      setSelectedJobForStatus(null);
      if (response.status === 201) {
        triggerAlert("success", "Schedule Created", "Scheduled Successfully.");
        // Refresh the schedule list after creating
        if (visibleViewRight && selectedJobsData?.[0]?.job_id) {
          getsetactivities(selectedJobsData[0].job_id);
        }
      }
      // setsuccessMatch(true)
      // setsuccess("Schedule ")
      // window.location.reload();
    } catch (error) {
      SetInterviewpop(false);
      setVisibleViewRight(false); // Close the sidebar on error too
      triggerAlert("error", "Error", error?.response?.data?.error || "An error occurred while creating the schedule.");
    }
  };

  const [subtype, setSubtype] = useState(null)
  const [subtypeget, setsubtypeget] = useState(null)
  const [startdate, setStartdate] = useState(null)
  const [starttime, setStarttime] = useState(null)
  const [endtime, setendtime] = useState(null)
  const [enddate, setenddate] = useState(null)
  const [popTextares, setPopTextares] = useState("")
  const [priority, setPriority] = useState(null)
  const [prioritycontact, setprioritycontact] = useState([])
  const [condidatevalu, setcondidatevalu] = useState(null)
  const condidatelist = (e) => {
    const selected = e.value || [];
    setprioritycontact(selected);
  };
  const priorityValue = [
    { name: 'Low', value: 'low' },
    { name: 'Medium', value: 'medium' },
    { name: 'High', value: 'high' },
  ];


  const [popchecked3, setPopchecked3] = useState(false)
  const handlePopupCheckbox3 = e => {
    setPopchecked3(e.checked)
  }

  const [typeInterviewcondirec, settypeInterviewcondirec] = useState([])
  const [subjectval, setsubjectval] = useState(null)
  const [popchecked2, setPopchecked2] = useState(false)
  const handlePopupCheckbox2 = e => {
    setPopchecked2(e.checked)
  }
  const [typeInterviewcontact, settypeInterviewcontact] = useState([])

  // const getcontactsdata = async () => {
  //   try {
  //     const response = await axios.get(`/api/v1/get-all-hiring-managers/`, {});
  //     const transformedData = response?.data?.results?.map((workv) => ({
  //       name: `${workv?.first_name} ${workv?.middle_name || ''} ${workv?.last_name || ''}`.trim(),
  //       id: workv?.id,
  //     })) || [];
  //     settypeInterviewcontact(transformedData);

  //   }
  //   catch (error) {
  //     settypeInterviewcontact([]);
  //   }
  // };

  const getcontactsdata = async () => {
  try {
    const response = await axios.get(`/api/v1/get-all-hiring-managers/`, {});
    const transformedData = response?.data?.results?.map((workv) => ({
      name: workv?.first_name || "", // Only first_name
      id: workv?.id,
    })) || [];
    settypeInterviewcontact(transformedData);
  }
  catch (error) {
    settypeInterviewcontact([]);
  }
};

  const [typeInterviewcondi, settypeInterviewcondi] = useState([]);
  const [lazyParamssub1, setLazyParamssub1] = useState({ page: 0, rows: 10 });
  const [totalRecordssub1, setTotalRecordssub1] = useState(0);

  const [lazyParamssubTO, setlazyParamssubTO] = useState({ page: 0, rows: 10 });
  const [totalRecordsTO, setTotalRecordsTO] = useState(0);

  const [lazyParamssubCC, setlazyParamssubCC] = useState({ page: 0, rows: 10 });
  const [totalRecordsCC, setTotalRecordsCC] = useState(0);


  const onPageChangeTO = (event) => {
    setlazyParamssubTO({ page: event.page, rows: event.rows });
  };
  const onPageChangeCC = (event) => {
    setlazyParamssubCC({ page: event.page, rows: event.rows });
  };

  const getcondival = async (page, size) => {
    try {
      const response = await axios.get(`/api/v1/candidates/?page=${lazyParamssub1.page + 1}&size=${lazyParamssub1.rows}&fields=candidate_id,first_name,middle_name,last_name,current_company&status=Active`, {
      });;
      const transformedData = response?.data?.results?.map((cond) => ({
        name: cond?.first_name,
        id: cond?.candidate_id,
      }));
      // settypeInterviewcondi(transformedData);
      setfilteredcaondidates(response?.data?.results)
      setTotalRecordssub1(response?.data?.count || 0)

    } catch (error) {
    }
  };
  const getcondivalLIST = async (page, size) => {
    try {
      const response = await axios.get(`/api/v1/get-all-candidates/`, {
      });;
      const transformedData = response?.data?.results?.map((cond) => ({
        name: cond?.first_name,
        id: cond?.candidate_id,
      }));
      settypeInterviewcondi(transformedData);


    } catch (error) {
    }
  };
  const getcondivalCCANDTO = async (page, size) => {
    try {
      const response = await axios.get(`/api/v1/contacts/?page=${lazyParamssubTO.page + 1}&size=${lazyParamssubTO.rows}&status=Active`, {});
      settoEmail(response.data.results)
      setTotalRecordsTO(response.data.count)
    } catch (error) {
    }
  };
  const getcondivalCCANDCC = async (page, size) => {
    try {
      const response = await axios.get(`/api/v1/contacts/?page=${lazyParamssubCC.page + 1}&size=${lazyParamssubCC.rows}&status=Active`, {});
      setccEmail(response.data.results)
      setTotalRecordsCC(response.data.count)
    } catch (error) {
    }
  };

  const getAllSmPtvalues = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-smtp-accounts/`);

      // Transform data to match the expected format for the Dropdown
      const transformedData = response?.data?.results?.map((item) => ({
        email: item?.from_email,  // use `email` as expected by `optionLabel`
        id: item?.smtp_id
      }));
      setfromEmail(transformedData); // set to state used in Dropdown
    } catch (error) {
    }
  };

  const getAllSmPtvaluesprimary = async () => {
    try {
      const response = await axios.get(`/api/v1/smtp-accounts/by-primary/?is_primary=true`);

      // API returns a single object
      const primaryData = response?.data;

      if (primaryData[0] && primaryData[0]?.from_email) {
        const temp = {
          email: primaryData[0]?.from_email,
          id: primaryData[0]?.smtp_id
        };
        setFrominputemail(temp);
        setfromemailinp([temp?.email]);
      }
    } catch (error) {
      console.error("Error fetching primary SMTP account", error);
    }
  };


  // const getAllSmPtvalues = async () => {
  //   try {
  //     const response = await axios.get(`/api/v1/smtp-accounts/`, {})

  //     const transformeemail = response.data.results.map((cond) => ({
  //       email: cond.from_email,
  //       id: cond.smtp_id,
  //     }));


  //   } catch (error) { }
  // }

  const onPageChangesub1 = (event) => {
    setLazyParamssub1({ page: event.page, rows: event.rows });
  };


  useEffect(() => {
    getcondival();
  }, [lazyParamssub1]);
  useEffect(() => {
    getcondivalCCANDTO();
  }, [lazyParamssubTO]);
  useEffect(() => {
    getcondivalCCANDCC();
  }, [lazyParamssubCC]);


  const [userid, setUserid] = useState([])
  const customChip = item => {
    return (
      <div>
        <span>{item} - (active)</span>
        <i className="pi pi-user-plus"></i>
      </div>
    )
  }
  const [popchecked, setPopchecked] = useState(false);
  const handlePopupCheckbox = e => {
    setPopchecked(e.checked)
  }
  // interview popup ends
  const [text, setText] = useState("");

  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <button className="ql-bold" aria-label="Bold"></button>
        <button className="ql-italic" aria-label="Italic"></button>
        <button className="ql-underline" aria-label="Underline"></button>
      </span>
    );
  };

  const header = renderHeader();
  const [hiringManager, setHiringManager] = useState(null);
  const [companies, setcompanies] = useState([])
  const getCompanydata = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-companies/`, {});
      const transformedData = response?.data?.results?.map((company) => ({
        name: company?.company_name,
        id: company?.company_id,
      }));
      setcompanies(transformedData);
    } catch (error) {

    }
  };
  const [jobworkspace, setjobworkspace] = useState(null);
  const [jobworkspaceview, setjobworkspaceview] = useState([]);
  const [primarySkillsget, setprimarySkillsget] = useState([]);

  const getworkspace = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-workplace-type/`, {
      });
      const transformedData = response?.data?.results?.map((workv) => ({
        name: workv?.workplace_type,
        id: workv?.id,
      }));
      setjobworkspaceview(transformedData);
    }
    catch (error) {

    }
  };
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);

  const formatCategories = (categories) => {
    return categories?.map((cat) => ({
      key: String(cat?.category_id),
      label: cat?.name,
      children: cat?.subcategories ? formatCategories(cat?.subcategories) : [],
    }));
  };

  const [selectedNodeKeycat, setSelectedNodeKeycat] = useState(null);
  const [selectedgroupKey, setselectedgroupKey] = useState(null);
  const [categoriesitem, setcategoriesitem] = useState([])
  const [groupitem, setgroupitem] = useState([])

  const handleCategorySelect = (category) => {
    setSelectedNodeKeycat(category);
  };
  const getcategoriesitem = async () => {

    try {
      const response = await axios.get(`/api/v1/get-all-categories/`, {});
      if (response?.data && response?.data?.results) {
        const formatted = formatCategories(response?.data?.results);
        setcategoriesitem(formatted);
        // const transformedData = response.data.results.map((Categories) => ({
        //   name: Categories.name,
        //   id: Categories.category_id,
        // }));
        // setcategoriesitem(transformedData);
      }
    } catch (error) {
    }
  };


  const formatGroups = (groups) => {
    return groups?.map((grp) => ({
      key: String(grp?.group_id),
      label: grp?.name,
      children: grp?.subgroups ? formatGroups(grp?.subgroups) : [],
    }));
  };


  const getgroupsitemval = async (category_ids) => {

    try {
      const response = await axios.get(`/api/v1/get-all-groups/`, {});
      if (response.data && response.data.results) {
        const formattedGroups = formatGroups(response.data.results);
        setgroupitem(formattedGroups);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (jobSidebarVisible) {
      getgroupsitemval();
      getcategoriesitem()
      getworkspace()
      getskills()
      getcontactsdata()
      getCompanydata()
      getcity()
      getHiringManagers()
      getRecruiterManagers()
      getRecruiterOptions()
    }
  }, [jobSidebarVisible]);

  // Add state for stage options
  const [stageOptions, setStageOptions] = useState([]);

  // Candidate form API calls
  useEffect(() => {
    if (candidateSidebarVisible) {
      getPrimarySkills();
      getCategories();
      getGroups();
      getCountries();
      getAddressLabels();
      fetchResumeSource();
      fetchCandidateStages();
      
      // Auto-populate stage field based on active pipeline tab when opening candidate form
      const currentJobId = selectedJobsData.length > 0 ? selectedJobsData[0]?.job_id : null;
      let stageToSet = null;
      
      if (currentJobId && jobActivePipelineTabs[currentJobId]) {
        // Use the active tab for the specific job
        stageToSet = jobActivePipelineTabs[currentJobId];
      } else if (activePipelineTab) {
        // Use the global active pipeline tab
        stageToSet = activePipelineTab;
      } else if (stages?.length > 0) {
        // Fallback to first stage
        stageToSet = stages[0]?.name || stages[0];
      }
      
      if (stageToSet) {
        setFormData(prev => ({
          ...prev,
          stage: stageToSet
        }));
      }
    }
  }, [candidateSidebarVisible, activePipelineTab, stages, jobActivePipelineTabs, selectedJobsData]);

  // Fetch stages specifically for candidate form
  const fetchCandidateStages = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-stages/");
      if (response?.data?.results) {
        const stageOptions = response.data.results
          .sort((a, b) => a.order - b.order)
          .map((stage) => ({
            label: stage.name,
            value: stage.name,
          }));
        setStageOptions(stageOptions);
      }
    } catch (error) {
      console.error("Failed to fetch stages for candidate form", error);
    }
  };

  // Candidate form API functions
  const getPrimarySkills = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-skills/`);
      const transformedData = response?.data?.results?.map((skill) => ({
        name: skill?.skill_name,
        id: skill?.skill_id,
      }));
      setCandidatePrimarySkillsget(transformedData);
    } catch (error) {
      console.error("Failed to fetch primary skills", error);
    }
  };

  const getCategories = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`);
      if (response?.data && response?.data?.results) {
        const transformedData = transformCategoriesToTree(response.data.results);
        setCategoryNodes(transformedData);
      }
    } catch (error) {
      console.error("Failed to fetch categories", error);
    }
  };

  const getGroups = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`);
      if (response?.data && response?.data?.results) {
        const transformedData = transformGroupsToTree(response.data.results);
        setGroupNodes(transformedData);
      }
    } catch (error) {
      console.error("Failed to fetch groups", error);
    }
  };

  const getCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`);
      const transformedData = response?.data?.results?.map((country) => ({
        name: country?.name,
        country_id: country?.country_id,
      }));
      setCountries(transformedData);
    } catch (error) {
      console.error("Failed to fetch countries", error);
    }
  };

  // Address dropdown API calls
  const fetchStates = async (countryId) => {
    try {
      const response = await axios.get(`/api/v1/get-all-states/?country_id=${countryId}`);
      const transformedData = response?.data?.results?.map((state) => ({
        name: state?.name,
        state_id: state?.state_id,
      }));
      setStates(transformedData);
    } catch (error) {
      console.error("Failed to fetch states", error);
      setStates([]);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const response = await axios.get(`/api/v1/get-all-cities/?state_id=${stateId}`);
      const transformedData = response?.data?.results?.map((city) => ({
        name: city?.name,
        city_id: city?.city_id,
      }));
      setCities(transformedData);
    } catch (error) {
      console.error("Failed to fetch cities", error);
      setCities([]);
    }
  };

  const getAddressLabels = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-address-label/`);
      if (response?.data?.results) {
        setAddressLabels(
          response.data.results.map(label => ({
            label: label.address_label,
            value: label.id,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch address labels", error);
    }
  };

  const fetchResumeSource = async () => {
    try {
      const response = await axios.get("/api/v1/resume-source/");
      if (response?.data?.results) {
        setResumeSourceOptions(
          response.data.results.map(source => ({
            label: source.resume_source,
            value: source.source_id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching resume sources:", error);
    }
  };

  // Transform categories to tree structure
  const transformCategoriesToTree = (categories) => {
    return categories?.map((category) => ({
      key: category.category_id,
      label: category.name, // Use 'name' field from API response
      data: category,
      children: category.subcategories ? transformCategoriesToTree(category.subcategories) : []
    }));
  };

  // Transform groups to tree structure  
  const transformGroupsToTree = (groups) => {
    return groups?.map((group) => ({
      key: group.group_id,
      label: group.name, // Use 'name' field from API response
      data: group,
      children: group.subgroups ? transformGroupsToTree(group.subgroups) : []
    }));
  };

  // Candidate form helper functions
  const handleTempAddressChange = (field, value) => {
    setTempAddressData(prev => ({
      ...prev,
      [field]: value
    }));
    if (formErrors[field]) {
      setFormErrors(prev => ({
        ...prev,
        [field]: ""
      }));
    }
  };

  // Email duplicate check handler - copied from AllActiveemp
  const handleCandidateEmailBlur = async (e) => {
    const email = e.target.value?.trim();
    setIsDuplicateEmail(false);
    setDuplicateCandidateId(null);
    setEmailError(""); // Clear previous email error

    if (!email) return;

    try {
      const response = await axios.post(
        "/api/v1/candidates/check-email/",
        { email }
      );
      if (response.data.duplicate) {
        setIsDuplicateEmail(true);
        setDuplicateCandidateId(response.data.candidate_id);
        setEmailError("Candidate with this email already exists.");
      } else {
        setIsDuplicateEmail(false);
        setDuplicateCandidateId(null);
        setEmailError("");
      }
    } catch (err) {
      setIsDuplicateEmail(false);
      setDuplicateCandidateId(null);
      setEmailError("Failed to check duplicate email.");
    }
  };

  const handleCandidateInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear validation error when user selects a value for mandatory fields
    if ((field === 'source' || field === 'stage') && value) {
      setFormErrors(prev => ({
        ...prev,
        [field]: ""
      }));
    }
  };

  const validateCandidateField = (name, value) => {
    switch (name) {
      case "street_address":
        return candidatePatterns.address.test(value) ? "" : "Invalid address format";
      case "pincode":
        return candidatePatterns.pincode.test(value) ? "" : "Invalid postal code format";
      case "source":
        return value ? "" : "Source is required";
      case "stage":
        return value ? "" : "Stage is required";
      default:
        return "";
    }
  };

  const handleAddressDialogOk = () => {
    const errors = {};
    
    // Validate required fields
    if (!tempAddressData.street_address) {
      errors.street_address = "Street address is required";
    }
    if (!tempAddressData.country) {
      errors.country = "Country is required";
    }
    if (!tempAddressData.state) {
      errors.state = "State is required";
    }
    if (!tempAddressData.city) {
      errors.city = "City is required";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    // Update main form data with temp data
    const fullAddress = `${tempAddressData.street_address}${tempAddressData.street_address_line_2 ? ', ' + tempAddressData.street_address_line_2 : ''}, ${tempAddressData.city?.name}, ${tempAddressData.state?.name}, ${tempAddressData.country?.name}${tempAddressData.pincode ? ', ' + tempAddressData.pincode : ''}`;
    
    setFormData(prev => ({
      ...prev,
      ...tempAddressData,
      address: fullAddress
    }));
    
    setVisible(false);
    setFormErrors({});
  };

  const handleAddressDialogCancel = () => {
    setTempAddressData({
      street_address: formData.street_address,
      street_address_line_2: formData.street_address_line_2,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      pincode: formData.pincode,
      label: formData.label,
    });
    setVisible(false);
    setFormErrors({});
  };

  // File handling for candidate resume - match AllActiveemp exactly
  const handleCandidateFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // File size validation (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      setResumeError("File size must be less than 5MB");
      event.target.value = "";
      return;
    }

    // File type validation - match AllActiveemp exactly
    const allowedTypes = [
      "application/pdf",
      "application/msword", 
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/png",
    ];
    
    if (!allowedTypes.includes(file.type)) {
      setResumeError("Invalid file type. Please upload PDF, DOC, DOCX, JPEG, or PNG files only.");
      event.target.value = "";
      return;
    }

    // Prevent folder uploads
    if (file.size === 0 || !file.type) {
      setResumeError("Folders are not allowed. Please upload a valid file.");
      event.target.value = "";
      return;
    }

    try {
      const base64 = await getCandidateBase64(file);
      // Match AllActiveemp structure exactly
      setResumeFileData({
        name: file.name,
        data: base64.split(",")[1], // Remove data:mime;base64, prefix like in AllActiveemp
        type: file.type,
        size: file.size
      });
      setResumeError("");
      setCandidateError(""); // Clear general error
    } catch (error) {
      setResumeError("Failed to process file");
      setCandidateError("Failed to process file");
      event.target.value = "";
    }
  };

  const getCandidateBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleCanacelCreateCandidate = () => {
    dispatch(setCandidateSidebarVisible(false));
    resetCandidateSidebarForm();
  };

  // Candidate form submission
  const onSubmitCandidate = async (data) => {
    // Check for duplicate email like in AllActiveemp
    if (isDuplicateEmail) {
      setCandidateError("Candidate with this email already exists.");
      setTimeout(() => {
        if (emailInputRef.current && typeof emailInputRef.current.scrollIntoView === "function") {
          emailInputRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          emailInputRef.current.focus();
        }
      }, 200);
      return;
    }
    
    if (candidateError) {
      triggerAlert("error", "Error", "Invalid resume file format. Only PDF and Word files are allowed.");
      return;
    }

    // Validate mandatory fields
    const validationErrors = {};
    
    if (!formData.source) {
      validationErrors.source = "Source is required";
    }
    
    if (!formData.stage) {
      validationErrors.stage = "Stage is required";
    }
    
    if (Object.keys(validationErrors).length > 0) {
      setFormErrors(validationErrors);
      return;
    }

    // Check if a job is selected
    const selectedJobId = selectedJobsData.length > 0 ? selectedJobsData[0]?.job_id : null;
    if (!selectedJobId) {
      triggerAlert("error", "Error", "Please select a job first before creating a candidate.");
      return;
    }

    setCandidateLoading(true);
    setDisable(true);
    
    const req = {};

    // Basic candidate information - match AllActiveemp exactly
    if (data.lastname) {
      req.last_name = data.lastname;
    }
    if (data.middle_name) {
      req.last_name = data.middle_name;
    }
    if (data.jobtitle) {
      req.job_title = data.jobtitle;
    }
    if (data.designation) {
      req.designation = data.designation;
    }
    if (data.phone) {
      req.mobile_phone = data.phone;
    }
    if (selectedCategoryNode) {
      req.categories = selectedCategoryNode;
    }
    if (selectedGroupNode) {
      req.groups = selectedGroupNode;
    }
    if (data.Company) {
      req.current_company = data.Company;
    }
    if (data.Availability) {
      req.availability_date = data.Availability;
    }
    if (primarySkillsview) {
      req.primary_skills = primarySkillsview;
    }
    if (selectedCity) {
      req.city = selectedCity;
    }
    req.first_name = data?.firstname;
    req.email = data.personal_email;
    req.relocation = data.relocation ? "true" : "false";
    req.private = data.private ? "true" : "false";
    
    // Resume handling - match AllActiveemp exactly
    if (resumefileData) {
      req.resume = {
        file_name: resumefileData.name,
        file_data: resumefileData.data,
      };
    }

    // Address fields - match AllActiveemp exactly
    req.street_address = formData.street_address || null;
    req.street_address_line_2 = formData.street_address_line_2 || null;
    req.country = formData.country?.id || null;
    req.state = formData.state?.id || null;
    req.city = formData.city?.id || null;
    req.pincode = formData.pincode || null;
    req.label = formData.label || null;
    req.address = formData.address || null;
    req.address_label = formData.label || null;
    
    // Source field
    req.source = formData.source || null;
    
    // Stage field - use the value from formData (already properly formatted)
    req.stage = formData.stage || null;

    try {
      // Call the new API that creates candidate and links to job
      const response = await axios.post(`/api/v1/create-and-link/?job_id=${selectedJobId}`, req, {});
      
      // Handle success response with candidate_id
      const candidateId = response?.data?.candidate_id;
      const message = response?.data?.message || "Candidate created and linked successfully!";
      
      triggerAlert("success", "Success", message);
      fetchJobPipelineData(selectedJobId); // Refresh job pipeline if needed
      resetCandidateSidebarForm();
      dispatch(setCandidateSidebarVisible(false));
      setVisibleViewRight(false); // Close the view sidebar as well
      reset();
      setprimarySkillsview([]);
      setSelectedCategoryNode(null);
      setSelectedGroupNode(null);
      setSelectedCity(null);
      setResumeFileData(null); // Clear resume file data
      setCandidateError(""); // Clear error message
      setFormData(prev => ({ ...prev, ...initialAddressState }));
      setTempAddressData({ ...initialAddressState });
      setEmailError("");
      setResumeError("");
      setIsDuplicateEmail(false);
      setDuplicateCandidateId(null);
      
      // Refresh the jobs data to reflect any changes
      const page = Math.floor(first / rows) + 1;
      await getArchedjob(page, rows, type, param, selectedHeaderJobStatus);
      
    } catch (error) {
      console.error(error);
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || "Something went wrong";
      triggerAlert("error", "Error", errorMessage);
    } finally {
      setCandidateLoading(false);
      setDisable(false);
    }
  };

  // Reset candidate sidebar form
  const resetCandidateSidebarForm = () => {
    reset();
    setFormData(initialAddressState);
    setTempAddressData(initialAddressState);
    setprimarySkillsview([]);
    setSelectedCategoryNode(null);
    setSelectedGroupNode(null);
    setResumeFileData([]);
    setCandidateError("");
    setResumeError("");
    setIsDuplicateEmail(false);
    setDuplicateCandidateId(null);
    setEmailError("");
    setFormErrors({});
    setCandidateUniqueUserId("");
    
    // Clear file input
    const fileInput = document.getElementById("MyPro_UploadedProfilePhoto_Modal_FilesInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };



  const getskills = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-skills/`, {
      });
      const transformedData = response?.data?.results?.map((workv) => ({
        name: workv?.skill_name,
        id: workv?.skill_id,
      }));
      setprimarySkillsget(transformedData);
    }
    catch (error) {

    }
  };
  const [typeInterview, settypeInterview] = useState([])
  const [typeStatus, settypeStatus] = useState([])
  const getsdropdownsubtype = async (id) => {
    try {
      const response = await axios.get(`/api/v1/get-all-schedule-sub-type/?schedule_id=${id}`, {
      });
      const transformedData = response?.data?.results?.map((workv) => ({
        name: workv?.schedule_subtype,
        id: workv?.id,
      }));
      settypeInterview(transformedData);
    }
    catch (error) {
    }
  };
  const getstatusval = async () => {
    try {

      const response = await axios.get(`/api/v1/get-all-Job-status/`, {
      });
      const transformedData = response?.data?.results?.map((workv) => ({
        name: workv?.job_status,
        id: workv?.id,
      }));
      let results = response?.data?.results;
      setJobStatusOptions(response?.data?.results);
      setsuccess("Status Changed ")
      // settypeStatus(transformedData);

    }
    catch (error) {
    }
  };



  const [visibleLinkCandidate, setVisibleLinkCandidate] = useState(false);
  const [candidateDetailsVisible, setCandidateDetailsVisible] = useState(false);
  const [filteredCandidatescond, setfilteredCandidatescond] = useState([]);
  const [joblinkcon, setjoblinkcon] = useState([])
  const jobslist = (e) => {
    const selected = e.value || [];
    setjoblinkcon(selected);

  };

  const handleSelectionChangejoblink = (e) => {
    const selectedEmails = e?.value?.map((cond) => `${cond?.first_name || ''} ${cond?.middle_name || ''} ${cond?.last_name || ''}`.trim());
    const selectedid = e?.value?.map((cond) => cond?.candidate_id);
    setselectedJobslink(e?.value);
    setSelectedCandidateNames(selectedEmails);
    setcandidateidsslect(selectedid)
    seterrorcondidate("")
    seterrlinkjob("")

    setcandidateinterview("")

  };
  const handleSavelink = () => {
    setCandidateDetailsVisible(false)
  };

  const handleRefreshlink = () => {
    setselectedJobslink([]);
    setSelectedCandidateNames("")
  };
  const handleRefreshlinkjobs = () => {
    setselectedJobListname([]);
    setSelectedJobTitles([])
    setSearchText1("")
  };




  const fullNameTemplate = (rowData) => {
    return `${rowData?.first_name || ''} ${rowData?.middle_name || ''} ${rowData?.last_name || ''}`.trim();
  };
  const [errorcondidate, seterrorcondidate] = useState("")
  const [errlinkjob, seterrlinkjob] = useState("")
  const [selectedJobslink, setselectedJobslink] = useState([]);
  const [selectedLinkCandidate, setSelectedLinkCandidate] = useState(null);
  const [successMatch, setsuccessMatch] = useState(false);
  const [success, setsuccess] = useState();


const onSubmitlinkcond = async (data) => {
  const req = {
    candidate: selectedJobslink?.map(candidate => ({
      candidate: candidate?.candidate_id,
      first_name: candidate?.first_name,
      middle_name: candidate?.middle_name,
      last_name: candidate?.last_name,
      designation: candidate?.designation,
      current_company: candidate?.current_company,
      candidate_email: candidate?.email
    })),
    status: "Active",
    notes: notes,
    subject: subject,
    user_ids: uniqueUserId,
    applied_date: currentDateTime,
    stage: selectedLinkCandidate ? selectedLinkCandidate.name : ''
  };

  try {
    const response = await axios.post(`/api/v1/candidate-job-links/?job_id=${jobidsslect}`, req);
    setVisibleLinkCandidate(false);
    setSelectedJobsData([]);
    setSelectedScheduleOption("");
    
    if (response.status === 201) {
      triggerAlert("success", "Link Candidates", response?.data?.message || "Candidates linked successfully");
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      triggerAlert("error", "Link Candidates", error.response.data.message);
    } else if (error?.response?.data?.error) {
      seterrlinkjob(error.response.data.error);
    }
  }
};


  const [currentDateTime, setCurrentDateTime] = useState(null);
  const calendarRef = useRef(null);

  const handleChange = (e) => {
    setCurrentDateTime(e.value); // Update state
  };

  const handleSelect = () => {
    if (calendarRef.current) {
      calendarRef.current.hide(); // Auto-close popup
    }
  };
  const [subject, setSubject] = useState("");
  const [notes, setNotes] = useState("");
  const [selectedCandidateNames, setSelectedCandidateNames] = useState('');

  const handleIconClick = () => {
    setCandidateDetailsVisible(true);
  };


  const [isAttachDocumentVisible, setIsAttachDocumentVisible] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);
  const [documentTypes, setdocumentTypes] = useState([])
  const [fileData, setFileData] = useState([]);
  const [error, setError] = useState("");


  const getdocumentTypes = async () => {

    try {
      const response = await axios.get(`/api/v1/get-all-document-type/`, {

      });
      if (response?.data) {

        const transformedData = response?.data?.results?.map((dept) => ({
          name: dept?.value,
          id: dept?.id,
        }));
        setdocumentTypes(transformedData);
        setAllDocumentTypes(transformedData);
        setsuccess("Attachment Added ")
      }
    } catch (error) {

    }
  };


  const getBase64attach = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(',')[1]; // remove the data:...;base64,
        resolve({
          file_name: file.name,
          // type: file.type,
          file_data: base64String
        });
      };
      reader.onerror = (error) => reject(error);
    });
  };
  const allowedTypes = [
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
  ];
  const maxSize = 2 * 1024 * 1024; // 10MB
  const handleFileChange1 = async (event) => {
    setError("")
    const files = Array.from(event.files || []);

    if (files.length === 0) {
      setError("Please select at least one file.");
      fileUploadRef.current?.clear();
      setfileDataattach([]);
      return;
    }

    const validFiles = [];

    for (let file of files) {
      if (!allowedTypes.includes(file.type)) {
        setError(`Invalid file type: ${file.name}. Only PDF and Word documents are allowed.`);
        fileUploadRef.current?.clear();        // Clear input UI

        return;
      }

      if (file.size > maxSize) {
        setError(`File too large: ${file.name}. Max allowed size is 2MB.`);
        fileUploadRef.current?.clear();        // Clear input UI

        return;
      }

      validFiles.push(file);
    }

    try {
      const base64Files = await Promise.all(validFiles?.map(file => getBase64attach(file)));
      setfileDataattach(base64Files);
    } catch (error) {
      setError("Something went wrong while processing the files.");
      fileUploadRef.current?.clear();
      setfileDataattach([]);
    }
  };

  const handleFileChange = async (event) => {
    const file = event.files; // PrimeReact gives files in event.files
    // if (!file) return;


    // Validate file type
    // const allowedTypes = ["application/pdf"];
    // if (!allowedTypes.includes(file.type)) {
    //   setError("Only PDF files are allowed.");
    //   return;
    // }

    // Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      setError("File size should not exceed 10MB.");
      return;
    }
    setError(""); // Clear previous error
    try {
      let temparray = []
      file?.map((item, i) => {
        let base64 = getBase64attach(item);
        let obje = {
          base64: base64,
          name: item.name
        }
        temparray.push(obje)
      })
      setfileDataattach([...temparray]);
    } catch (error) {
      setError("Error while converting file to base64.");
    }
  };

const [errorDocumentType, setErrorDocumentType] = useState("");
const [errorDocSubject, setErrorDocSubject] = useState("");
const [errorFile, setErrorFile] = useState("");
  const onSubmitAttachment = async () => {
    let hasError = false;

  if (!selectedDocumentType) {
    setErrorDocumentType("Please select document type.");
    hasError = true;
  } else {
    setErrorDocumentType("");
  }

  if (!docSubject) {
    setErrorDocSubject("Please enter subject.");
    hasError = true;
  } else {
    setErrorDocSubject("");
  }

  if (!fileDataattach || fileDataattach.length === 0) {
    setErrorFile("Please upload at least one file.");
    hasError = true;
  } else {
    setErrorFile("");
  }

  if (hasError) return;
    let id = statusids;
   
    const req = {
      job_id: id,
      attachments: fileDataattach,
    };

    if (selectedDocumentType) {
      req.document_type = selectedDocumentType;
    }

    if (docSubject) {
      req.document_subject = docSubject;
    }

    try {
      const response = await axios.post(`/api/v1/documents/`, req);
      if (response.status === 201) {
        setIsAttachDocumentVisible(false);
        setsuccessMatch(true)
        setSelectedJobsData([])
        setSelectedScheduleOption("")

      }
    } catch (error) {
      if (error.response.data.error) {
        seterrorsmg(error.response.data.error)
      }
    }
  };

  const [docSubject, setDocSubject] = useState("");
  const [errorsmg, seterrorsmg] = useState("");
  const getCandidateValuesForView = async (job_id) => {
    try {
      const response = await axios.get(`/api/v1/jobs/${job_id}/`, {});

      if (response.status === 200) {
        let job = response.data;

        setValueView('job_id', job?.job_number ?? '');
        setValueView('job_title', job?.job_title ?? '');
        setValueView('company_name', job?.company_name ?? '');
        setValueView('hiring_manager_name', job?.hiring_manager_name ?? '');
        setValueView('location', job?.location_name ?? '');
        setValueView('job_description', job?.job_description ? job.job_description.replace(/<[^>]*>/g, '') : '');
        setValueView('experience', job?.required_experience ?? '');
        setValueView('notes', job?.job_notes ?? '');
        setValueView('groups_name', job?.groups_name ?? '');
        setValueView('category_name', job?.category_name ?? '');
        setValueView('workplace_name', job?.workplace_name ?? '');
        setValueView('job_end_date', job?.job_end_date ?? '');
        setValueView('job_start_date', job?.job_start_date ?? '');
        setValueView('required_skill_names', job?.required_skill_names ?? '');


      }
    } catch (error) {
      console.error('Error fetching job details:', error);
    }
  };


  const onSubmitView = (data) => {
  }

  const [templatei, settemplatei] = useState([])
  const [signatutei, setsignatutei] = useState([])
  const [templateval, settemplateval] = useState(null)
  const [signatuteval, setsignatuteval] = useState(null)
  const [subjectemail, setsubjectemail] = useState(null)
  const [condidateslectnames, setcondidateslectnames] = useState([])
  const [emailviewpop, SetEmailviewpop] = useState(false);
  const [selectedEmailOption, setSelectedEmailOption] = useState(null);
  const [condidatedata, setcondidatedata] = useState([])

  const fileUploadRef = useRef(null);
  // const handleTemplateChange = async (e) => {
  //   try {
  //     const templateId = e.value.id; // Use e.value to get the selected option value, and access 'id' from it
  //     if (!templateId) {
  //       return;
  //     }
  //     const response = await axios.get(`/api/v1/email-templates/${templateId}/`,);
  //     if (response && response.data) {
  //       const { body } = response.data;
  //       settemplateval(e.value); // Set the selected template value
  //       setEmailtextEditor(body || ""); // Update editor content dynamically
  //     }
  //   } catch (error) {

  //   }
  // };
  // const handleSignatureChange = async (e) => {
  //   try {
  //     const templateId = e.value.id;
  //     if (!templateId) {
  //       console.error("Template ID is not provided.");
  //       return;
  //     }
  //     const response = await axios.get(`/api/v1/email-signatures/${templateId}/`, {});
  //     if (response && response.data) {
  //       const { signature_text } = response.data;
  //       setsignatuteval(e.value);
  //       setEmailtextEditor((prevBody) => prevBody + "\n\n" + signature_text || "");
  //     }
  //   } catch (error) {

  //   }
  // };




  const updateEditorContent1 = (body, signature) => {
    const combined = (body || "") + (signature ? `\n\n${signature}` : "");
    setEmailtextEditor(combined);
  };



  const gettemplateitems = async () => {

    try {
      const response = await axios.get(`/api/v1/email-templates/`, {});
      const transformedData = response?.data?.map((city) => ({
        name: city?.name,
        id: city?.template_id,
        body: city?.body,
      }));
      settemplatei(transformedData)
    } catch (error) {

    }
  };
  const getsignatureitems = async () => {
    try {
      const response = await axios.get(`/api/v1/email-signatures/`, {});
      const transformedData = response?.data?.map((city) => ({
        name: city?.name,
        id: city?.signature_id,
      }));
      setsignatutei(transformedData)
    } catch (error) {
    }
  };
  const getsignatureitemsdefalt = async () => {
    try {
      const response = await axios.get(`/api/v1/email-signatures/default/`);
      const transformedData = response.data


      if (transformedData.length > 0) {
        const defaultSignature = transformedData[0].signature_text;
        setSignatureText(defaultSignature);
        setEmailtextEditor((prev) =>
          rebuildEditorContent(templateBody, candidateBlock, defaultSignature)
        );
        let temp = {
          name: transformedData[0].name,
          id: transformedData[0].signature_id,
        }
        console.log(temp)
        setsignatuteval({ ...temp })
      } else {
        setSignatureText("");
        setEmailtextEditor((prev) =>
          rebuildEditorContent(templateBody, candidateBlock, "")
        );
      }
    } catch (error) {
      console.error("Default Signature Fetch Error:", error);
    }


  };


  const formatJobsToHTMLTable = (filteredJobs) => {
    console.log(filteredJobs)
    if (filteredJobs.length === 0) return "";

    const defaultText = `Dear {{contact_name}}, <br> <br>
    Please find below candidate with resume`;

    const formattedJobDetails = filteredJobs
      .map(
        (job) => {
          const rupees = job.expected_salary || 0;
          // const dollars = rupees > 0 ? (rupees / 83).toFixed(2) : '0.00';
          // const tooltip = rupees === 0 ? 'enter the expected salary in dollars' : `₹${rupees}`;
          return `
           <table border="1" cellpadding="5" cellspacing="0" style="width: 100%; border-collapse: collapse;">
             <tr>
              <th> </th>
              <td><b> Candidate </b></td>
              <td>
    ${job.first_name} ${job.middle_name || ''} ${job.last_name || ''}
    ${job.designation ? ' - ' + job.designation : ''}
    </td>
             </tr>
             <tr>
              <th> </th>
              <td><b> Primary Skills </b></td>
              <td>${job.primary_skill_names || ''}</td>
             </tr>
             <tr>
              <th style="text-align: left;"></th>
              <td><b> Contact Details </b></td>
              <td><b>Phone number:</b> ${job.mobile_phone || ''} <b>Email:</b> ${job.email || ''}</td>
             </tr>
             <tr>
              <th style="text-align: left;"> </th>
              <td><b> Work Experience </b></td>
              <td>${job.total_experience || ''} Yrs</td>
             </tr>
             <tr>
              <th style="text-align: left;"></th>
              <td><b> Details </b> </td>
              <td><b>Salary Expectation:</b> \₹${rupees}, <b>Availability:</b> ${job.availability_date || ''}, <b>Employment Type:</b> ${job.employee_type || ''}</td>
             </tr>
           </table>
         `;
        }
      )
      .join("");

    const defaultSig = ` Best Regards, <br>
 ${uniqueUserId} <br>
 Senior HR Recruiter <br>
 Varun Digital Media <br>
 Ph: +91-98765343210 `;

    return `${defaultText}<br><br>${formattedJobDetails}`;
  };

  const [candidateBlock, setCandidateBlock] = useState("");
  const [templateBody, setTemplateBody] = useState("");

  const [signatureText, setSignatureText] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);


  const handleSavecond = () => {
    const candidateContent = formatJobsToHTMLTable(selectedJobsS);
    setCandidateBlock(candidateContent); // only first time

    rebuildEditorContent(templateBody, candidateContent, signatureText);
    setJobDetailsVisible(false);

    const validResumes = selectedJobsS
      .filter(candidate => candidate.resume)
      .map(candidate => ({ file_name: `${candidate.first_name}_${candidate.last_name}_resume.pdf`, file_data: candidate.resume }));
    setFileData(validResumes);

    SetEmailviewpop(true);
  };


  const rebuildEditorContent = (template = templateBody, candidate = candidateBlock, signature = signatureText) => {
    const finalContent = `
   ${template ? `<!-- template -->${template}` : ""}
    ${candidate ? `<!-- candidate -->${candidate}` : ""}
       ${signature ? `<!-- signature -->${signature}` : ""}
    <!-- end -->
  `;
    setEmailtextEditor(finalContent.trim());
  };

  // const handleTemplateChange = async (e) => {
  //   try {
  //     const templateId = e.value?.id;
  //     if (!templateId) return;

  //     const response = await axios.get(`/api/v1/email-templates/${templateId}/`);
  //     if (response?.data) {
  //       const { body } = response.data;
  //       settemplateval(e.value);
  //       setTemplateBody(body || "");
  //       updateEditorContent(body || "", signatureText); // only update template
  //     }
  //   } catch (error) {
  //     console.error("Error loading template:", error);
  //   }
  // };
 
 
  const handleTemplateChange = async (e) => {
    try {
      const templateId = e.value?.id;
      if (!templateId) return;

      const response = await axios.get(`/api/v1/email-templates/${templateId}/`);
      if (response?.data) {
        const { body } = response.data;
        settemplateval(e.value);
        setTemplateBody(body || "");

        // Use latest signatureBlock from state
        rebuildEditorContent(body, candidateBlock || "", signatureText);
      }
    } catch (error) {
      console.error("Template fetch error:", error);
    }
  };

  const handleSignatureChange = async (e) => {
    try {

      const selected = e?.value;
      if (!selected?.id) return;
      console.log(selected)
      setsignatuteval({ ...selected });

      const response = await axios.get(`/api/v1/email-signatures/${selected.id}/`);
      if (response?.data) {
        const { signature_text } = response.data;
        setSignatureText(signature_text || "");
        rebuildEditorContent(templateBody, candidateBlock, signature_text || "");
      }
    } catch (error) {
      console.error("Signature fetch error:", error);
    }
  };

  const footerContent = (
    <div>
      <div className="d-flex align-items-center">
        <Checkbox inputId="checkbox" checked={isPrivate}
          onChange={(e) => setIsPrivate(e.checked)} />
        <label htmlFor="username" className="ms-2 mt-1">
          Private
        </label>
      </div>
    </div>
  );



  // const handleSignatureChange = async (e) => {
  //   try {
  //     const signatureId = e.value?.id;
  //     if (!signatureId) return;

  //     const response = await axios.get(`/api/v1/email-signatures/${signatureId}/`);
  //     if (response?.data) {
  //       const { signature_text } = response.data;
  //       setsignatuteval(e.value);
  //       setSignatureText(signature_text || "");
  //       updateEditorContent(templateBody, signature_text || ""); // only update signature
  //       rebuildEditorContent()
  //     }
  //   } catch (error) {
  //     console.error("Error loading signature:", error);
  //   }
  // };

  const sendCandidateMail = async() =>{
        const req = {};
    let id = statusids;

    let errorMessage = "";

    if (!fromemailinp) {
      errorMessage = "Enter from email";
    } else if (!toemailinp || toemailinp.length === 0) {
      errorMessage = "Enter to email";
    } else if (!emailtextEditor) {
      errorMessage = "Enter email body";
    }

    if (errorMessage) {
      setError(errorMessage);
      return false;
    } else {
      setError("");
    }
    if (!fromemailinp) {
      setError("Enter from email");
      return false;
    }
    if (toemailinp.length === 0) {
      setError("Enter to email");
      return;
    }

    if (ccemailinp) {
      req.cc_addresses = ccemailinp;
    }
    if (subject) {
      req.subject = subject;
    }
    req.job_id = String(id);
    req.status = "Active",
      req.user_ids = uniqueUserId

    req.candidate = condidatedata?.map((datacon) => ({
      candidate: datacon?.candidate_id,
      first_name: datacon?.first_name,
      middle_name: datacon?.middle_name,
      last_name: datacon?.last_name,
      designation: datacon?.designation,
      current_company: datacon?.current_company,
      candidate_email: datacon?.candidate_email,
    }));


    req["from_address"] = fromemailinp.length === 1 ? fromemailinp[0] : fromemailinp;
    req["to_addresses"] = toemailinp;
    req["subject"] = subjectemail;
    req["body"] = emailtextEditor;

    if (ccemailinp) {
      req["cc_addresses"] = ccemailinp;
    }

    if (fileData.length > 0) {
      req["attachments"] = fileData; // Assuming fileData is an array
    } else {
      req["attachments"] = []
    }
    if (isPrivate) {
      req.private = isPrivate
    }


    try {
      const response = await axios.post(`/api/v1/submit-candidate-job/`, req, {});
      if (response?.status === 201) {
    // Success
    SetEmailviewpop(false);
    setSelectedJobsData([]);
    triggerAlert("success", "Success", response?.data?.message || "Candidate submitted successfully");
  } else {
    // Warning if status is not 201
    SetEmailviewpop(false);
    triggerAlert("warning", "Warning", response?.data?.message || "Something might be wrong.");
  }

    } catch (error) {
      SetEmailviewpop(false);
      triggerAlert("error", "Error", error?.response?.data?.message);
      
    }
  }
  const onSubmitemail = async (e) => {
    e?.preventDefault?.();
  if (!subjectemail || subjectemail.trim() === "") {
    setShowNoSubjectConfirm(true);
    setPendingSubmitType("candidate");
    return;
  }
  await sendCandidateMail();
  };
const handleConfirmSend = async () => {
  setShowNoSubjectConfirm(false);
  await sendCandidateMail();
};
const handleCancelSend = () => {
  setShowNoSubjectConfirm(false);
  setPendingSubmitType(null);
};


  useEffect(() => {
     getdocumentTypes()
  }, [])

  useEffect(() => {
      const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"));
      if (userInfo && userInfo.user_details) {
        setUniqueUserId(userInfo.user_details.unique_user_id);
        setLoggedInUserId(userInfo.user_details.user_id);
      }

    }, []);


  const removeFile = (fileName) => {
    setFileData((prevFiles) => prevFiles?.filter((file) => file?.file_name !== fileName));
  };

  const [frominputemail, setFrominputemail] = useState(null);
  const [toinputemail, settoinputemail] = useState(null);
  const [ccinputemail, setccinputemail] = useState(null);
  const [fromemailinp, setfromemailinp] = useState([]);
  const [toemailinp, settoemailinp] = useState([]);
  const [ccemailinp, setccemailinp] = useState([]);
  const [fromEmail, setfromEmail] = useState([]);

  const [toEmail, settoEmail] = useState([]);
  const [ccEmail, setccEmail] = useState([]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(',')[1]; // Remove data:...prefix
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const onUploadHandler1 = async (e) => {
    const allowedTypes = ["application/pdf", "image/png", "image/jpeg"];
    const maxSize = 2 * 1024 * 1024; // 10MB
    const newFiles = e.files || []; // Ensure event.files exists
    const validFiles = await Promise.all(
      newFiles?.map(async (file) => {
        if (!allowedTypes?.includes(file.type)) {
          setError("Only PDF or png or  jpeg files are allowed.");
          return null;
        }
        if (file.size > maxSize) {
          setError("File size should not exceed 2MB.");
          return null;
        }
        const base64 = await getBase64(file);
        return {
          file_name: file.name,
          file_data: base64,
        };
      })
    );

    const filteredFiles = validFiles?.filter(Boolean); // Remove invalid files
    if (filteredFiles?.length === 0) return;
    setFileData((prevFiles) => [...prevFiles, ...filteredFiles]); // Append new files
    setError(""); // Clear errors
    // Clear FileUpload component's internal state
    if (fileUploadRef?.current) {
      fileUploadRef?.current.clear();
    }
  };



  const handleKeyDown1 = (e) => {
    if (e.key === 'Backspace') {
      if (Array.isArray(toemailinp) && toemailinp.length > 0) {
        const newEmails = [...toemailinp];
        newEmails.pop();
        settoemailinp(newEmails);
      } else if (typeof toemailinp === 'string' && toemailinp.length > 0) {
        settoemailinp('');
      }
    }
  };
  const handleKeyDown2 = (e) => {
    if (e.key === 'Backspace') {
      if (Array.isArray(ccemailinp) && ccemailinp.length > 0) {
        const newEmails = [...ccemailinp];
        newEmails.pop();
        setccemailinp(newEmails);
      } else if (typeof ccemailinp === 'string' && ccemailinp.length > 0) {
        setccemailinp('');
      }
    }
  };
  const handleDropdownChange = (e) => {
    setFrominputemail(e.value); // Update dropdown value
    setfromemailinp([e.value.email]);
    setError(""); // Update chips value
    console.log(e.value.email);
  };


  const handleDropdownChangecc = (e) => {
    const selectedEmail = e.target.value;
    const email = selectedEmail.email;
    if (email && !ccemailinp.includes(email)) {
      setccemailinp([...ccemailinp, email]);
    }
    setccinputemail(email);
  };
  const handleDropdownChangeTO = (e) => {
    const selectedEmail = e.target.value;
    const email = selectedEmail.email;
    if (email && !toemailinp.includes(email)) {
      settoemailinp([...toemailinp, email]);
    }
    settoinputemail(email);
  };
  const [emailtextEditor, setEmailtextEditor] = useState([]);

  const onSelectionmail = (e) => {
    const selected = e.value || [];

    setcondidatedata(selected);
    setSelectedJobsS(selected);

    if (selected.length > 0) {
      setcondihide(true); // Show buttons
    } else {
      setcondihide(false); // Hide buttons
    }
  };
  const filterData = (data) =>
    data.filter(
      (item) =>
        item?.first_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
        item?.job_title?.toLowerCase().includes(searchText?.toLowerCase()) ||
        item?.current_company?.toLowerCase().includes(searchText?.toLowerCase()) ||
        item?.candidate_id?.toString().includes(searchText)
    );

  const [notesjobs, setnotesjobs] = useState("")
  const [jobDetailsVisiblelist, setjobDetailsVisiblelist] = useState('');
  const [visibleNote, setvisibleNote] = useState(false);

  const [filteredJobslink, setfilteredJobslink] = useState([])
  const [selectedJobTitles, setSelectedJobTitles] = useState([]);
  const [linkJobVisible, setlinkJobVisible] = useState(false);
  const [linkJobCCVisible, setlinkJobCCVisible] = useState(false);
  const [searchTextTo, setSearchTextTo] = useState("");
  const [searchTextCc, setSearchTextCc] = useState("");
  const [selectedJoblist, setselectedJoblist] = useState([]);
  const [selectedCCJoblist, setselectedCCJoblist] = useState([]);
  const [lazyParamsjoblist, setlazyParamsjoblist] = useState({
    first: 0,
    rows: 10,
    page: 0,
  });
  const [totalRecordsjoblist, setTotalRecordsjoblist] = useState(0);

  const onPageChangejoblist = (event) => {
    setlazyParamsjoblist({ page: event.page, rows: event.rows });
  };

  const handleSaveContact = () => {
    const contactDetails = (selectedJoblist || [])?.filter(contact => contact && contact?.email)?.map(contact => contact?.email);
    settoemailinp(contactDetails);
    setError("");
    setlinkJobVisible(false);
  };


  const handleSaveccjob = () => {
    const contactDetails = (selectedCCJoblist || [])?.filter(contact => contact && contact?.email)?.map(contact => contact?.email);
    setccemailinp(contactDetails);
    setlinkJobCCVisible(false);
  };


  const handleRefresh1 = () => {
    setselectedCCJoblist([]);
    setSearchTextTo("");
  };
  const handleRefresh = () => {
    setselectedJoblist([]);
    setSearchTextTo("");
  };
  const handleSearchTo = (e) => {
    setSearchTextTo(e.target.value);
  };

  const handleSearchCc = (e) => {
    setSearchTextCc(e.target.value);
  };

  const [lazyParamsjob1, setlazyParamsjob1] = useState({ page: 0, rows: 10 });
  const [totalRecordsjob1, setTotalRecordsjob1] = useState(0);
  const getjobvallist = async () => {
    try {
      const response = await axios.get(`/api/v1/jobs/?page=${lazyParamsjob1.page + 1}&size=${lazyParamsjob1.rows}&fields=job_id,job_title,job_number&status=Approved / Open`, {});
      if (response.data) {
        setfilteredJobslink(response.data.results);
        setTotalRecordsjob1(response.data.count);
        console.log(response.data.count)
      }

    } catch (error) {
    }
  };
  useEffect(() => {
    getjobvallist();
  }, [lazyParamsjob1]);

  const onPageChangejob1 = (event) => {
    setlazyParamsjob1({ page: event.page, rows: event.rows });
  };
  const [searchText, setSearchText] = useState("")
  const filterDatalinkCONDI = (data) =>
    data?.filter(
      (item) =>
        item?.first_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
        // item.job_title?.toLowerCase().includes(searchText.toLowerCase()) ||
        item?.current_company?.toLowerCase().includes(searchText?.toLowerCase()) ||
        item?.candidate_id?.toString().includes(searchText)
    );
  const [searchText1, setSearchText1] = useState('');
  const filterDatalinkjOB = (data) =>
    data.filter(

      (item) =>
        item.job_title?.toLowerCase().includes(searchText1.toLowerCase()) ||
        item.job_number?.toLowerCase().includes(searchText1.toLowerCase())

    );

  const usersList = Array.isArray(selectedJobsData) ? selectedJobsData?.map(user => user?.job_title || '').join(' | ') : '';

  const handleIconClickjob = () => {
    setjobDetailsVisiblelist(true);
    setselectedJobListname(selectedJobsData);
  };
  const [selectedJobIds, setSelectedJobIds] = useState()
  const handlejoblink = (e) => {
    const selected = e.value || [];

    //  Join all job titles as a single string (for InputText display)
    // const selectedTitles = selected.map(job => job.job_title).join(", ");
    // setSelectedJobTitles(selectedTitles);

    // //  Update selected list for checkboxes
    // setselectedJobListname(selected);

    // Update job IDs
    // const selectedJobIds = selected.map(job => job.job_id);
    // setSelectedJobIds(selectedJobIds);

    // //  Clear interview validation message
    // setjobinterview("");

    //  Sync full logic with the main function
    setSelectedJobsDataAcrhid({ value: selected });
  };
  const jobnotereq = async (data) => {

    // if (!notesjobs) {
    //   alert("Enter Notes")
    //   return
    // }
    // if (!selectedJobListname) {
    //   alert("Enter Job")
    //   return
    // }

    const currentdateval = moment(currentDateTime).format("YYYY-MM-DD");
    var req = {
      user_ids: uniqueUserId,
      notes: notesjobs,
      currentDateTime: currentdateval ? currentdateval : "null",
      // job_id:     Array.isArray(jobidsslect) ? jobidsslect.join(",") : jobidsslect   
      job_id: selectedJobsData.length > 0 ? selectedJobsData?.map((job) => job?.job_id)?.join(",") : selectedJobListname?.map((job) => job?.job_id)?.join(","),
      // job_id:     Array.isArray(jobidsslect) ? jobidsslect.join(",") : jobidsslect
    };


    try {
      var notespost = await axios.post("/api/v1/notes/", req);
      if (notespost.data) {
        setvisibleNote(false)
        setselectedJobListname([])
        setsuccessMatch(true)
        setsuccess("Notes Added ")
      }
    } catch (error) {

    };
  }

  const [importCsvIcons, setImportCsvIcons] = useState(false)
  const dtContact = useRef(null);

  const exportCSVBtn = () => {
    // Use selected data if present, otherwise use all archived data
    const dataToExport = selectedJobsData?.length > 0 ? selectedJobsData : jobsDataArchirved;

    if (!dataToExport || dataToExport.length === 0) {
      alert("No data available for export.");
      return;
    }

    const exportData = dataToExport.map(item => {
      const createdAtFormatted = item.created_at
        ? moment(item.created_at).format("YYYY-MM-DD HH:mm")
        : "-";
      const updatedAtFormatted = item.updated_at
        ? moment(item.updated_at).format("YYYY-MM-DD HH:mm")
        : "-";

      return {
        JobNumber: item.job_number || "-",
        Company: item.company_name || "-",
        JobTitle: item.job_title || "-",
        Status: item.job_status_name || "-",
        HiringManager: item.hiring_manager_name || "-",
        Department: item.department_name || "-",
        JobNumber: item.job_number || "-",
        JobTitle: item.job_title || "-",
        JobStatus: item.job_status_name || "-",
        Openings: item.openings ?? "-",
        HiringManager: item.hiring_manager_name || "-",
        Company: item.company_name || "-",
        Location: item.location_name || "-",
        WorkplaceType: item.workplace_name || "-",
        JobType: item.job_type_name || "-",
        PrimarySkills: (item.required_skill_names),
        ExperienceRequired: item.required_experience || "-",
        MinSalary: item.salary_min ?? "-",
        MaxSalary: item.salary_max ?? "-",
        Department: item.department_name || "-",
        // StartDate: formatDate(item.job_start_date),
        // EndDate: formatDate(item.job_end_date),
        HiringGoal: item.hiring_goals ?? "-",
        Function: item.job_function_name || "-",
        Seniority: item.seniority_name || "-",
        Category: item.category_name || "-",
        Group: item.groups_name || "-",
        CreatedAt: item.created_at || "-",
        // UpdatedAt: formatDate(item.updated_at),
        UpdatedAt: item.updated_at || "-",
      };
    });

    const headers = Object.keys(exportData[0]).join(",");
    const rows = exportData.map(row =>
      Object.values(row)
        .map(val => `"${String(val).replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers, ...rows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `jobs_export_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };




// ...existing code...

const exportPdfBtn = (allData, fileName) => {
  const dataToExport = selectedJobsData?.length > 0 ? selectedJobsData : allData;

  // Get all columns from DataTable ref
  const columns = dt.current?.props?.children?.filter(
    col => col?.props?.field && col?.props?.header
  );

  // List of fields to exclude for PDF
  const excludeFields = [
    "openings",
    "groups_name",
    "job_function_name",
    "seniority_name"
  ];

  // Filter columns for PDF
  const exportColumns = columns
    .filter(col => !excludeFields.includes(col.props.field))
    .map(col => col.props.header);

  const exportFields = columns
    .filter(col => !excludeFields.includes(col.props.field))
    .map(col => col.props.field);

  const exportData = dataToExport.map(row =>
    exportFields.map(field => {
      let val = row[field];
      if (
        field === "created_at" ||
        field === "updated_at" ||
        field === "job_start_date" ||
        field === "job_end_date"
      ) {
        return val ? moment(val).format("YYYY-MM-DD") : "-";
      }
      return val ?? "-";
    })
  );

  import("jspdf").then(jsPDF => {
    import("jspdf-autotable").then(() => {
      const doc = new jsPDF.default("landscape");

      doc.autoTable({
        head: [exportColumns],
        body: exportData,
        startY: 20,
        styles: { fontSize: 8, cellPadding: 2 },
        theme: "grid",
        margin: { top: 10, left: 5, right: 5 }
      });

      doc.save(`${fileName}.pdf`);
    });
  });
};
// ...existing code...



  // const exportExcelBtn = (data, fileName) => {
  //   import("xlsx").then((xlsx) => {
  //     const worksheet = xlsx.utils.json_to_sheet(data);
  //     const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
  //     const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

  //     saveAsExcelFile(excelBuffer, fileName);
  //   });
  // };



  // const saveAsExcelFile = (buffer, fileName) => {
  //   import("file-saver").then((module) => {
  //     if (module && module.default) {
  //       const EXCEL_TYPE =
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  //       const EXCEL_EXTENSION = ".xlsx";
  //       const data = new Blob([buffer], { type: EXCEL_TYPE });

  //       module.default.saveAs(
  //         data,
  //         `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`
  //       );
  //     }
  //   });
  // };

  const columnMap = [
    { field: "job_number", header: "Job ID" },
    { field: "job_title", header: "Job Title" },
    { field: "job_status_name", header: "Job Status" },
    { field: "openings", header: "Openings" },
    { field: "hiring_manager_name", header: "Hiring Manager" },
    { field: "company_name", header: "Company" },
    { field: "location_name", header: "Location" },
    { field: "workplace_name", header: "Workplace Type" },
    { field: "job_type_name", header: "Job Type" },
    {
      field: "required_skill_names",
      header: "Primary Skills",
      transform: (val) => {
        const skills = (val || "").split(",").map(s => s.trim());
        return skills.length > 3
          ? `${skills.slice(0, 3).join(", ")}, +${skills.length - 3}`
          : skills.join(", ");
      },
    },
    { field: "required_experience", header: "Experience Required" },
    { field: "salary_min", header: "Min Salary" },
    { field: "salary_max", header: "Max Salary" },
    { field: "department_name", header: "Department" },
    {
      field: "job_start_date",
      header: "Start Date",
      transform: (val) => val ? moment(val).format("YYYY-MM-DD") : ""
    },
    {
      field: "job_end_date",
      header: "End Date",
      transform: (val) => val ? moment(val).format("YYYY-MM-DD") : ""
    },
    { field: "hiring_goals", header: "Hiring Goal" },
    { field: "job_function_name", header: "Function" },
    { field: "seniority_name", header: "Seniority" },
    { field: "category_name", header: "Category" },
    { field: "groups_name", header: "Group" },
    {
      field: "created_at",
      header: "Create Date",
      transform: (val) => val ? moment(val).format("YYYY-MM-DD") : ""
    },
    {
      field: "updated_at",
      header: "Edit Date",
      transform: (val) => val ? moment(val).format("YYYY-MM-DD") : ""
    },
    { field: "created_by_name", header: "Created By" },
  ];

  const exportExcelBtn = (allJobsData, selectedJobIds, fileName) => {
    const dataToExport = Array.isArray(selectedJobIds) && selectedJobIds?.length > 0
      ? allJobsData?.filter(job => selectedJobIds?.includes(job?.job_id))
      : allJobsData;

    if (!dataToExport || dataToExport.length === 0) {
      console.warn("No data to export");
      return;
    }

    const transformedData = dataToExport.map((job) => {
      const row = {};
      columnMap?.forEach(({ field, header, transform }) => {
        const value = job[field];
        row[header] = transform ? transform(value) : value ?? "";
      });
      return row;
    });

    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(transformedData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      saveAsExcelFile(excelBuffer, fileName);
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], { type: EXCEL_TYPE });

        module.default.saveAs(
          data,
          `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`
        );
      }
    });
  };



  const headerBtn = (
    <div className="flex align-items-center justify-content-end gap-1 actionitem-import">
      <Button
        className="csvbtn p-button"
        icon="pi pi-file"
        rounded
        onClick={() => exportCSVBtn(jobsDataArchirved, jobidsslect, "Job")}
        tooltip="Export to CSV"
      />
      <Button
        className="xlsbtn p-button"
        icon="pi pi-file-excel"
        severity="success"
        rounded
        onClick={() => exportExcelBtn(jobsDataArchirved, jobidsslect, "Job")}
        tooltip="Export to Excel"
      />
      <Button
        className="pdfbtn p-button me-2"
        icon="pi pi-file-pdf"
        severity="warning"
        rounded
        onClick={() => exportPdfBtn(jobsDataArchirved, jobidsslect, "Job")}
        disabled={jobsDataArchirved.length === 0}
        tooltip="Export to PDF"
      />
    </div>

  )



  const [editingId, setEditingId] = useState(null); // Track editing row by ID
  const [editedRow, setEditedRow] = useState({});

  const handleEdit = (rowData) => {

    setEditingId(rowData.document_type_name); // set only one row to edit
      setEditedRow({
    ...rowData,
    document_type: rowData.document_type, // Pre-select the ID
  });
  };

  const handleInputChange = (field, value) => {
    setEditedRow((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditedRow({});
  };

  const handleSave = async (id) => {

    try {
      const req = {};

      // Capture edited values safely
      if (editedRow?.document_subject) {
        req.document_subject = editedRow.document_subject;
      }

      if (editedRow?.document_type) {
  // Find the value (name) for the selected document_type ID
  const docTypeObj = allDocumentTypes.find(dt => dt.id === editedRow.document_type);
  req.document_type = docTypeObj ? docTypeObj.name : editedRow.document_type;
}

      // if (editedRow?.document_type_name) {
      //   req.document_type = editedRow.document_type_name;
      // }

      if (editedRow?.job_id || statusids?.job_id) {
        req.job_id = editedRow?.job_id || statusids?.job_id;
      }

      await axios.patch(`/api/v1/documents/${id}/`, req);

      setDocuments((prev) =>
  prev?.map((doc) => {
    if (doc?.id === id) {
      // Find the name for the selected document_type
      let docTypeName = req.document_type;
      // If you sent the value, use it directly
      // If you sent the ID, look up the name
      if (!docTypeName && editedRow?.document_type) {
        const docTypeObj = allDocumentTypes.find(dt => dt.id === editedRow.document_type);
        docTypeName = docTypeObj ? docTypeObj.name : '';
      }
      return {
        ...doc,
        ...req,
        document_type_name: docTypeName || doc.document_type_name,
      };
    }
    return doc;
  })
);

      setEditingId(null);
      setEditedRow({});
      getprofiledoc(selectedJobsData[0].job_id);
    } catch (error) {

    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/v1/documents/${id}/`);
      setDocuments((prev) => prev?.filter((doc) => doc?.id !== id));
      getprofiledoc(selectedJobsData[0]?.job_id);
    } catch (error) {

    }
  };

  const editableTemplate = (rowData, field) => {
    const isEditing = editingId === rowData.document_type_name;
    if (field === "document_type_name" && isEditing) {
    return (
      <Dropdown
        value={editedRow.document_type || rowData.document_type}
        options={allDocumentTypes}
        optionLabel="name"
        optionValue="id"
        placeholder="Select Document Type"
        onChange={(e) => {
          // Update both id and name for display and save
          setEditedRow((prev) => ({
            ...prev,
            document_type: e.value,
            document_type_name: allDocumentTypes.find(dt => dt.id === e.value)?.name || "",
          }));
        }}
        style={{ width: "100%" }}
      />
    );
  } 

    if (isEditing) {
      return (
        <InputText
          value={editedRow[field] || ""}
          onChange={(e) => handleInputChange(field, e.target.value)}
        />
      );
    }

    // For server time, format if needed
    const value = field === "created_at"
      ? new Date(rowData[field]).toLocaleString()
      : rowData[field];

    return <span>{value}</span>;
  };

  const actionTemplate = (rowData) => {
    const isEditing = editingId === rowData.document_type_name;

    return (
      <div className="flex gap-2">
        {isEditing ? (
          <>
            <Button
              icon="pi pi-check"
              className="p-button-success p-button-sm"
              onClick={() => handleSave(rowData.document_id)}
            />
            <Button
              icon="pi pi-times"
              className="p-button-secondary p-button-sm"
              onClick={handleCancel}
            />
          </>
        ) : (
          <>
            <Button
              icon="pi pi-pencil"
              className="p-button-warning p-button-sm"
              onClick={() => handleEdit(rowData)}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-sm"
              onClick={() => handleDelete(rowData.document_id)}
            />
          </>
        )}
      </div>
    );
  };
  const attachmentTemplate = (rowData) => {
    if (rowData.attachments && rowData.attachments.length > 0) {
      return rowData?.attachments?.map((file, index) => {
        const fileName = file?.file_name;
        const fileUrl = file?.file_path;
        return (
          <div key={index}>
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              {fileName?.length > 25 ? fileName?.slice(0, 25) + "..." : fileName}
            </a>
          </div>
        );
      });
    } else {
      return <span>No file</span>;
    }
  };

  // Job ID column template with actions
  const jobIdActionTemplate = (rowData) => {
    return (
      <div className="d-flex align-items-center gap-2">
        <span>{rowData.job_number}</span>
        <div className="d-flex gap-1">
          {/* Eye icon for view */}
          <button
            className="pi pi-eye"
            style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '14px', padding: '4px' }}
            title="View Job"
            onClick={() => {
              setSelectedJob(rowData);
              setSelectedJobsData([rowData]);
              const jobId = rowData.job_id;
              setVisibleViewRight(true);
              getCandidateValuesForView(jobId);
              setstatusids(jobId);
              fetchPipelineData(jobId);
              setEditorVisible(false);
              setDeleteRowID(jobId);
              getprofiledoc(jobId);
              getprofilehis(jobId);
              getallnotes(jobId);
            }}
          />
          {/* 3 dots menu */}
          <button
            className="pi pi-ellipsis-v"
            style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '14px', padding: '4px' }}
            title="More Actions"
            onClick={(e) => {
              setSelectedJob(rowData);
              const menuItems = [
                {
                  label: 'Delete',
                  icon: 'pi pi-trash',
                  command: () => {
                    setjobidsslect(rowData.job_id);
                    setSmShowdele(true);
                  }
                },
                {
                  label: archived_only ? 'Unarchive' : 'Archive',
                  icon: archived_only ? 'pi pi-refresh' : 'pi pi-archive',
                  command: () => {
                    setjobidsslect(rowData.job_id);
                    if (archived_only) {
                      setSmShowun(true);
                    } else {
                      setSmShow(true);
                    }
                  }
                }
              ];
              
              // Create a temporary context menu for this specific row
              const tempMenu = document.createElement('div');
              tempMenu.className = 'p-contextmenu p-component';
              tempMenu.style.position = 'absolute';
              tempMenu.style.zIndex = '1000';
              tempMenu.style.background = 'white';
              tempMenu.style.border = '1px solid #ddd';
              tempMenu.style.borderRadius = '4px';
              tempMenu.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
              tempMenu.style.minWidth = '120px';
              
              menuItems.forEach(item => {
                const menuItem = document.createElement('div');
                menuItem.className = 'p-menuitem';
                menuItem.style.padding = '8px 12px';
                menuItem.style.cursor = 'pointer';
                menuItem.style.display = 'flex';
                menuItem.style.alignItems = 'center';
                menuItem.innerHTML = `<i class="${item.icon}" style="margin-right: 8px;"></i>${item.label}`;
                
                menuItem.addEventListener('mouseenter', () => {
                  menuItem.style.backgroundColor = '#f5f5f5';
                });
                menuItem.addEventListener('mouseleave', () => {
                  menuItem.style.backgroundColor = 'transparent';
                });
                menuItem.addEventListener('click', () => {
                  item.command();
                  if (document.body.contains(tempMenu)) {
                    document.body.removeChild(tempMenu);
                  }
                });
                
                tempMenu.appendChild(menuItem);
              });
              
              const rect = e.target.getBoundingClientRect();
              tempMenu.style.left = rect.left + 'px';
              tempMenu.style.top = (rect.bottom + 5) + 'px';
              
              document.body.appendChild(tempMenu);
              
              // Remove menu when clicking outside
              const removeMenu = (event) => {
                if (!tempMenu.contains(event.target)) {
                  if (document.body.contains(tempMenu)) {
                    document.body.removeChild(tempMenu);
                  }
                  document.removeEventListener('click', removeMenu);
                }
              };
              
              setTimeout(() => {
                document.addEventListener('click', removeMenu);
              }, 100);
            }}
          />
        </div>
      </div>
    );
  };
  const [selectedJob, setSelectedJob] = useState(null);
  const [recruiterManager, setRecruiterManager] = useState(null);
  const [recruiters, setRecruiters] = useState([]);
  const [recruiterManagerOptions, setRecruiterManagerOptions] = useState([]);
  const [loggedInUserId, setLoggedInUserId] = useState(null);
  const [recruiterOptions, setRecruiterOptions] = useState([]);

  // Candidate form refs
  const emailInputRef = useRef(null);
  const emailDebounceRef = useRef(null);

  // Candidate form state
  const [isDuplicateEmail, setIsDuplicateEmail] = useState(false);
  const [duplicateCandidateId, setDuplicateCandidateId] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [resumeError, setResumeError] = useState("");

  // Candidate form additional states
  const initialAddressState = {
    street_address: "",
    street_address_line_2: "",
    country: null,
    state: null,
    city: null,
    pincode: "",
    label: null,
    source: null,
    stage: null,
  };
  const [formData, setFormData] = useState(initialAddressState);
  const [tempAddressData, setTempAddressData] = useState(initialAddressState);
  const [visible, setVisible] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [addressLabels, setAddressLabels] = useState([]);
  const [resumeSourceOptions, setResumeSourceOptions] = useState([]);
  const [primarySkillsview, setprimarySkillsview] = useState([]);
  const [selectedCategoryNode, setSelectedCategoryNode] = useState(null);
  const [selectedGroupNode, setSelectedGroupNode] = useState(null);
  const [categoryNodes, setCategoryNodes] = useState([]);
  const [groupNodes, setGroupNodes] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  // Additional candidate form states from AllActiveemp
  const [resumefileData, setResumeFileData] = useState([]);
  const [candidateError, setCandidateError] = useState("");
  const [candidateLoading, setCandidateLoading] = useState(false);
  const [candidatePrimarySkillsget, setCandidatePrimarySkillsget] = useState([]);
  const [candidateUniqueUserId, setCandidateUniqueUserId] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);
  
  // Address-related states
  const candidateLabels = [
    { label: "Work from Office (WFO)", value: "WORK" },
    { label: "Work from Home (WFH)", value: "HOME" },
    { label: "Work from Remote (WFR)", value: "REMOTE" },
  ];

  // Form validation patterns for candidate
  const candidatePatterns = {
    address: /^[a-zA-Z0-9\s,.-]{5,100}$/,
    pincode: /^[a-zA-Z0-9]{0,6}$/,
  };

  const [expandedRows, setExpandedRows] = useState({});
  const [jobPipelineData, setJobPipelineData] = useState({});
  const [jobActivitiesData, setJobActivitiesData] = useState({});
  const [jobProfileData, setJobProfileData] = useState({});
  const [jobDocumentsData, setJobDocumentsData] = useState({});
  const [jobHistoryData, setJobHistoryData] = useState({});
  const [jobNotesData, setJobNotesData] = useState({});

  // Address-related useEffects (moved here to fix initialization order)
  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    if (tempAddressData.country?.country_id) {
      fetchStates(tempAddressData.country.country_id);
      setTempAddressData(prev => ({
        ...prev,
        state: null,
        city: null
      }));
    }
  }, [tempAddressData.country]);

  useEffect(() => {
    if (tempAddressData.state?.state_id) {
      fetchCities(tempAddressData.state.state_id);
      setTempAddressData(prev => ({
        ...prev,
        city: null
      }));
    }
  }, [tempAddressData.state]);

  const handleRowToggle = (e) => {
    let newExpandedRows = {};
    if (e.data && Object.keys(e.data).length > 0) {
      const jobId = Object.keys(e.data)[0];
      const isCurrentlyExpanded = expandedRows[jobId];
      
      if (isCurrentlyExpanded) {
        // Collapsing - clear everything
        newExpandedRows = {};
      } else {
        // Expanding - add to expanded rows and select
        newExpandedRows = { [jobId]: true };
        
        // Find the job object from jobsDataArchirved
        const selectedJob = jobsDataArchirved.find(job => String(job.job_id) === String(jobId));
        if (selectedJob) {
          setSelectedJobsData([selectedJob]);
          setSelectedJob(selectedJob);
          // Update all related selection states when expanding
          setselectedJobListname([selectedJob]);
          setjobidsslect([selectedJob.job_id]);
          setjobidsslectnames([selectedJob.job_title]);
          setSelectedJobTitles(selectedJob.job_title);
          setSelectedJobForStatus(selectedJob);
        }
        
        // Initialize pipeline tab for this job if not already set
        if (!jobActivePipelineTabs[jobId] && stages.length > 0) {
          setJobActivePipelineTabs(prev => ({
            ...prev,
            [jobId]: stages[0] // Set to first stage by default
          }));
        }
      }
    }
    setExpandedRows(newExpandedRows);
    
    // Clear selection when collapsing
    if (Object.keys(newExpandedRows).length === 0) {
      setSelectedJobsData([]);
      setSelectedJob(null);
      setselectedJobListname([]);
      setjobidsslect([]);
      setjobidsslectnames([]);
      setSelectedJobTitles("");
      setSelectedJobForStatus(null);
    }

    // Fetch data for the expanded row
    Object.keys(newExpandedRows).forEach(jobId => {
      if (newExpandedRows[jobId] && !jobPipelineData[jobId]) {
        fetchJobPipelineData(jobId);
      }
      if (newExpandedRows[jobId] && !jobActivitiesData[jobId]) {
        fetchJobActivitiesData(jobId);
      }
      if (newExpandedRows[jobId] && !jobProfileData[jobId]) {
        fetchJobProfileData(jobId);
      }
      if (newExpandedRows[jobId] && !jobDocumentsData[jobId]) {
        fetchJobDocumentsData(jobId);
      }
      if (newExpandedRows[jobId] && !jobHistoryData[jobId]) {
        fetchJobHistoryData(jobId);
      }
      if (newExpandedRows[jobId] && !jobNotesData[jobId]) {
        fetchJobNotesData(jobId);
      }
    });
  };

  const menuModel = useMemo(() => {
    if (isApprovedOpenStatus) {
      // Show all items for Approved / Open status
      return [
        {
          label: 'View',
          visible: viewPermission,
          icon: 'pi pi-fw pi-eye',
          command: () => {
            if (selectedJob) {
              const jobId = selectedJob.job_id;
              setVisibleViewRight(true);
              getCandidateValuesForView(jobId);
              setstatusids(jobId);
              fetchPipelineData(jobId);
              setEditorVisible(false);
              setDeleteRowID(jobId);
              getprofiledoc(jobId);
              getprofilehis(jobId);
              getallnotes(jobId);
            }
          }
        },
        {
          label: 'Edit',
          visible: editPermission,
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            if (selectedJob) {
              const job = selectedJob.job_id;
              navigate(`/jobs-editform?job_id=${job}`);
            }
          }
        },
        {
          label: archived_only ? 'Unarchive' : 'Archive',
          icon: archived_only ? 'pi pi-refresh' : 'pi pi-check-circle',
          command: () => {
            if (selectedJob && selectedJob.job_id) {
              const jobId = selectedJob.job_id;
              setjobidsslect(jobId)
              if (archived_only) {
                setSmShowun(true);
              } else {
                setSmShow(true);
              }
            }
          }
        },
        {
          label: 'Delete',
          visible: deletePermission,
          icon: 'pi pi-fw pi-trash',
          command: () => {
            if (selectedJob) {
              const job = selectedJob.job_id;
              setSmShowdele(true);
              setDeleteRowID(job);
              setjobidsslect(job)
            }
          }
        }
      ];
    } else {
      // For other statuses (inactive, hold, etc.), only show Delete and Archive options
      return [
        {
          label: archived_only ? 'Unarchive' : 'Archive',
          icon: archived_only ? 'pi pi-refresh' : 'pi pi-check-circle',
          command: () => {
            if (selectedJob && selectedJob.job_id) {
              const jobId = selectedJob.job_id;
              setjobidsslect(jobId)
              if (archived_only) {
                setSmShowun(true);
              } else {
                setSmShow(true);
              }
            }
          }
        },
        {
          label: 'Delete',
          visible: deletePermission,
          icon: 'pi pi-fw pi-trash',
          command: () => {
            if (selectedJob) {
              const job = selectedJob.job_id;
              setSmShowdele(true);
              setDeleteRowID(job);
              setjobidsslect(job)
            }
          }
        }
      ];
    }
  }, [isApprovedOpenStatus, selectedJob, viewPermission, editPermission, deletePermission, archived_only, actScheduleOptions, candilist]);

  
  const [pipelineData, setPipelineData] = useState({});
  const [stageCounts, setStageCounts] = useState({});
  const [selectedJobs, setSelectedJobs] = useState({});
  const [pipelineFilters, setPipelineFilters] = useState({});
  const [selectedRowExpansionJobs, setSelectedRowExpansionJobs] = useState({});

  // Handler when selecting rows in the sidebar pipeline per-stage
  const handlePipelineSelectionChange = (stage, value) => {
    setSelectedJobs(prev => ({ ...prev, [stage]: value }));
  };

  // Initialize filters for each stage
  const initFilters = {
    stage: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jobid: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    candidate_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    hiring_manager_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    create_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    candidate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    createdBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user_ids: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };
  const fetchStages = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-stages/");
      if (response.data && response.data.results) {
        // Sort stages by order and keep original capitalization
        const sortedStages = response.data.results
          .sort((a, b) => a.order - b.order)
          .map((stage) => stage?.name);
        setStages(sortedStages);

        // Initialize state for each stage
        const initialPipelineData = {};
        const initialStageCounts = {};
        const initialSelectedJobs = {};
        const initialFilters = {};
        sortedStages?.forEach((stage) => {
          initialPipelineData[stage] = [];
          initialStageCounts[stage] = 0;
          initialSelectedJobs[stage] = [];
          initialFilters[stage] = initFilters;
        });
        setPipelineData(initialPipelineData);
        setStageCounts(initialStageCounts);
        setSelectedJobs(initialSelectedJobs);
        setFilters(initialFilters);
        const transformedData = response?.data?.results?.map((cond) => ({
          name: cond?.name,
          id: cond?.id,
        }));

        setcandilist(transformedData)
        
        // Set stage options for candidate form dropdown
        const stageOptions = response.data.results
          .sort((a, b) => a.order - b.order)
          .map((stage) => ({
            label: stage.name,
            value: stage.name,
          }));
        setResumeSourceOptions(prev => [...(prev || []), ...stageOptions]);
        
        // Initialize activePipelineTab with the first stage
        if (sortedStages.length > 0) {
          setActivePipelineTab(sortedStages[0]);
        }
      } else {
        console.warn("No stages found in API response.");
        setStages([]);
      }
    } catch (error) {
      console.error("Error fetching stages:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch stages. Please try again.",
        life: 3000,
      });
    }
  };
  const fetchPipelineData = async (deleteRowId) => {
    if (!deleteRowId) {
      console.error("No job ID provided.");
      return;
    }
    try {
      const response = await axios.get(`/api/v1/stages/job_candidates_by_stage/?job_id=${deleteRowId}`);

      if (response?.data && response?.data?.results) {
        // Transform the API response to match DataTable structure
        const newPipelineData = {};
        const newStageCounts = {};
        
        // Initialize all stages with empty data
        stages?.forEach((stage) => {
          newPipelineData[stage] = [];
          newStageCounts[stage] = 0;
        });

        // Process the API response data
        response?.data?.results?.forEach((stageData) => {
          const stageName = stageData?.stage_name;
          console.log('Processing sidebar stage:', stageName, 'Count:', stageData?.count);
          
          if (stageName) {
            // Set the count for this stage
            newStageCounts[stageName] = stageData?.count || 0;
            
            // Map the candidates data for this stage
            newPipelineData[stageName] = (stageData?.candidates || []).map((candidate) => ({
              stage: stageName,
              user_ids: candidate?.user_ids || "N/A",
              jobid: candidate?.job?.job_number || "N/A",
              job_title: candidate?.job?.job_title || "N/A",
              company_name: candidate?.job?.company_name || "N/A",
              hiring_manager_name: candidate?.job?.hiring_manager_name || "N/A",
              candidate_name: candidate?.candidate_name || "N/A",
              status: candidate?.status || "N/A",
              create_date: candidate?.created_at
                ? moment(candidate?.created_at).format('YYYY-MM-DD')
                : "N/A",
              createdBy: candidate?.created_by_meta ? candidate?.created_by_meta : candidate?.created_by_name || "N/A",
              candidate: candidate?.candidate_name || "N/A",
              location: candidate?.job?.location || "N/A",
            }));
          }
        });

        console.log('Final sidebar pipeline data:', { data: newPipelineData, counts: newStageCounts });
        setPipelineData(newPipelineData);
        setStageCounts(newStageCounts);
      } else {
        console.warn("No results found in API response.");
        const emptyPipelineData = {};
        const emptyStageCounts = {};
        stages?.forEach((stage) => {
          emptyPipelineData[stage] = [];
          emptyStageCounts[stage] = 0;
        });
        setPipelineData(emptyPipelineData);
        setStageCounts(emptyStageCounts);
      }
    } catch (error) {
      console.error("Error fetching pipeline data:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch pipeline data. Please try again.",
        life: 3000,
      });
      const emptyPipelineData = {};
      const emptyStageCounts = {};
      stages?.forEach((stage) => {
        emptyPipelineData[stage] = [];
        emptyStageCounts[stage] = 0;
      });
      setPipelineData(emptyPipelineData);
      setStageCounts(emptyStageCounts);
    }
  };

  const fetchJobPipelineData = async (jobId) => {
    try {
      const response = await axios.get(`/api/v1/stages/job_candidates_by_stage/?job_id=${jobId}`);
      if (response?.data && response?.data?.results) {
        const newPipelineData = {};
        const newStageCounts = {};
        
        // Initialize all stages with empty data
        stages?.forEach((stage) => {
          newPipelineData[stage] = [];
          newStageCounts[stage] = 0;
        });

        // Process the API response data
        response?.data?.results?.forEach((stageData) => {
          const stageName = stageData?.stage_name;
          console.log('Processing stage:', stageName, 'Available stages:', stages);
          
          if (stageName) {
            // Set the count for this stage
            newStageCounts[stageName] = stageData?.count || 0;
            
            // Map the candidates data for this stage
            newPipelineData[stageName] = (stageData?.candidates || []).map((candidate) => ({
              stage: stageName,
              user_ids: Array.isArray(candidate?.user_ids) ? candidate.user_ids.join(', ') : candidate?.user_ids || "N/A",
              jobid: candidate?.job?.job_number || "N/A",
              job_title: candidate?.job?.job_title || "N/A",
              company_name: candidate?.job?.company_name || "N/A",
              hiring_manager_name: candidate?.job?.hiring_manager_name || "N/A",
              candidate_name: candidate?.candidate_name || "N/A",
              status: candidate?.status || "N/A",
              create_date: candidate?.created_at
                ? moment(candidate?.created_at).format('YYYY-MM-DD')
                : "N/A",
              createdBy: candidate?.created_by_name || "N/A",
              candidate: candidate?.candidate_name || "N/A",
            }));
          }
        });

        console.log('Final pipeline data for job', jobId, ':', { data: newPipelineData, counts: newStageCounts });
        setJobPipelineData(prev => ({ ...prev, [jobId]: { data: newPipelineData, counts: newStageCounts } }));
      } else {
        console.warn('No pipeline data found for job:', jobId);
        setJobPipelineData(prev => ({ ...prev, [jobId]: { data: {}, counts: {} } }));
      }
    } catch (error) {
      console.error("Error fetching job pipeline data:", error);
      setJobPipelineData(prev => ({ ...prev, [jobId]: { data: {}, counts: {} } }));
    }
  };

  const fetchJobActivitiesData = async (jobId) => {
    try {
      const response = await axios.get(`/api/v1/activity-log/?job_id=${jobId}&page=1&size=10`);
      if (response?.data && response?.data?.results) {
        setJobActivitiesData(prev => ({ ...prev, [jobId]: response.data.results }));
      } else {
        setJobActivitiesData(prev => ({ ...prev, [jobId]: [] }));
      }
    } catch (error) {
      console.error("Error fetching job activities data:", error);
      setJobActivitiesData(prev => ({ ...prev, [jobId]: [] }));
    }
  };

  const fetchJobProfileData = async (jobId) => {
    try {
      const response = await axios.get(`/api/v1/jobs/${jobId}/`);
      if (response.status === 200) {
        setJobProfileData(prev => ({ ...prev, [jobId]: response.data }));
      }
    } catch (error) {
      console.error('Error fetching job profile:', error);
    }
  };

  const fetchJobDocumentsData = async (jobId) => {
    try {
      const response = await axios.get(`/api/v1/documents/?job_id=${jobId}`);
      if (response.data) {
        setJobDocumentsData(prev => ({ ...prev, [jobId]: response.data.results }));
      }
    } catch (error) {
      setJobDocumentsData(prev => ({ ...prev, [jobId]: [] }));
    }
  };

  const fetchJobHistoryData = async (jobId) => {
    try {
      const response = await axios.get(`/api/v1/history/?job_id=${jobId}`);
      if (response.data) {
        setJobHistoryData(prev => ({ ...prev, [jobId]: response.data.results }));
      }
    } catch (error) {
      setJobHistoryData(prev => ({ ...prev, [jobId]: [] }));
    }
  };

  const fetchJobNotesData = async (jobId) => {
    try {
      const response = await axios.get(`/api/v1/notes/?job_id=${jobId}`);
      if (response.data) {
        setJobNotesData(prev => ({ ...prev, [jobId]: response.data.results }));
      }
    } catch (error) {
      setJobNotesData(prev => ({ ...prev, [jobId]: [] }));
    }
  };

  useEffect(() => {
    fetchStages();
  }, []);
  const [newErrors, setNewErrors] = useState({});

  const reminderOptions = [
    { name: '0 mins', value: '0 minutes' },
    { name: '5 mins', value: '5 minutes' },
    { name: '10 mins', value: '10 minutes' },
    { name: '15 mins', value: '15 minutes' },
    { name: '30 mins', value: '30 minutes' }, // default selected value
  ];
  const [reminder, setReminder] = useState("10 minutes");
  const [repeat, setRepeat] = useState(null);
  const repeatOptions = [
    { name: 'Do not repeat', value: 'none' },
    { name: 'Daily', value: 'Daily' },
    { name: 'Weekly', value: 'Weekly' },
    { name: 'Mon-Fri', value: 'Mon-Fri' },
  ];

  const [followup, setFollowup] = useState(null);

  // Dropdown options
  const followupOptions = [
    { name: 'None', value: 'none' },
    { name: '1 Day', value: '1 Day' },
    { name: '2 Days', value: '2 Day' },
    { name: '3 Days', value: '3 Day' },
  ];

  return (
    <React.Fragment>
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          <div className="page-title-box actjobbread">

            <Row className="align-items-center breadcrumb-card ac-items">
              <Col xxl={9} xl={12} lg={12} md={12} sm={12}>
                            <div style={{ display: "inline-block", marginRight: "10px", minWidth: "180px", verticalAlign: "middle" }}>
                <Dropdown
                  value={selectedHeaderJobStatus}
                  options={headerJobStatusOptions}
                  onChange={e => setSelectedHeaderJobStatus(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select Job Status"
                  className="me-2"
                  style={{ minWidth: 180 }}
                  tooltip={selectedHeaderJobStatus ? headerJobStatusOptions.find(opt => opt.value === selectedHeaderJobStatus)?.description : ""}
                />
              </div>
                <span className="addcan-ac">
                  {selectedJobsData && selectedJobsData.length > 0 ? (
                    <span className="btn btn-info import-res-btn md:w-8rem me-1">
                      <i className="pi pi-check me-1"></i> {selectedJobsData.length} Selected
                    </span>
                  ) : (
                    addPermission && (
                      <button
                        type="button"
                        className="btn btn-secondary import-res-btn md:w-8rem me-1"
                        onClick={() => {
                          dispatch(setJobSidebarVisible(true));
                          resetJob();
                          setprimartkey("");
                          setJobStartDate("");
                          setJobEndDate("");
                          setText("");
                          setprimarySkillsview([]);
                          settimetohire("");
                          setjobActualEnddate("");
                          setSelectedNodeKeycat("");
                          setselectedgroupKey("");
                          setPopchecked3("");
                          seterrorjobs("");
                          setSelectedCompany("");
                          setjobworkspace("");
                          setHiringManager("");
                          setRecruiterManager("");
                          setRecruiters([]);
                          setJobLocationview("");
                          setExperience("");
                        }}
                      >
                        <i className="pi pi-briefcase me-1"></i> Add Job
                      </button>
                    )
                  )}

                  <CascadeSelect
                    value={selectedScheduleOption}
                    onChange={handleScheduleChangemore}
                    options={moreoptions1}
                    optionLabel="name"
                    optionGroupLabel="name"
                    optionGroupChildren={['candidates']}
                    className="md:w-10rem me-1"
                    breakpoint="767px"
                    placeholder="Bulk Actions"
                  />
                </span>
              </Col>

              <Col xxl={3} xl={12} lg={12} sm={12}>
                <Tooltip target=".note" content="Note" position="bottom" style={{ marginTop: "5px" }} />
                <div className="clr-icons">
                  {viewPermission && <>
                    <button className="btn icons-btn me-1 note" type="button"
                      onClick={() => { setCurrentDateTime(""); setSelectedJobTitles(""); setnotesjobs(""); setSelectedJobIds(""); setvisibleNote(true); }} ><i class="pi pi-file"></i></button>

                  </>}
                  {/* {selectedJobsData.length > 0 ? <NotesJobs /> : <NotesJobs1 />} */}

                  {/* <ExportJobs /> */}
                  <div className="clr-icons">
                    {/* {selectedjobsDataArchirved.length > 0 ? <NotesContact1 /> : <NotesContact />} */}

                    <Tooltip target=".expbtn" content="Export" position="bottom" style={{ marginTop: "5px" }} />

                    <button
                      type="button"
                      className="btn icons-btn me-1 expbtn"
                      onClick={() => setImportCsvIcons(!importCsvIcons)}
                    >
                      <i className="pi pi-file-export"></i>
                    </button>

                    {importCsvIcons && <span>{headerBtn}</span>}

                    <Tooltip target=".clear" content="Clear Search" position="bottom" style={{ marginTop: "5px" }} />

                    <button
                      type="button"
                      className="btn icons-btn me-1 clear" onClick={handleClearSearchJobs}
                    >
                      <i className="pi pi-sync"></i>
                    </button>
                  </div>

                  {/* <button
                    type="button"
                    className="btn btn-secondary icons-btn" Tooltip="Clear Search" onClick={handleClearSearchJobs}
                  >
                    <i className="pi pi-sync"></i>
                  </button> */}
                </div>
              </Col>
              <Col xxl={3} xl={12} lg={12} sm={12}>

              </Col>
            </Row>
            {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
          <ProgressSpinner />
        </div>
      ) :(
        <Row>
              <Col sm={12}>
                {/* Toast for notifications */}
                <Toast ref={toast} />

                {/* ContextMenu for right-click actions */}
                <ContextMenu model={menuModel} ref={cm} onHide={() => setSelectedJob(null)} />

                <section className="allactjobs-table">
                  <div className="card1 mt-4 mb-4 actjobsumtable">
                    {type === "activity-log" ?
                      <DataTable
                        ref={dt}
                        value={filterData(jobsDataArchirved)}

                        first={first}
                        rows={rows}
                        totalRecords={totalRecords}
                        onPage={onPageChange} loading={loading}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 50, totalRecords]} // Dynamic row options including "All"

                        dataKey="calendar_id"
                        scrollable
                        selectionMode="single"
                        emptyMessage="No  found."

                        selection={selectedJobsData}
                        onSelectionChange={setSelectedJobsDataAcrhid}
                        rowGroupMode="rowspan"
                        rowClassName="row-bottom-color"  // Apply custom row style
                        editMode="cell"
                        filters={filtersjoball}
                        filterDisplay="row"
                        reorderableRows
                        resizableColumns
                        reorderableColumns
                        columnResizeMode="expand"
                        onContextMenu={(e) => {
                          cm.current.show(e.originalEvent); // Show the context menu
                          setSelectedJob(e.data); // Set the selected company
                        }}
                        contextMenuSelection={selectedJob}

                      >


                        <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                        <Column field="job_type_name" header="Job Type" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="job_status_name" header="Job Status" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="job_number" header="Job ID" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="job_title" header="Job Title" sortable filter style={{ minWidth: '12rem' }} />
                        <Column field="hiring_manager_name" header="Hiring Manager" sortable filter style={{ minWidth: '12rem' }} />
                        <Column field="company_name" header="Company" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="department_name" header="Department" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="category_name" header="Category" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="groups_name" header="Group" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="created_at" header="Create Date" sortable filter style={{ minWidth: '10rem' }}
                          body={(rowData) =>
                            rowData.created_at && moment(rowData.created_at).isValid()
                              ? moment(rowData.created_at).format('YYYY-MM-DD')
                              : '-'
                          }
                        />
                        <Column field="updated_at" header="Edit Date" sortable filter style={{ minWidth: '10rem' }}
                          body={(rowData) =>
                            rowData.updated_at && moment(rowData.updated_at).isValid()
                              ? moment(rowData.updated_at).format('YYYY-MM-DD')
                              : '-'
                          }
                        />
                        <Column field="created_by_name_job" header="Created By" sortable filter style={{ minWidth: '10rem' }} />

                        {/* <Column field="event_type" header="Type " sortable filter style={{ minWidth: "10rem" }} />
                        <Column field="event_sub_type" header="Sub Type  " sortable filter style={{ minWidth: "10rem" }} />
                        <Column field="event_priority" header="Priority" sortable filter style={{ minWidth: "10rem" }} />
                        <Column field="subject" header="Subject " sortable filter style={{ minWidth: "10rem" }} />
                        <Column field="start_date" header=" Date time  " sortable filter style={{ minWidth: "10rem" }}
                          body={(rowData) => rowData.start_date ? moment(rowData.start_date).format('YYYY-MM-DD HH:mm') : '-'}
                        />
                        <Column field="action_date" header="status" sortable filter style={{ minWidth: "10rem" }} /> */}


                      </DataTable> : <DataTable
                        ref={dt}
                        value={filterData(jobsDataArchirved)}

                        // lazy
                        // paginator
                        // first={lazyParamslist.page * lazyParamslist.rows}
                        // rows={lazyParamslist.rows}
                        // totalRecords={totalRecordslist}
                        // onPage={onPageChangelist}
                        loading={loading}
                        first={first}
                        rows={rows}
                        totalRecords={totalRecords}
                        onPage={onPageChange}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 50, totalRecords]} // Dynamic row options including "All"
                        dataKey="job_id"
                        scrollable
                        emptyMessage="No records found."
                        selection={selectedJobsData}
                        onSelectionChange={setSelectedJobsDataAcrhid}
                        selectionMode="single"
                        // onFilter={(e) => setfiltersjoball(e.filters)}
                        // onFilter={createDefaultFilters}

                        // onFilter={onFilter}
                        filters={filtersjoball}
                        filterDisplay="row"
                        reorderableRows
                        resizableColumns
                        reorderableColumns
                        columnResizeMode="expand"

                        onContextMenu={(e) => {
                          cm.current.show(e.originalEvent); // Show the context menu
                          setSelectedJob(e.data); // Set the selected company
                        }}
                        contextMenuSelection={selectedJob}
                        onContextMenuSelectionChange={(e) => setSelectedJob(e.value)}
                      >


                        <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                        <Column field="job_number" header="Job ID" sortable filter style={{ minWidth: '10rem' }} body={jobIdActionTemplate} />
                        <Column field="job_title" header="Job Title" sortable filter style={{ minWidth: '12rem' }} />
                        <Column field="job_status_name" header="Job Status" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="openings" header="Openings" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="hiring_manager_name" header="Hiring Manager" sortable filter style={{ minWidth: '12rem' }} />
                        <Column field="company_name" header="Company" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="location_name" header="Location" sortable filter style={{ minWidth: '12rem' }} />
                        {/* <Column field="workplace_name" header="Workplace Type" sortable filter style={{ minWidth: '12rem' }} /> */}
                        {/* <Column field="job_type_name" header="Job Type" sortable filter style={{ minWidth: '10rem' }} /> */}
                        <Column field="required_skill_names" header="Primary Skills" sortable filter style={{ minWidth: '12rem' }}
                          body={(rowData) => {
                            const skills = (rowData.required_skill_names || '')?.split(',')?.map(s => s?.trim());
                            return (
                              <span title={skills?.slice(3).join(', ')}>
                                {skills?.slice(0, 3).join(', ')}{skills?.length > 3 ? `, +${skills?.length - 3} more` : ''}
                              </span>
                            );
                          }}
                        />



                        {/* <Column field="required_skill_names" header="Primary Skills" sortable filter style={{ minWidth: '12rem' }} /> */}
                        <Column field="required_experience" header="Experience Required" sortable filter style={{ minWidth: '12rem' }} />
                        {/* <Column field="salary_min" header="Min Salary" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="salary_max" header="Max Salary" sortable filter style={{ minWidth: '10rem' }} /> */}
                        {/* <Column field="department_name" header="Department" sortable filter style={{ minWidth: '10rem' }} /> */}
                        <Column field="job_start_date" header="Start Date" sortable filter style={{ minWidth: '10rem' }}
                          body={(rowData) => rowData.job_start_date ? moment(rowData.job_start_date).format('YYYY-MM-DD') : '-'}
                        />
                        <Column field="job_end_date" header="End Date" sortable filter style={{ minWidth: '10rem' }}
                          body={(rowData) => rowData.job_end_date ? moment(rowData.job_end_date).format('YYYY-MM-DD') : '-'}
                        />
                        {/* <Column field="hiring_goals" header="Hiring Goal" sortable filter style={{ minWidth: '10rem' }} /> */}
                        {/* <Column field="job_function_name" header="Function" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="seniority_name" header="Seniority" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="category_name" header="Category" sortable filter style={{ minWidth: '10rem' }} />
                        <Column field="groups_name" header="Group" sortable filter style={{ minWidth: '10rem' }} /> */}
                        <Column field="created_at" header="Create Date" sortable filter style={{ minWidth: '10rem' }}
                          body={(rowData) =>
                            rowData.created_at && moment(rowData.created_at).isValid()
                              ? moment(rowData.created_at).format('YYYY-MM-DD')
                              : '-'
                          }
                        />
                        <Column field="updated_at" header="Edit Date" sortable filter style={{ minWidth: '10rem' }}
                          body={(rowData) =>
                            rowData.updated_at && moment(rowData.updated_at).isValid()
                              ? moment(rowData.updated_at).format('YYYY-MM-DD')
                              : '-'
                          }
                        />
                      </DataTable>}
                  </div>
                </section>
              </Col>
            </Row>
      ) }
            

            {/* Side bar start */}
            <Row>
              <Col lg={12}>

                <Sidebar visible={jobSidebarVisible} position="right" className="sidebar"   onHide={() => {
   dispatch(setJobSidebarVisible(false));
   resetJob();
   setHiringManager(null);
   setRecruiterManager(null);
   setRecruiters([]);
 }}>
                  <div className="sidebar-header">

                    <h3>Create a Job</h3>
                    <div className="d-flex align-items-center">
                      <Link to="/jobs-editform">
                        <p className="mb-0 text-white"> <i class="fa-regular fa-pen-to-square me-3"></i> </p>
                      </Link>
                      <Button
                        icon="pi pi-times"
                        className="p-button-text close-btn"
                        onClick={() => dispatch(setJobSidebarVisible(false))}
                      />
                    </div>

                  </div>
                  <div className="card sidebardetails">
                          <form onSubmit={handleSubmitJob(onSubmit)}>
                      <Row className="mb-3">

                        {/* <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="jobId" className="p-d-block">Job ID<span className="text-danger">*</span></label>
                            <InputText
                              id="job_number"
                              {...registerJob("job_number", {
                                required: "This field is required",
                                pattern: {
                                  value: /^[a-zA-Z0-9_ -]*$/,
                                  message:
                                    "Please enter valid Job ID ",
                                },
                              })}
                              onKeyUp={() => { triggerJob("job_number") }}
                              placeholder="Job Id"
                              className="p-d-block"
                            />
                            {errorsJob.job_number && (<small id='emailHelp' className='form-text text-danger'>{errorsJob.job_number.message}</small>)}
                          </div>
                        </Col> */}
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="jobTitle" className="p-d-block">Job Title<span className="text-danger">*</span></label>
                            <InputText
                              id="jobTitle"
                              placeholder="Job Title"
                              className="p-d-block"
                              maxLength={50}
                              {...registerJob("jobtitle", {
                                required: "This field is required",
                                 pattern: {
    value: /^[a-zA-Z0-9\s\-().&/]+$/,
    message: "Only letters, numbers, spaces, and these special characters are allowed: - ( ) . & /"
  },
                                minLength: {
                                  value: 1,
                                  message: "Job Title must be at least 1 character",
                                },
                                maxLength: {
                                  value: 50,
                                  message: "Job Title cannot exceed 50 characters",
                                }
                              })}
                              onKeyUp={() => { triggerJob("jobtitle"); seterrorjobs("") }}
                            />
                            {errorsJob.jobtitle && (<small id='emailHelp' className='form-text text-danger'>{errorsJob.jobtitle.message}</small>)}
                          </div>
                        </Col>

                         <Col lg={6}>
                          <label htmlFor="experience">
                            Experience in Years <span className="text-danger">*</span>
                          </label>
                          <InputNumber
                            inputId="experience"
                            value={experience}
                            onValueChange={(e) => {
                              const value = e.value;
                              if (value === null || value === undefined || value === "") {
      setExperience("");
      seterrmsgexperience("");
    }
                              else if (value >= 0) {
                                setExperience(value);
                                seterrmsgexperience("");
                              } else {
                                setExperience(null);
                                seterrmsgexperience("Only positive numbers are allowed");
                              }
                            }}
                            min={0}
                            useGrouping={false}  // disables commas
                            className="w-full activejobdrop"
                          />
                          <small className="text-danger">{errmsgexperience}</small>
                        </Col>

                      </Row>
                      <Row className="mb-3">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Company<span className="text-danger">*</span></label>
                            <Dropdown
                              id="company"
                              value={selectedCompany} // This binds the selected company id
                              options={companies} // This binds the companies array
                              onChange={(e) => { seterrmsgcompanies(""); setSelectedCompany(e.value) }}// Update the selected company id
                              placeholder="Select Company"
                              optionLabel="name" // Display company name
                              optionValue="id" // Use company id as the value for selection
                              filter // Enable search functionality
                              filterBy="name" // Search by company name
                              className="w-full activejobdrop"
                            />
                          </div>
                          <small className="text-danger">{errmsgcompanies}</small>
                        </Col>
                        <Col lg={6}>
  <div className="p-field">
    <label htmlFor="hiringManager">Hiring Manager <span className="text-danger">*</span></label>
    <Dropdown value={hiringManager} onChange={(e) => { setHiringManager(e.value); seterrmsghirring(""); }} options={hiringManagers} optionLabel="name" optionValue="id" placeholder="Select Hiring Manager" filter filterPlaceholder="Search Hiring Manager" className="w-full activejobdrop" showClear={!!hiringManager} />
  </div>
                          <small className="text-danger">{errmsghirring}</small>
                        </Col>
                       
                      </Row>
<Row className="mb-3">
                         <Col lg={6}>
                           <div className="p-field">
                             <label htmlFor="recruiterManager">Recruiter Manager <span className="text-danger">*</span></label>
                             <Dropdown value={recruiterManager} onChange={(e) => { setRecruiterManager(e.value); seterrmsgrecruitermanager(""); }} options={recruiterManagerOptions} optionLabel="name" optionValue="id" placeholder="Select Recruiter Manager" filter filterPlaceholder="Search Recruiter Manager" className="w-full activejobdrop" showClear={!!recruiterManager} />
                           </div>
                           <small className="text-danger">{errmsgrecruitermanager}</small>
                         </Col>
                         <Col lg={6}>
                           <div className="p-field">
                             <label htmlFor="recruiters">Recruiters</label>
                             <MultiSelect value={recruiters} onChange={(e) => { setRecruiters(e.value); seterrmsgrecruiters(""); }} options={recruiterOptions} optionLabel="name" optionValue="id" placeholder="Select Recruiters" filter filterPlaceholder="Search Recruiters" className="w-full activejobdrop" />
                           </div>
                           <small className="text-danger">{errmsgrecruiters}</small>
                         </Col>
                       </Row>
                      <Row className="mb-3">


                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="jobLocation">Job Location</label>
                            <Dropdown
                              value={jobLocationview}
                              onChange={(e) => setJobLocationview(e.value)}
                              options={jobLocations}
                              optionLabel="name" // Display company name
                              optionValue="id" // Use company id as the value for selection
                              filter
                              filterPlaceholder="Search Location"
                              className="w-full activejobdrop"
                              placeholder="Enter job location..."
                            />
                          </div>
                        </Col>

                        <Col lg={6}>

                          {/* <MultiSelect
                            style={{ border: "1px solid #ced4da", borderRadius: "5px", }}
                            id="multiSelect"
                            className="w-full"
                            options={primarySkillsget}
                            value={primarySkillsview}
                            onChange={e => { setprimarySkillsview(e.value) }}
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select skills"
                            display="chip" // Displays selected options as chips
                          /> */}
                          <div className="p-field">
                            <label htmlFor="jobType">UserIDs</label>
                            <InputText
                              value={uniqueUserId}
                              readOnly
                              placeholder="Select a User ID"
                              className="w-full activejobdrop" />
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="hiringManager">Workplace Type</label>
                            <Dropdown
                              id="jobLocation"
                              value={jobworkspace}
                              onChange={(e) => setjobworkspace(e.value)}
                              options={jobworkspaceview}
                              optionLabel="name"
                              optionValue="id"
                              filter
                              filterPlaceholder="Search Workplace Type"
                              className="w-full activejobdrop"
                              placeholder="Enter Workplace Type..."
                            />

                          </div>
                        </Col>

                        <Col lg={6}>
                          <label htmlFor="jobStartDate" className="p-mb-2">Job Start Date</label>
                          <Calendar
                            id="jobStartDate"
                            value={jobStartDate}
                            minDate={new Date()}
                            // onChange={(e) => setJobStartDate(e.value)}
                            onChange={(e) => {
                              setJobStartDate(e.value);
                              // Optional: Reset end date if it becomes invalid
                              if (jobEndDate && e.value && jobEndDate <= e.value) {
                                setJobEndDate(null);
                              }
                            }}
                            dateFormat="yy-mm-dd"
                            placeholder="YYYY-MM-DD"
                            className="w-full activejobdrop"
                          />
                        </Col>

                      </Row>
                      <Row className="mb-3">
                        
                        <Col lg={6}>
                          <label htmlFor="jobEndDate" className="mr-2">Job End Date</label>
                          <Calendar
                            id="jobEndDate"
                            value={jobEndDate}
                            onChange={(e) => setJobEndDate(e.value)}
                            minDate={getMinEndDate()}
                            disabled={!jobStartDate}
                            dateFormat="yy-mm-dd"
                            placeholder="YYYY-MM-DD"
                            className="w-full activejobdrop"
                          />
                        </Col>

                        <Col lg={6}>
                          <label htmlFor="jobStartDate" className="p-mb-2">Time to hire</label>
                          <input type="number"
                            value={timetohire || ''}
                            readOnly
                            className="w-full activejobdrop form-control"
                          />
                        </Col>
                        
                      </Row>

                      {/* <Row className="mb-3">
                        <Col lg={6}>
                          <label htmlFor="jobStartDate" className="p-mb-2">Time to hire</label>
                          <input type="number"
                            value={timetohire || ''}
                            readOnly
                            className="w-full activejobdrop form-control"
                          />
                        </Col>
                        <Col lg={6}>
                          <label htmlFor="jobEndDate" className="mr-2">Actual End date</label>
                          <Calendar
                            value={jobActualEnddate}
                            onChange={(e) => setjobActualEnddate(e.value)}
                            minDate={getMinEndDate()}
                            disabled={!jobStartDate}
                            dateFormat="dd/mm/yy"
                            placeholder="dd/mm/yy"
                            className="w-full activejobdrop"
                          />
                        </Col>
                      </Row> */}

                      <Row className="mb-3">


                        {/* <Dropdown
                                                    id="jobLocation"
                                                    value={primarySkillsview}
                                                    onChange={(e) => setprimarySkillsview(e.value)}
                                                    options={primarySkillsget}
                                                    optionLabel="name"
                                                    optionValue="id"
                                                    filter
                                                    filterPlaceholder="Search Location"
                                                    className="w-full activejobdrop"
                                                    placeholder="Enter job location..."
                                                /> */}
                      </Row>
                      <Row className="mb-2">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Categories </label>
                            <TreeSelect
                              value={selectedNodeKeycat}
                              onChange={(e) => handleCategorySelect(e.value)}
                              options={categoriesitem}
                              placeholder="Select Category"
                              className="w-full"
                              filter
                              selectionMode="single"
                            />

                            {/* <Dropdown
                              value={selectedNodeKeycat}
                              onChange={(e) => handleCategorySelect(e.value)}
                              options={categoriesitem}
                              optionLabel="name"
                              optionValue="id"
                              filter
                              filterPlaceholder="Search Categories"
                              className="w-full activejobdrop"
                              placeholder="Select Item"
                            /> */}
                          </div>
                        </Col >
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Groups</label>
                            <TreeSelect
                              value={selectedgroupKey}
                              onChange={(e) => setselectedgroupKey(e.value)}
                              options={groupitem}
                              placeholder="Select Group"
                              className="w-full"
                              filter
                              selectionMode="single"
                            />
                            {/* <Dropdown
                              value={selectedgroupKey}
                              onChange={(e) => setselectedgroupKey(e.value)}
                              options={groupitem}
                              optionLabel="name"
                              optionValue="id"
                              filter
                              className="w-full activejobdrop"
                              placeholder="Select Item"
                            /> */}
                          </div>
                        </Col>
                      </Row >
                      <Row className="mb-3 d-flex justify-content-between align-items-end">

                        <Col lg={8}>
                          <label htmlFor="jobEndDate" className="mr-2"> Skills</label>
                          <MultiSelect
                            id="primarySkills"
                            value={primarySkillsview}
                            onChange={e => setprimarySkillsview(e.value)} // e.value will be an array of selected IDs
                            options={primarySkillsget}
                            optionLabel="name"
                            optionValue="id"
                            filter
                            display="chip" // optional: shows chips for selected values
                            className="w-full activejobdrop"
                            placeholder="Select primary skills..."
                          />

                        </Col>
                        <Col xl={4}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked3}
                              onChange={handlePopupCheckbox3}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">Private</label>
                          </div>
                        </Col>

                      </Row>
                      <Row className="mb-3 d-flex justify-content-between align-items-end">
                        <Col lg={6}>
                          <div className="">
                            <label htmlFor="descriptionEditor">Description</label>
                          </div>
                        </Col>
                      </Row>


                      <Row className="mb-3">
                        <Col lg={12}>
                          <div className="">
                            <Editor value={text} onTextChange={(e) => setText(e.htmlValue)} headerTemplate={header} style={{ height: '200px' }}
                            // {...registerJob("Description", {
                            //     required: "This field is required",
                            //     // pattern: {
                            //     //     value: /^[a-zA-Z_ ]*$/,
                            //     //     message:
                            //     //         "Please enter valid Job Tittle ",
                            //     // },
                            // })}
                            // onKeyUp={() => { trigger("Description") }}
                            />
                            {/* {errors.Description && (<small id='emailHelp' className='form-text text-danger'>{errors.Description.message}</small>)} */}
                          </div>
                        </Col>
                      </Row>
                      <small className='form-text text-danger'>{errorjobs}</small>

                      <Row>
                        {loading && (
                          <div className="flex justify-content-center align-items-center mt-3">
                            <ProgressSpinner />
                          </div>
                        )}
                      </Row>
                      <Row>
                        <Col>
                          <Button
                            disabled={loading || disable}
                            type="submit"
                            color="primary"
                            className="btn btn-primary  waves-light me-2 sidebarbtn"
                          >
                            Create
                          </Button>
                        </Col>
                      </Row>
                    </form>

                  </div>
                </Sidebar>
              </Col>
            </Row>
            {/* Side bar end */}
          </div>
        </Container>
      </div >

      {/* view page starts */}
      < Row >
        <Col lg={12}>
          <Sidebar visible={visibleViewRight} position="right" onHide={() => { setVisibleViewRight(false); }} className="view-form-sidebar">
            <div className="sidebar-header">
              <h3 className="head"><i className="pi pi-users"></i> Jobs Profile</h3>
              <div className="d-flex align-items-center">
                <Link
                  to={`/jobs-editform?job_id=${deleteRowId}`}
                  className="p-link"
                >
                  <button
                    type="button"
                    className="btn btn-secondary icons-btn ms-1 edit"
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                </Link>
                {/* <Link to="/jobs-editform">
                  <p className="mb-0 text-white"> <i class="fa-regular fa-pen-to-square me-3"></i> </p>
                </Link> */}
                <Button
                  icon="pi pi-times"
                  className="p-button-text close-btn"
                  onClick={() => { setSelectedJobsData([]); setVisibleViewRight(false) }}
                />
              </div>
            </div>
            <TabView className="mt-4">
              <TabPanel header="Pipeline" leftIcon="pi pi-cog mr-2">
                <Row>
                  <Col lg={12} className="d-flex justify-content-end mb-3">
                    <Button 
                      label="Add a Candidate" 
                      onClick={() => {
                        // Get the current active stage from the active tab
                        const currentStage = activePipelineTab || (stages?.length > 0 ? stages[0] : null);
                        // Set the selected job data for the candidate form
                        if (selectedJobsData.length > 0) {
                          handleOpenCandidateForm(selectedJobsData[0]?.job_id, currentStage);
                        } else {
                          // Auto-populate stage even without selected job
                          setFormData(prev => ({
                            ...prev,
                            stage: currentStage
                          }));
                          dispatch(setCandidateSidebarVisible(true));
                        }
                      }} 
                      className="btn btn-primary"
                      style={{ background: 'linear-gradient(90deg, #0e527d, #1a87cb)', border: 'none' }}
                      icon="pi pi-plus"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="pipelinetabs">
                      {stages?.length === 0 ? (
                        <p>Loading stages or no stages available...</p>
                      ) : (
                        <TabView 
                          scrollable 
                          style={{ maxWidth: "1200px", overflow: "hidden" }}
                          activeIndex={stages.indexOf(activePipelineTab)}
                          onTabChange={(e) => {
                            const selectedStage = stages[e.index];
                            setActivePipelineTab(selectedStage);
                          }}
                        >
                          {stages?.map((stage) => (
                            <TabPanel
                              key={stage}
                              header={stage.charAt(0).toUpperCase() + stage.slice(1)}
                              rightIcon={
                                <Badge
                                  value={stageCounts[stage] || 0}
                                  severity="success"
                                  className="ml-2"
                                />
                              }
                              leftIcon="pi pi-cog mr-1"
                            >
                              <Row>
                                <Col lg={12}>
                                  <section className="job-datatable-section">
                                    <div className="card1 mt-3 mb-4 actjobsumtable">
                                      <DataTable
                                        responsive
                                        showGridlines
                                        value={pipelineData[stage] || []}
                                        dataKey="jobid"
                                        tableStyle={{
                                          minWidth: "50rem",
                                          borderRadius: "8px",
                                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                        }}
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[10, 25, 50]}
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        filters={filters[stage] || initFilters}
                                        filterDisplay="row"
                                        emptyMessage={`No ${stage} jobs found.`}
                                        selectionMode="multiple"
                                        selection={selectedJobs[stage] || []}
                                        onSelectionChange={(e) => handlePipelineSelectionChange(stage, e.value)}
                                        resizableColumns
                                        columnResizeMode="expand"
                                      >
                                        <Column selectionMode="multiple" style={{ width: '3em' }} />
                                        <Column
                                          field="stage"
                                          header="Stage"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by stage"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="jobid"
                                          header="Job ID"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by job ID"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="job_title"
                                          header="Job Title"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by job title"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="candidate_name"
                                          header="candidate"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by contact"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="hiring_manager_name"
                                          header="Contact"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by contact"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="company_name"
                                          header="Company"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by contact"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="status"
                                          header="Status"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by status"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="create_date"
                                          header="Create Date"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by create date"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="createdBy"
                                          header="Created by Name"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by user ID"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="user_ids"
                                          header="UserId"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by user ID"
                                          style={{ minWidth: "12rem" }}
                                        />
                                      </DataTable>
                                    </div>
                                  </section>
                                </Col>
                              </Row>
                            </TabPanel>
                          ))}
                        </TabView>
                      )}
                    </div>
                  </Col>
                </Row>
              </TabPanel>
              {/* <TabPanel header="Activities" leftIcon="pi pi-calendar mr-2" >
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={activities}
                          // lazy
                          // paginator 
                          // first={lazyParamsactive.page * lazyParamsactive.rows}
                          // rows={lazyParamsactive.rows} totalRecords={totalRecordsactive}

                          // onPage={onPageChangeactive}
                          loading={loading}
                          paginator
                          rows={5}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={activitiesFilters}
                          filterDisplay="row"
                          emptyMessage="No activities found."
                          selection={selectedActivities}
                          onSelectionChange={(e) => setSelectedActivities(e.value)}
                          selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          
                          <Column field="event_type" header="Type " sortable filter style={{ minWidth: "10rem" }} />
                          <Column field="event_sub_type" header="Sub Type  " sortable filter style={{ minWidth: "10rem" }} />
                          <Column field="event_priority" header="Priority" sortable filter style={{ minWidth: "10rem" }} />
                          <Column field="subject" header="Subject " sortable filter style={{ minWidth: "10rem" }} />
                          <Column field="start_date" header=" Date time  " sortable filter style={{ minWidth: "10rem" }} />
                          <Column field="user_ids" header=" Userid   " sortable filter style={{ minWidth: "10rem" }} />

                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel> */}
              <TabPanel header="Schedule" leftIcon="pi pi-calendar mr-2">
                <style>
                  {`
                    .custom-schedule-dropdown .p-dropdown-label {
                      color: white !important;
                    }
                    .custom-schedule-dropdown:hover .p-dropdown-label {
                      color: black !important;
                    }
                    .custom-schedule-dropdown .p-dropdown-trigger {
                      color: white !important;
                    }
                    .custom-schedule-dropdown:hover .p-dropdown-trigger {
                      color: black !important;
                    }
                  `}
                </style>
            <Row>
              <Col lg={12}>
                <div className="d-flex justify-content-end mb-3">
                   <Dropdown
                    value={selectedScheduleval}
                     onChange={(e) => {
                       setSelectedScheduleval(e.value);
                      if (e.value && e.value.name) {
                       const selectedJob = jobsDataArchirved.find(job => String(job.job_id) === String(deleteRowId));
                         if (selectedJob) {
                           setSelectedJobsData([selectedJob]);
                        }
                        handleScheduleChange(e);
                     }
}}
                    options={actScheduleOptions}
                   optionLabel="name"
                    placeholder="+ Add Schedule"
                    className="md:w-10rem me-2 custom-schedule-dropdown"
                    style={{ 
                      background: 'linear-gradient(90deg, #0e527d, #1a87cb)', 
                      color: 'white', 
                      border: '1px solid #0e527d'
                    }}
                    panelStyle={{ 
                      backgroundColor: 'white',
                      color: '#333'
                    }}
                 />
                 </div>
               </Col>
             </Row>
             <Row>
               <Col lg={12}>
                <section className="job-datatable-section">
                   <div className="card1 mt-3 mb-4 actjobsumtable">
                     <DataTable
                      responsive
                      showGridlines
                      value={activities}
                     paginator
                       rows={5}
                       rowsPerPageOptions={[5, 10, 25, 50]}
                     paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                       currentPageReportTemplate="{first} to {last} of {totalRecords}"
                       filters={activitiesFilters}
                       filterDisplay="row"
                       emptyMessage="No schedules found."
                       resizableColumns
                       columnResizeMode="expand"
                     >
                       <Column field="event_type" header="Type" sortable filter style={{ minWidth: "10rem" }} />
                       <Column field="event_sub_type" header="Sub Type" sortable filter style={{ minWidth: "10rem" }} />
                       <Column field="event_priority" header="Priority" sortable filter style={{ minWidth: "10rem" }} />
                       <Column field="subject" header="Subject" sortable filter style={{ minWidth: "10rem" }} />
                       <Column field="start_date" header="Date Time" sortable filter style={{ minWidth: "10rem" }}
                         body={(rowData) => rowData.start_date ? moment(rowData.start_date).format('YYYY-MM-DD HH:mm') : '-'}
                       />
                      <Column field="user_ids" header="User ID" sortable filter style={{ minWidth: "10rem" }} />
                   <Column field="status" header="Status" sortable filter style={{ minWidth: "10rem" }} 
                        body={(rowData) => (
                          <span className={`badge ${rowData.completed ? 'bg-success' : 'bg-warning'}`}>
                            {rowData.completed ? 'Completed' : 'Pending'}
                          </span>
                        )}
                      />
                    </DataTable>
               </div>
                 </section>
               </Col>
             </Row>
           </TabPanel>
              <TabPanel header="History" leftIcon="pi pi-clock mr-2" >
                <Row>
                  <Col lg={12} sm={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={history}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={5}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={historyFilters}
                          filterDisplay="row"
                          globalFilterFields={[
                            "type",
                            "sub_type",
                            "priority",
                            "subject",
                            "date_time",
                            "user_id",
                          ]}
                          emptyMessage="No history found."
                          selection={selectedHistory}
                          onSelectionChange={(e) => setSelectedHistory(e.value)}
                          selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          {/* <Column selectionMode="multiple" headerStyle={{ width: "3em" }} /> */}
                          <Column
                            field="type"
                            header="Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="sub_type"
                            header="Sub Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="priority"
                            header="Priority"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column field="datetime" header="Date and Time" sortable filter style={{ minWidth: '10rem' }}
                            body={(rowData) => moment(rowData.datetime).format('YYYY-MM-DD HH:mm')} />

                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Notes" leftIcon="pi pi-pencil mr-2" className="nav-items">
                <Row>
                  <Col lg={12}>
                    <div className="d-flex justify-content-end">
                      <Button
                        type="button"
                        label="Add Notes"
                        icon="pi pi-plus"
                        className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                        onClick={handleAddNotes}
                      />
                    </div>
                  </Col>
                </Row>

                {isEditorVisible && (
                  <Row className="mt-4">
                    <Col lg={12}>
                      <Editor
                        value={editorContent}
                        onTextChange={(e) => setEditorContent(e.htmlValue)}
                        style={{ height: '200px' }}
                        placeholder="Enter your notes here..."
                      />
                      <div className="d-flex justify-content-end mt-2">
                        <Button
                          type="button"
                          label="Save"
                          icon="pi pi-save"
                          className="btn btn-success me-2"
                          onClick={handleSaveNotes}
                        />
                        <Button
                          color="primary"
                          className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                          onClick={handleCancelNotes}
                        >
                          <i className="pi pi-times me-1"></i>
                          Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}

                <Row className="mt-4 notes">
                  <Col lg={12}>



                    {candidateNotes.length > 0 && (
                      <Card className="pt-0 pb-0">
                        {candidateNotes?.map((note, index) => (
                          <div key={index}>
                            <div className="d-flex mt-0">
                              <h5 className="mr-2">Note:</h5>
                              <strong className="text-muted me-4">{note.created_by_name}</strong>
                              {/* <strong className="text-muted">{stripHtml(note.notes)}</strong> */}
                              <strong className="text-muted ms-2">
                                {note.created_at ? moment(note.created_at).format('YYYY-MM-DD hh:mm A') : ''}
                              </strong>
                            </div>
                            <div className="d-flex justify-content-between mt-2 mb-0">
                              <div dangerouslySetInnerHTML={{ __html: note.notes }} />
                              <div>
                                <Button
                                  icon="pi pi-pencil"
                                  className="btn btn-warning editbtn p-0"
                                  onClick={() => { handleEditNote(index); setEditId(note.note_id); setisEdited(true);; onloadvalues(note.notes); }}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  className="btn btn-danger deletebtn"
                                  onClick={() => { handleDeleteNote(note.note_id); }}
                                />
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                      </Card>
                    )}
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Job Details" leftIcon="pi pi-user mr-2">
                <Row>
                  <Col lg={12}>
                    <form onSubmit={handleSubmitView(onSubmitView)}>
                      <Accordion activeIndex={0}>
                        <AccordionTab
                          header={
                            <span className="flex align-items-center gap-2 w-full">
                              <span className="white-space-nowrap">JOB INFORMATION</span>
                              <Badge value="-" className="ml-auto" />
                            </span>
                          }
                        >
                          <Row className="mb-2">
                            <Col lg={4}>
                              <Controller name="job_id" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="job_id" className="block">Job ID</label>
                                  <InputText id="job_id" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                            <Col lg={4}>
                              <Controller name="job_title" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="job_title" className="block">Job Title</label>
                                  <InputText id="job_title" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                            <Col lg={4}>
                              <Controller name="company_name" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="company_name" className="block">Company</label>
                                  <InputText id="company_name" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                          </Row>

                          <Row className="mb-2">
                            <Col lg={4}>
                              <Controller name="hiring_manager_name" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="hiring_manager_name" className="block">Hiring Manager</label>
                                  <InputText id="hiring_manager_name" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                            <Col lg={4}>
                              <Controller name="experience" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="experience" className="block">Experience (Years)</label>
                                  <InputNumber id="experience" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                            <Col lg={4}>
                              <Controller name="location" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="location" className="block">Job Location</label>
                                  <InputText id="location" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                          </Row>

                          <Row className="mb-2">
                            <Col lg={4}>
                              <Controller name="workplace_name" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="workplace_name" className="block">Workplace Type</label>
                                  <InputText id="workplace_name" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                            <Col lg={4}>
                              <Controller name="job_start_date" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="job_start_date" className="block">Job Start Date</label>
                                  <InputText id="job_start_date" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                            <Col lg={4}>
                              <Controller name="job_end_date" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="job_end_date" className="block">Job End Date</label>
                                  <InputText id="job_end_date" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                          </Row>

                          <Row className="mb-2">
                            <Col lg={4}>
                              <Controller
                                name="required_skill_names"
                                control={controlView}
                                render={({ field }) => (
                                  <div className="p-field">
                                    <label htmlFor="required_skill_names" className="block">Primary Skills</label>
                                    <InputText
                                      id="required_skill_names"
                                      className="block w-full"
                                      value={field.value?.split(',').slice(0, 3).join(', ') + (field.value?.split(',').length > 3 ? `, +${field.value.split(',').length - 3} more` : '')}
                                      title={field.value?.split(',').slice(3).join(', ')}
                                      disabled
                                    />
                                  </div>
                                )}
                              />
                            </Col>
                            <Col lg={4}>
                              <Controller name="category_name" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="category_name" className="block">Categories</label>
                                  <InputText id="category_name" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                            <Col lg={4}>
                              <Controller name="groups_name" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="groups_name" className="block">Groups</label>
                                  <InputText id="groups_name" className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                          </Row>

                          <Row className="mb-2">
                            <Col lg={12}>
                              <Controller name="job_description" control={controlView} render={({ field }) => (
                                <div className="p-field">
                                  <label htmlFor="job_description" className="block">Job Description</label>
                                  <InputTextarea id="job_description" rows={6} className="block w-full" {...field} disabled />
                                </div>
                              )} />
                            </Col>
                          </Row>
                        </AccordionTab>
                        <AccordionTab
                          header={
                            <span className="flex align-items-center gap-2 w-full">
                              {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/onyamalimba.png" shape="circle" /> */}
                              <span className="white-space-nowrap">DOCUMENTS</span>
                              <Badge value="-" className="ml-auto" />
                            </span>
                          }
                        >
                          <Row>
                            <Col lg={12}>
                              <div className="doc-table">


                                <DataTable value={documents} dataKey="document_id" tableStyle={{ minWidth: "60rem" }}>
                                  <Column
  field="document_type_name"
  header="Document Type"
  body={(rowData) => {
    // If editing, show the dropdown
    if (editingId === rowData.document_type_name) {
      return editableTemplate(rowData, "document_type_name");
    }
    // Always show the name, not the ID
    const docTypeObj = allDocumentTypes.find(
      dt => String(dt.id) === String(rowData.document_type)
    );
    return docTypeObj ? docTypeObj.name : rowData.document_type_name || "";
  }}
/>
                                  <Column
                                    field="document_subject"
                                    header="Document Subject"
                                    body={(rowData) => editableTemplate(rowData, "document_subject")}
                                  />
                                  <Column
                                    field="created_at" header="Applied Date & Time" body={(rowData) => rowData.created_at ? moment(rowData.created_at).format('YYYY-MM-DD hh:mm A ') : ''} />
                                  <Column
                                    field="attachment"
                                    header="Attachments"
                                    body={(rowData) => attachmentTemplate(rowData)}
                                  />
                                  <Column
                                    header="Actions"
                                    headerClassName="w-10rem"
                                    body={actionTemplate}
                                  />
                                </DataTable>



                              </div>
                            </Col>
                          </Row>
                        </AccordionTab>

                      </Accordion>
                    </form>
                  </Col>
                </Row>
              </TabPanel>
            </TabView>

          </Sidebar>
        </Col>
      </Row >

      {/* view page ends */}

      {/* Interview schedule start */}
      <Dialog header={intertype}
        // header="APPOINTMENT "
        visible={interviewpop}
        className="interview-popup"
        style={{ width: '50vw' }}
        onShow={resetDefaultDateTime}
        // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
        onHide={() => { SetInterviewpop(false); setSelectedScheduleval("") }}
      >
        <form onSubmit={handleSubmit3(onsubmitSedules)}>

          <p className="bg-form">
            <div className="mb-4">
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="interview">Type<span className="text-danger">*</span></label>
                    <InputText disabled={isTypeDisabled}
                      value={intertype}
                      placeholder="Type" />

                  </div>
                </Col>

                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label
                      htmlFor="integer"
                      className=" block"
                    >
                      Sub-Type
                    </label>
                    <Dropdown
                      value={subtype}
                      onChange={(e) => { setSubtype(e.value); setsubTypeinterview("") }}
                      options={typeInterview}
                      optionLabel="name"
                      // optionValue="id"
                      placeholder="Subtype"
                      className="w-full search-option"
                    />
                  </div>
                  {/* <small className='text-danger'>{subTypeinterview}</small> */}
                </Col>

              </Row>

              <Row>
                <Col xl={6}>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <div className="p-field flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          Start date<span className="text-danger">*</span>
                        </label>
                        <Calendar
                          value={startdate}
                          onChange={(e) => {
                            setStartdate(e.value);
                            setstartdateinterview("");
                            if (enddate && e.value && enddate <= e.value) {
                              setenddate(e.value);
                            }
                          }}
                          minDate={new Date()} // Allow today and future
                          showIcon
                          dateFormat="yy-mm-dd"
                          placeholder="YYYY-MM-DD"
                        />
                      </div><small className='text-danger'>{startdateinterview}</small>
                    </Col>


                    <Col xl={6}>
                      <div className="p-field flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          Start Time<span className="text-danger">*</span>
                        </label>
                        <Calendar
                          value={starttime}
                          onChange={(e) => {
                            const selectedTime = e.value;
                            setStarttime(selectedTime);
                            setstarttimeinterview("");
                            if (selectedTime) {
                              const endDateTime = new Date(selectedTime.getTime() + 30 * 60000);
                              setendtime(endDateTime);
                              setenddate(new Date(endDateTime.getFullYear(), endDateTime.getMonth(), endDateTime.getDate()));
                              setsendtimeinterview("");
                            }
                          }}
                          showIcon
                          timeOnly
                          icon={() => <i className="pi pi-clock" />}
                        />
                      </div><small className='text-danger'>{starttimeinterview}</small>
                    </Col>

                  </Row>
                </Col>


                <Col xl={6}>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          End date<span className="text-danger">*</span>
                        </label>
                        <Calendar
                          value={enddate}
                          minDate={
                            startdate
                              ? new Date(new Date(startdate).setDate(new Date(startdate).getDate()))
                              : null
                          } // Only after start date
                          disabled={!startdate}
                          onChange={(e) => {
                            setsenddateinterview("");
                            setenddate(e.value);
                          }}
                          showIcon
                          dateFormat="yy-mm-dd"
                          placeholder="YYYY-MM-DD"
                        />
                      </div><small className='text-danger'>{senddateinterview}</small>
                    </Col>


                    <Col xl={6}>

                      <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          End Time<span className="text-danger">*</span>
                        </label>

                        <Calendar
                          value={endtime}
                          onChange={(e) => { setsendtimeinterview(""); setendtime(e.value) }}
                          showIcon
                          timeOnly
                          icon={() => <i className="pi pi-clock" />}
                        />
                      </div>  <small className='text-danger'>{sendtimeinterview}</small>
                    </Col>

                  </Row>
                </Col>
              </Row>


            </div>


            <div className="mb-4">
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="field">
                    <label htmlFor="job" className="block mb-0">
                      Jobs
                    </label>
                    <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                      <InputText
                        value={selectedJobTitles}
                        onChange={(e) => setSelectedJobTitles(e.target.value)}
                        placeholder={selectedJobsData.length > 0 ? usersList : 'Select job'}
                        className="w-full"
                        style={{ paddingRight: '2rem' }}
                        readOnly
                      />
                      <i
                        className="pi pi-chevron-down"
                        onClick={handleIconClickjob}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer'
                        }}
                      ></i>
                    </div>

                    <Dialog
                      header="Job Details"
                      visible={jobDetailsVisiblelist}
                      onHide={() => setjobDetailsVisiblelist(false)}
                      style={{ width: '40vw' }}
                      breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                    >
                      <Row>
                        <Col lg={12}>
                          <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                            <InputText
                              placeholder="Search Jobs"
                              value={searchText1}
                              onInput={(e) => setSearchText1(e.target.value)}
                              style={{ paddingRight: '2rem' }}
                            />
                            <i
                              className="pi pi-search"
                              style={{
                                position: 'absolute',
                                right: '10px',
                                top: '49%',
                                transform: 'translateY(-50%)',
                              }}
                            ></i>
                          </div>
                        </Col>
                      </Row>

                      <DataTable
                        value={filterDatalinkjOB(filteredJobslink)}
                        selection={selectedJobListname}
                        // onSelectionChange={(e) => setSelectedJobsDataAcrhid(e.value)}
                        onSelectionChange={setSelectedJobsDataAcrhid}
                        dataKey="job_id"
                        paginator
                        lazy
                        first={lazyParamsjob1.page * lazyParamsjob1.rows}
                        rows={lazyParamsjob1.rows}
                        totalRecords={totalRecordsjob1}
                        onPage={onPageChangejob1}
                        loading={loading}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 50, totalRecordsjob1]}
                        size="small"
                      >
                        <Column selectionMode="multiple" style={{ width: '3em' }} />
                        <Column field="job_number" header="Job ID" />
                        <Column field="job_title" header="Job Title" />
                      </DataTable>

                      <div className="d-flex mt-3">
                        <button
                          type="submit"
                          className="btn btn-primary me-2 btn-main"
                          onClick={() => setjobDetailsVisiblelist(false)}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary btn-main"
                          onClick={handleRefreshlinkjobs}
                        >
                          Refresh
                        </button>
                      </div>
                    </Dialog>
                    <small className="text-danger">{jobinterview}</small>
                  </div>
                </Col>

                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label For="Priority" className=" block">
                      Contact
                    </label>
                    <MultiSelect
 value={Array.isArray(prioritycontact) ? prioritycontact : []}
  onChange={e => { condidatelist(e) }}
  options={Array.isArray(typeInterviewcontact) ? typeInterviewcontact : []}
  optionLabel="name"
  optionValue="id"
  placeholder="Select Contact"
  className="w-full"
/>
                    {/* <Dropdown
                      value={prioritycontact}
                      onChange={(e) => setprioritycontact(e.value)}
                      options={typeInterviewcontact}
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Contact"
                      className="w-full search-option"
                    /> */}
                  </div> <small className='text-danger'>{contactinterview}</small>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <div className="field">
                      <label htmlFor="candidateDetail" className="block mb-0">Candidate Details </label>
                      <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                        <InputText
                          id="candidateDetail"
                          value={selectedCandidateNames}
                          // onChange={(e) => setSelectedCandidateNames(e.target.value)}
                          placeholder="Enter Candidate"
                          className="w-full"
                          style={{ paddingRight: '2rem' }} // Ensure space for the icon
                        />
                        <i
                          className="pi pi-chevron-down"
                          onClick={handleIconClick}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer'
                          }}
                        ></i>

                      </div>
                      <small className='text-danger'>{errorcondidate}</small>

                      <Dialog
                        header="Candidate Details"
                        visible={candidateDetailsVisible}
                        onHide={() => setCandidateDetailsVisible(false)}
                        style={{ width: '40vw' }}
                        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                      >
                        {/* Search Bar */}
                        <Row>
                          <Col lg={12}>
                            <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                              <InputText
                                placeholder="Search Candidates"
                                value={searchText}
                                onInput={(e) => { seterrlinkjob(""); setSearchText(e.target.value) }}
                                style={{ paddingRight: '2rem' }}
                              />
                              <i
                                className="pi pi-search"
                                style={{
                                  position: 'absolute',
                                  right: '10px',
                                  top: '49%',
                                  transform: 'translateY(-50%)',
                                }}
                              ></i>
                            </div>
                          </Col>
                        </Row>

                        {/* DataTable */}
                        <DataTable
                          // value={submitcondidatelist}
                          value={filterDatalinkCONDI(filteredcaondidates)}
                          lazy
                          paginator first={lazyParamssub1.page * lazyParamssub1.rows}
                          rows={lazyParamssub1.rows}
                          totalRecords={totalRecordssub1}
                          onPage={onPageChangesub1}
                          loading={loading}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, totalRecordssub1]}
                          selection={selectedJobslink}
                          onSelectionChange={handleSelectionChangejoblink}
                          dataKey="candidate_id"
                          size="small"
                        >
                          <Column selectionMode="multiple" style={{ width: '3em' }} />
                          <Column body={fullNameTemplate} header="Full name" />
                          <Column field="designation" header="Designation" />
                          <Column field="current_company" header="Company" />
                        </DataTable>

                        {/* Actions */}
                        <div className="d-flex  mt-3">
                          <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSavelink}>Save</button>
                          <button type="button" className="btn btn-primary btn-main" onClick={handleRefreshlink}>Refresh</button>
                        </div>
                      </Dialog>
                    </div>
                    {/* <MultiSelect
                      value={condidatevalu}
                      onChange={e => { condidatelist(e); setcandidateinterview("") }}
                      options={typeInterviewcondi}
                      optionLabel="name"
                      optionValue="id"
                      placeholder={`Select Candidates`}
                      maxSelectedLabels={0}
                      className="w-full" /> */}
                    {/* <Dropdown
                      value={condidatevalu}
                      onChange={e => setcondidatevalu(e.value)}
                      options={typeInterviewcondi}
                      optionLabel="name"
                      placeholder="Select a Status"
                      className="w-full search-option"
                    /> */}
                  </div>
                  <small className='text-danger'>{candidateinterview}</small>
                </Col>
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="username">Subject</label>
                    <InputText placeholder="" value={subjectval}
                      onChange={e => { setsubjectinterview(""); setsubjectval(e.target.value) }} />
                  </div>
                  {/* <small className='text-danger'>{subjectinterview}</small> */}
                </Col>
              </Row>

              <Row className="mb-2 mt-3">
                <Col xl={12}>
                  <div className="">
                    <InputTextarea
                      className="w-full"
                      value={popTextares}
                      onChange={(e) => { setpopTextaresinterview(""); setPopTextares(e.target.value) }}
                      placeholder="Interview Test"
                      rows={3}
                      cols={20}
                    />
                  </div>

                </Col>
              </Row>
            </div>
            <div>

              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label
                          For="Priority"
                          className=" block"
                        >
                          Priority
                        </label>
                        <Dropdown
                          value={priority}
                          onChange={(e) => { setpriorityinterview(""); setPriority(e.value) }}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="Priority"
                          className="w-full search-option"
                        />
                      </div>
                      {/* <small className='text-danger'>{priorityinterview}</small> */}
                    </Col>
                    <Col xl={6}>

                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked}
                              onChange={handlePopupCheckbox}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">Completed</label>

                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">Private</label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6}>
                  <label htmlFor="username">User Id's</label>
                  {/* <Chips value={userid} onChange={(e) => setUserid(e.value)} itemTemplate={customChip} className="w-full" /> */}
                  <InputText
                    value={uniqueUserId}
                    readOnly
                    placeholder="Select a User ID"
                    className="w-full activejobdrop" />
                </Col>
              </Row>
            </div>



            < Row className="mb-2">
              {callingtask ? <> <Col xl={4}>
                <div className="p-field">
                  <label htmlFor="followup">Auto Followup</label>
                  <Dropdown
                    value={followup}
                    onChange={(e) => {
                      setfollowuperr("");
                      setFollowup(e.value);
                    }}
                    options={followupOptions}
                    optionLabel="name"
                    placeholder="Select a Followup Interval"
                    className="w-full search-option"
                  />
                  {/* <small className="text-danger">{followuperr}</small> */}
                </div>
              </Col>

                <Col xl={4}>
                  <div className="p-field">
                    <label htmlFor="repeat">Repeat</label>
                    <Dropdown
                      value={repeat}
                      onChange={(e) => {
                        setrepeaterr("");
                        setRepeat(e.value);
                      }}
                      options={repeatOptions}
                      optionLabel="name"
                      placeholder="Select a Repeat Option"
                      className="w-full search-option"
                    />
                    {/* <small className="text-danger">{repeaterr}</small> */}
                  </div>
                </Col></> : ""}

              <Col xl={4}>
                <div className="p-field">
                  <label htmlFor="reminder">Reminder</label>
                  <select
                    value={reminder}
                    onChange={(e) => {
                      setremindererr(""); setReminder(e.target.value);
                    }}
                    className="form-control"

                  >
                    <option value="10 minutes">10 mins</option>
                    <option value="20 minutes">20 mins</option>
                    <option value="30 minutes">30 mins</option>
                  </select>
                </div>
                {/* <Dropdown
                    value={reminder}
                    options={reminderOptions}
                    onChange={(e) => { setremindererr(""); setReminder(e.value); }}
                    optionLabel="name"
                    placeholder="Select a Reminder"
                    className="w-full search-option"
                  /> */}
                {/* <small className="text-danger">{remindererr}</small> */}

              </Col>
            </Row>


            <Row className="mt-2">
              <Col xl={12}>
                <div className="d-flex justify-content-end">
                  <button type="submit" class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main">
                    <i className="pi pi-save me-1"></i>
                    Save
                  </button>
                  <button color="primary" type="button" className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn" onClick={() => { setSelectedScheduleval(""); SetInterviewpop(false); }}>
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>



          </p>
        </form>
      </Dialog>
      {/* Interview schedule end */}

      {/* more */}
      <Dialog header={jobidsslectnames?.length > 0 ? jobidsslectnames : "No Jobs Selected"}
        visible={visibleLinkCandidate} onHide={() => { setSelectedScheduleOption(""); setVisibleLinkCandidate(false) }}
        style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
        <form onSubmit={handleSubmit4(onSubmitlinkcond)}>  <Row>
          <Col lg={6}>
            <div className="field">
              <label htmlFor="job" className="block mb-0">
                Job
              </label>
              <MultiSelect
                value={joblinkcon}
                onChange={e => { jobslist(e) }}
                options={typeInterviewcondirec}
                optionLabel="name"
                optionValue="id"
                placeholder={`Select Jobs`}
                disabled
                className="w-full" />

            </div>
          </Col>
          <Col lg={6}>
            <div className="field">
              <label htmlFor="candidateDetail" className="block mb-0">Candidate Details<span className="text-danger">*</span> </label>
              <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                <InputText
                  id="candidateDetail"
                  value={selectedCandidateNames}
                  // onChange={(e) => setSelectedCandidateNames(e.target.value)}
                  placeholder="Enter Candidate"
                  className="w-full"
                  style={{ paddingRight: '2rem' }} // Ensure space for the icon
                />
                <i
                  className="pi pi-chevron-down"
                  onClick={handleIconClick}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer'
                  }}
                ></i>

              </div>
              <small className='text-danger'>{errorcondidate}</small>

              <Dialog
                header="Candidate Details"
                visible={candidateDetailsVisible}
                onHide={() => setCandidateDetailsVisible(false)}
                style={{ width: '40vw' }}
                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
              >
                {/* Search Bar */}
                <Row>
                  <Col lg={12}>
                    <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                      <InputText
                        placeholder="Search Candidates"
                        value={searchText}
                        onInput={(e) => { seterrlinkjob(""); setSearchText(e.target.value) }}
                        style={{ paddingRight: '2rem' }}
                      />
                      <i
                        className="pi pi-search"
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '49%',
                          transform: 'translateY(-50%)',
                        }}
                      ></i>
                    </div>
                  </Col>
                </Row>

                {/* DataTable */}
                <DataTable
                  // value={submitcondidatelist}
                  value={filterDatalinkCONDI(filteredcaondidates)}
                  lazy
                  paginator first={lazyParamssub1.page * lazyParamssub1.rows}
                  rows={lazyParamssub1.rows}
                  totalRecords={totalRecordssub1}
                  onPage={onPageChangesub1}
                  loading={loading}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  rowsPerPageOptions={[10, 20, 50, totalRecordssub1]}
                  selection={selectedJobslink}
                  onSelectionChange={handleSelectionChangejoblink}
                  dataKey="candidate_id"
                  size="small"
                >
                  <Column selectionMode="multiple" style={{ width: '3em' }} />
                  <Column body={fullNameTemplate} header="Full name" />
                  <Column field="designation" header="Designation" />
                  <Column field="current_company" header="Company" />
                </DataTable>

                {/* Actions */}
                <div className="d-flex  mt-3">
                  <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSavelink}>Save</button>
                  <button type="button" className="btn btn-primary btn-main" onClick={handleRefreshlink}>Refresh</button>
                </div>
              </Dialog>
            </div>
            <small className='form-text text-danger'>{errlinkjob}</small>
          </Col>
        </Row>
          <Row>
            <Col lg={6}>
              <div className="field">
                <label htmlFor="currentDateTime" className="block mb-0">
                  Date
                </label>
                <Calendar
                  id="currentDateTime"
                  value={currentDateTime}
                  onChange={handleChange}
                  onSelect={handleSelect}
                  showTime
                  showIcon
                  dateFormat="yy-mm-dd"
                  hourFormat="12"
                  readOnlyInput
                  className="w-full"
                  ref={calendarRef}

                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="field">
                <label htmlFor="userId" className="block mb-0">
                  User IDs
                </label>
                <InputText
                  id="userId"
                  value={uniqueUserId}
                  readOnly
                  className="w-full"
                  placeholder="User ID"
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="field">
                <label htmlFor="subject" className="block mb-0">
                  Subject
                </label>
                <InputText
                  id="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="w-full"
                  placeholder=""
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="field">
                <label htmlFor="notes" className="block mb-0">
                  Notes
                </label>
                <InputTextarea
                  id="notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  rows={3}
                  cols={20}
                  className="w-full"
                  placeholder="Enter your notes here..."
                  autoResize
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-primary me-2 btn-main">Ok</button>
                <button
                  color="primary"
                  type="button"
                  className="btn btn-primary me-2 cancel-outlinebtn"
                  onClick={() => { setSelectedScheduleOption(""); setVisibleLinkCandidate(false) }}
                >
                  <i className="pi pi-times me-1"></i>
                  Cancel
                </button>
              </div>
            </Col>
          </Row>
        </form>
      </Dialog>




      <Modal size="md" show={smShow} onHide={() => setSmShow(false)} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Archived</h1></Modal.Header>
        <div className="text-center m-3 text-danger">  </div>
        <h4 className="text-center"> Are you sure you want to Archive </h4>
        <div className="text-center m-3">
          <Button className="btn btn-primary m-1" onClick={() => setSmShow(false)} >Cancel</Button>
          <button className="btn btn-primary m-1" onClick={archivedHandler}> Archive </button>
        </div>
      </Modal>
      <Modal size="md" show={smShowun} onHide={() => setSmShowun(false)} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> UnArchived</h1></Modal.Header>
        <div className="text-center m-3 text-danger">  </div>
        <h4 className="text-center"> Are you sure you want to UnArchived </h4>
        <div className="text-center m-3">
          <Button className="btn btn-primary m-1" onClick={() => setSmShowun(false)} >Cancel</Button>
          <button className="btn btn-primary m-1" onClick={unarchivedHandler}> UnArchive </button>
        </div>
      </Modal>
      <Modal size="md" show={smShowmatchcond} onHide={() => { setSelectedScheduleOption(""); setsmShowmatchcond(false) }} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Candidate</h1></Modal.Header>
        <div className="text-center m-3 text-danger">  </div>
        <h4 className="text-center"> Are you sure you want to Match Candidate </h4>
        <div className="text-center m-3">
          <Button className="btn btn-primary m-1" onClick={() => { setSelectedScheduleOption(""); setsmShowmatchcond(false) }}>Cancel</Button>
          <button className="btn btn-primary m-1" onClick={matchcandidateHandler}>Match Candidate </button>
        </div>
      </Modal>

      <Modal size="md" show={smShowdele} onHide={() => { setSelectedScheduleOption(""); setSmShowdele(false) }} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
        <div className="text-center m-3 text-danger">  </div>
        <h4 className="text-center"> Are you sure you want to delete this Job </h4>
        <div className="text-center m-3">
          <Button className="btn btn-primary m-1" onClick={() => { setSelectedScheduleOption(""); setSmShowdele(false) }} >Cancel</Button>
          <button className="btn btn-primary m-1" onClick={deleteHandler}> Delete </button>
        </div>
      </Modal>
      <Modal size="md" show={successAlert} onHide={() => setSuccessAlert(false)} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
        <div className="text-center m-3"> </div>
        <h4 className="text-center">Deleted  Successfully</h4>
        <div className="text-center m-3">
          <button className="btn btn-primary" onClick={() => setSuccessAlert(false)} > OK </button>
        </div>
      </Modal>
      <Modal size="md" show={successMatch} onHide={() => setsuccessMatch(false)} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
        <div className="text-center m-3"> </div>
        <h4 className="text-center">{success}Successfully </h4>
        <div className="text-center m-3">
          <button className="btn btn-primary" onClick={() => setsuccessMatch(false)} > OK </button>
        </div>
      </Modal>

      {/* change status starts */}

      <Dialog
        header="Change Status"
        visible={changeStatusAction}
        onHide={() => { setSelectedScheduleOption(""); setChangeStatusAction(false) }}
        style={{ width: '30vw' }}
        className="changestatus-popup"
      >
        {/* Search Bar */}
        <form onSubmit={handleSubmit1(onSubmitJobStatus)}>
          <Row className="mt-2 align-items-center">
            <Col xl={2}>
              <label className="block mb-2">
                Status
              </label>
            </Col>
            <Col xl={10}>
              <div className="card flex justify-content-center mb-0 border-0">
                <select
                  className='form-select profileDetailsInput'
                  id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                  {...register1("arcStatus", {
                    required: "This field is required",
                  })}
                  onKeyUp={() => { trigger1("arcStatus"); }}
                >
                  <option value="">-- Select Status --</option>
                  {jobStatusOptions?.map((status) => (
                    <option key={status?.id} value={status?.id}>
                      {status?.job_status}
                    </option>
                  ))}
                </select>
                {errors1.arcStatus && (<small id='emailHelp' className='form-text text-danger'>{errors1.arcStatus.message}</small>)}
              </div>
            </Col>
          </Row>

          <div className="d-flex justify-content-end  mt-4">
            <button type="submit" class="btn btn-primary btn-main">Submit</button>
          </div>
        </form>
      </Dialog>

      {/* chnage status ends */}

      {/* assign recruiters starts */}
      <Dialog
        header="Assign Recruiters"
        visible={assignRecruitersAction}
        onHide={() => setAssignRecruitersAction(false)}
        style={{ width: '30vw' }}
        className="changestatus-popup"
      >
        <form onSubmit={onSubmitAssignRecruiters}>
          <Row className="mt-2 align-items-center">
            <Col xl={12}>
              <MultiSelect
                value={selectedRecruiters}
                onChange={(e) => setSelectedRecruiters(e.value)}
                options={recruiterOptions}
                optionLabel="name"
                optionValue="id"
                placeholder="Select Recruiters"
                className="w-full"
                filter
                filterPlaceholder="Search Recruiters"
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-end mt-4">
            <button type="submit" className="btn btn-primary btn-main">Submit</button>
          </div>
        </form>
      </Dialog>
      {/* assign recruiters ends */}

      {/* attachements starts */}

      <Dialog
        header="Attachments"
        visible={isAttachDocumentVisible}
        onHide={() => { setSelectedScheduleOption(""); setIsAttachDocumentVisible(false),seterrorsmg("");
  setErrorDocumentType("");
  setErrorDocSubject("");
  setErrorFile(""); }}
        style={{ width: '45vw' }}
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
      >
        <form onSubmit={handleSubmit2(onSubmitAttachment)}>
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="card flex justify-content-center mb-0 border-0">
                <label className="block mb-2">
                  Document Type<span style={{ color: "red" }}>*</span>
                </label>
                <Dropdown
                  value={selectedDocumentType}
                  onChange={(e) => { seterrorsmg(""); setSelectedDocumentType(e.value) }}
                  options={documentTypes}
                  optionLabel="name" // Display the "name" property in the dropdown
                  optionValue="id"
                  placeholder="Select a Document Type"
                  className="w-full bgclr"
                />
                {errorDocumentType && <small style={{ color: "red" }}>{errorDocumentType}</small>}
              </div>
            </Col>

            <Col lg={6}>
              <div className="p-field mt-2">
                <label htmlFor="docSubject" className="block">Document Subject<span style={{ color: "red" }}>*</span></label>
                <InputText
                  id="docSubject"
                  value={docSubject}
                  onChange={(e) => { seterrorsmg(""); setDocSubject(e.target.value) }}
                  placeholder=""
                  className="p-inputtext-sm w-full"
                />
                {errorDocSubject && <small style={{ color: "red" }}>{errorDocSubject}</small>}
              </div>
            </Col>

            <Col lg={12}>
              <div className="card flex justify-content-center mb-0 border-0 mt-2">
                <label className="block mb-2"                                  >
                  Attach Documents<span style={{ color: "red" }}>*</span>
                </label>
                <FileUpload
                  ref={fileUploadRef}
                  name="demo[]"
                  multiple
                  accept=".pdf,.doc,.docx"
                  customUpload
                  auto
                  onSelect={handleFileChange1}
                  itemTemplate={(file, props) => {
                    // Format the size in KB
                    const sizeInKB = (file.size / 1024).toFixed(2) + ' KB';

                    return (
                      <div className="w-full flex justify-content-between p-2 border-round-sm">
                        <div>
                          <div>{file.name}</div>
                          <small>{sizeInKB}</small>
                        </div>
                        <Button
                          icon="pi pi-times"
                          className="p-button-rounded p-button-text"
                          onClick={() => props.onRemove(file)}
                        />
                      </div>
                    );
                  }}
                />
              </div>
{errorFile && <small style={{ color: "red" }}>{errorFile}</small>}
        {errorsmg && <p style={{ color: "red" }}>{errorsmg}</p>}
            </Col>
            {errorsmg && <p style={{ color: "red" }}>{errorsmg}</p>}

            <Col lg={12}>
              <button type="submit" className="btn btn-primary btn-main mt-2" > Submit </button>
            </Col>
          </Row>
        </form>

      </Dialog>

      <>
        <Dialog header="Confirm Your Action" visible={selectoneemp} onHide={() => { setselectoneemp(false); setSelectedScheduleval(""); setSelectedScheduleOption("") }}
          style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
          {/* <form onSubmit={handleSubmit3(onSubmitlinkcond)}> */}
          <Row>

            <h4 className='blue_dark_text font_weight_700'>
              Please Select Atleast One Job id
            </h4>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-end">
                <button color="primary" type="button" className="btn btn-primary me-2 cancel-outlinebtn"
                  onClick={() => { setselectoneemp(false); setSelectedScheduleOption(""); setSelectedScheduleval("") }}>
                  {/* <i className="pi pi-times me-1"></i> */}
                  Ok
                </button>
              </div>
            </Col>
          </Row>
          {/* </form> */}
        </Dialog></>
        <>
          <Dialog header="Confirm Your Action" visible={selectOnlyOneJob} onHide={() => setSelectOnlyOneJob(false)}
            style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
            <Row>
              <h4 className='blue_dark_text font_weight_700'>
                For only one job you can open that
              </h4>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="d-flex justify-content-end">
                  <button color="primary" type="button" className="btn btn-primary me-2 cancel-outlinebtn"
                    onClick={() => setSelectOnlyOneJob(false)}>
                    Ok
                  </button>
                </div>
              </Col>
            </Row>
          </Dialog></>
      <>
        <Dialog header="successfully" visible={successAlertlink} onHide={() => setsuccessAlertlink(false)}
          style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
          <Row>
            <div className='text-center py-3'>
              <div className='text-success font_54 '> <i className='fa fa-check-circle-o' aria-hidden='true'></i> </div>
              <h4 className='blue_dark_text font_weight_700'>Linked successfully </h4>
            </div>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-end">
                <button color="primary" type="button" className="btn btn-primary me-2 cancel-outlinebtn"
                  onClick={() => { setsuccessAlertlink(false) }}>
                  <i className="pi pi-times me-1"></i>
                  Ok
                </button>
              </div>
            </Col>
          </Row>
        </Dialog></>

      <Dialog
        header="Select Candidates"
        visible={jobDetailsVisible}
        onHide={() => setJobDetailsVisible(false)}
        style={{ width: "40vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        className="cand-details"
      >
        {/* Search Bar */}
        <Row>
          <Col lg={12}>
            <div
              className="p-inputgroup mb-3"
              style={{ position: "relative" }}
            >
              <InputText
                placeholder="Search Candidates"
                value={searchText}
                onInput={e => setSearchText(e.target.value)}
                style={{ paddingRight: "2rem" }} // Space for the icon
              />
              <i
                className="pi pi-search"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "49%",
                  transform: "translateY(-50%)",
                }}
              ></i>
            </div>
          </Col>
        </Row>

        {/* DataTable */}
        <DataTable
          // value={submitcondidatelist}
          value={filterDatalinkCONDI(filteredcaondidates)}
          lazy
          paginator first={lazyParamssub1.page * lazyParamssub1.rows}
          rows={lazyParamssub1.rows}
          totalRecords={totalRecordssub1}
          onPage={onPageChangesub1}
          loading={loading}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          rowsPerPageOptions={[10, 20, 50, totalRecordssub1]}
          selection={selectedJobsS}
          onSelectionChange={onSelectionmail}
          dataKey="candidate_id"
          size="small"
        >
          <Column selectionMode="multiple" style={{ width: '3em' }} />
          <Column body={fullNameTemplate} header="Full name" />
          <Column field="job_title" header="Designation" />
          <Column field="current_company" header="Company" />
        </DataTable>
        {/* Actions */}
        {condihide ? <div className="d-flex mt-3">
          <button
            type="button"
            className="btn btn-primary me-2 btn-main"
            onClick={() => { SetEmailviewpop(true); handleSavecond(); setJobDetailsVisible(false); setccemailinp([]); settoemailinp([]); settemplateval(""); setsubjectemail("") }}
          >
            Ok
          </button>
          {/* <button
                        type="button"
                        className="btn btn-primary btn-main"
                        onClick={handleRefresh}
                    >
                        Refresh
                    </button> */}
        </div> : ""}
      </Dialog>
      <>
        <div>
          <Dialog
            header={condidateslectnames?.length > 0 ? condidateslectnames.join(", ") : "Selected"}
            visible={emailviewpop}
            className="interview-popup"
            style={{ width: "55vw", height: "82%" }}
            maximizable
            modal
            onHide={() => {
              if (!emailviewpop) return;
              SetEmailviewpop(false);
              setSelectedEmailOption(null);
            }}
            footer={footerContent}
          >
            <form onSubmit={handleSubmit2(onSubmitemail)}>
              <>
                <div className="popup-header-bg">
                  <Row>
                    <Col xl={6} className="p-0 d-flex align-items-center">
                      <div className="popup-header d-flex">
                        <Dropdown
                          value={templateval}
                          onChange={handleTemplateChange}
                          options={templatei}
                          optionLabel="name"
                          placeholder="Template"
                          className="w-full md:w-10rem me-2"
                        />

                        <Dropdown
                          value={signatuteval}
                          onChange={handleSignatureChange}
                          options={signatutei}
                          optionLabel="name"
                          placeholder="Signature"
                          className="w-full md:w-10rem me-2"
                        />

                        {/* <div className="me-2" style={{ display: "flex", alignItems: "center" }}>
                          <Tooltip target=".attachment-button" content="Upload Files" />
                          <input
                            type="file"
                            multiple
                            style={{ width: "105px" }}
                            onChange={handleFileChange}
                          />

                        </div> */}
                        <div className="d-inline-block">

                          <FileUpload
                            ref={fileUploadRef}
                            name="emailAttachments[]"
                            mode="basic"
                            multiple
                            accept=".pdf, .png, .jpg, .jpeg"
                            maxFileSize={10 * 1024 * 1024} // 10MB
                            auto
                            chooseLabel={<span>Attach File</span>}
                            customUpload
                            uploadHandler={onUploadHandler1}
                            className="me-2"
                          />
                        </div>

                        {/* <Dropdown
                          value={selectedOption}
                          onChange={(e) => setSelectedOption(e.value)}
                          options={options}
                          optionLabel="label"
                          placeholder="Preview"
                          valueTemplate={selectedOptionTemplate}
                          itemTemplate={optionTemplate}
                          className="preview-icon w-full md:w-7rem action-items"
                          dropdownIcon={(opts) =>
                            opts.iconProps["data-pr-overlay-visible"] ? (
                              <EyeIcon {...opts.iconProps} />
                            ) : (
                              <ChevronDownIcon {...opts.iconProps} />
                            )
                          }
                        /> */}
                      </div>
                    </Col>

                    <Col xl={6}>

                      <div className="d-flex justify-content-end align-items-center mt-1">
                        {error && (
                          <div style={{ color: "red" }}>{error}</div>
                        )}
                        <button type="submit" className=" waves-light outlinebtn btn btn-primary mx-2">
                          <i className="fa-regular fa-paper-plane me-2"></i>Send
                        </button>
                      </div>
                    </Col>
                  </Row>
                </div>


                <div className="bg-form form-insidepop">
                  <Row className="mb-2">
                    <Col xl={12}>
                      <Row className="mb-2">
                        <Col xl={1} className="pe-0">
                          <div className="label-input">
                            <Dropdown
                              value={frominputemail}
                              onChange={handleDropdownChange}
                              options={fromEmail}
                              optionLabel="email"
                              placeholder="From"
                              className="from-width w-full"
                            />
                          </div>
                        </Col>
                        <Col xl={11}>
                          <Chips
                            value={fromemailinp}
                            onRemove={() => { setfromemailinp([]); setFrominputemail("") }}
                            className="size-mail w-full"
                            allowDuplicate={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col xl={1} className="pe-0">
                          <div className="label-input">
                            <Dropdown
                              // value={toinputemail}
                              // options={toEmail} // Handle undefined/null 
                              // onChange={handleDropdownChangeTO}
                              onClick={(e) => {
                                e.preventDefault();
                                setlinkJobVisible(true);
                              }}
                              optionLabel="email"
                              placeholder="To"
                              className="from-width w-full"
                            />
                          </div>
                        </Col>
                        <Col xl={11}>
                          <Chips
                            value={toemailinp}
                            // onClick={(e) => { showemialtovalues(true) }}
                             onChange={(e) => {
    settoemailinp(e.value);
    setError(""); // <-- Clear error when user adds/removes a value
  }}
                            removable={false}
                            onKeyDown={handleKeyDown1}
                            className="size-mail w-full"
                          />
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col xl={1} className="pe-0">
                          <div className="label-input">
                            <Dropdown
                              // value={ccinputemail}
                              // onChange={handleDropdownChangecc}
                              // onChange={(e) => setccinputemail(e.value)}
                              // options={ccEmail}
                              onClick={(e) => {
                                e.preventDefault();
                                setlinkJobCCVisible(true);
                              }}
                              optionLabel="email"
                              placeholder="Cc"
                              className="from-width w-full"
                            />
                          </div>
                        </Col>
                        <Col xl={11}>
                          <Chips
                            value={ccemailinp}
                            onChange={(e) => setccemailinp(e.value)}
                            removable={false}
                            className="size-mail w-full"
                            onKeyDown={handleKeyDown2}
                          />
                        </Col>
                      </Row>
                      <Row className="size-mail align-items-center">
                        <Col xl={1}>
                          <label htmlFor="interview">Subject:</label>
                        </Col>
                        <Col xl={11}>
                          <InputText
                            value={subjectemail}
                            onChange={(e) => setsubjectemail(e.target.value)}
                            placeholder=""
                            className="w-full"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {fileData && fileData?.length > 0 && (
                    <Row className="align-items-center">
                      <Col xl={1}>
                        <label htmlFor="interview">Attached:</label>
                      </Col>
                      <Col lg={11}>
                        <ul style={{ listStyle: "none", padding: 0, display: "flex", flexWrap: "wrap" }}>
                          {fileData?.map((item, index) => (
                            <li
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "10px",
                                marginRight: "10px",
                              }}
                              className="bg-warning p-2 rounded"
                            >
                              <i className="pi pi-file mr-2"></i>
                              <span style={{ marginRight: "10px" }}>{item.file_name}</span>
                              <button
                                style={{
                                  backgroundColor: "red",
                                  color: "white",
                                  border: "none",
                                  padding: "5px 10px",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                }}
                                onClick={() => removeFile(item.file_name)}
                              >
                                <i className="pi pi-times"></i>
                              </button>
                            </li>
                          ))}
                        </ul>
                      </Col>
                    </Row>
                  )}


                  <Row>
                    <Col xl={12}>
                      <Editor
                        value={emailtextEditor}
                        onTextChange={(e) => setEmailtextEditor(e.htmlValue)}
                        className="jobsall-editor"
                      />
                    </Col>
                  </Row>
                </div>
              </>
            </form>
          </Dialog>
        </div></>

      <Dialog header={`NOTES`} visible={visibleNote} onHide={() => setvisibleNote(false)}
        style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
        <form onSubmit={handleSubmit5(jobnotereq)}>
          <Row>
            <Col lg={6}>
              <div className="field">
                <label htmlFor="candidate" className="block mb-0">
                  Type
                </label>
                <InputText
                  id="candidate"
                  value="Note"
                  readOnly
                  className="w-full"
                  placeholder="Note"
                  disabled
                />
              </div>
            </Col>


            <Col lg={6}>
              <div className="field">
                <label htmlFor="currentDateTime" className="block mb-0">
                  Date
                </label>
                <Calendar
                  id="currentDateTime"
                  value={currentDateTime}
                  onChange={handleChange}
                  onSelect={handleSelect}
                  showTime
                  showIcon
                  dateFormat="yy-mm-dd"
                  hourFormat="12"
                  readOnlyInput
                  className="w-full"
                  ref={calendarRef}
                  minDate={new Date()}
                />
                {/* <Calendar
                  id="currentDateTime"
                  value={currentDateTime}
                  onChange={(e) => setCurrentDateTime(e.value)} // Update state on change
                  showTime
                  showIcon
                  dateFormat="dd/mm/yy" // Customize the date format
                  hourFormat="12" // Use 12-hour time format (or "12" for AM/PM)
                  readOnlyInput
                  className="w-full"
                /> */}
              </div>
            </Col>

            {/* <Col lg={12}>
                              <div className="field">
                                  <label htmlFor="candidate" className="block mb-0">
                                      Candidates
                                  </label>
                                  <InputText
                                      id="candidate"
                                      value={candidateName}
                                      readOnly
                                      className="w-full"
                                      disabled
                                  />
                              </div>
                          </Col> */}

            <Col lg={12}>
              <div className="field">
                <label htmlFor="job" className="block mb-0">Jobs</label>
                <div className="d-flex align-items-center" style={{ position: 'relative' }}>

                  <InputText
                    id="job"
                    value={selectedJobTitles}
                    onChange={(e) => setSelectedJobTitles(e.target.value)}
                    placeholder={selectedJobsData.length > 0 ? usersList : 'Select job'}
                    className="w-full"
                    style={{ paddingRight: '2rem' }} // Ensure space for the icon
                    disabled={selectedJobsData.length > 0}
                  />
                  {selectedJobsData.length === 0 && (
                    <i
                      className="pi pi-chevron-down"
                      onClick={handleIconClickjob}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer'
                      }}
                    // disabled={selectedCustomers.length > 0}
                    ></i>
                  )}

                  {/* <InputText

                    value={selectedJobTitles}
                    // onChange={(e) => setSelectedJobTitles(e.target.value)}
                    placeholder="Enter Job"
                    className="w-full"
                    style={{ paddingRight: '2rem' }} // Ensure space for the icon
                  />
                  <i className="pi pi-chevron-down"
                    onClick={handleIconClickjob}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer'
                    }}
                  ></i> */}
                </div>
                <Dialog
                  header="Job Details"
                  visible={jobDetailsVisiblelist}
                  onHide={() => setjobDetailsVisiblelist(false)}
                  style={{ width: '40vw' }}
                  breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                >
                  <Row>
                    <Col lg={12}>
                      <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                        <InputText
                          placeholder="Search Jobs"
                          value={searchText1}
                          onInput={(e) => setSearchText1(e.target.value)}
                          style={{ paddingRight: '2rem' }} // Space for the icon
                        />
                        <i className="pi pi-search"
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '49%',
                            transform: 'translateY(-50%)',
                          }}
                        ></i>
                      </div>
                    </Col>
                  </Row>
                  <DataTable
                    value={filterDatalinkjOB(filteredJobslink)}
                    lazy
                    paginator first={lazyParamsjob1.page * lazyParamsjob1.rows}
                    rows={lazyParamsjob1.rows} totalRecords={totalRecordsjob1}
                    onPage={onPageChangejob1}
                    loading={loading}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 20, 50, totalRecordsjob1]}
                    selection={selectedJobListname}
                    // onSelectionChange={(e) => setselectedJobListname(e.value)}
                    // onSelectionChange={(e) => setselectedJobListname(e.value)}
                    onSelectionChange={handleJobSelectionChange}
                    dataKey="job_id"
                    size="small" // Set size to small
                  >
                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                    <Column field="job_number" header="Job ID" />
                    <Column field="job_title" header="Job Title" />

                  </DataTable>
                  <div className="d-flex  mt-3">
                    <button type="submit" class="btn btn-primary me-2 btn-main" onClick={() => { setjobDetailsVisiblelist(false) }}>Save</button>
                    <button type="button" class="btn btn-primary btn-main" onClick={handleRefreshlinkjobs}>Refresh</button>
                  </div>
                </Dialog>
              </div>
            </Col>
          </Row>
          <Row>
            {/* <Col lg={6}>
                              <div className="field">
                                  <label htmlFor="currentDateTime" className="block mb-0">
                                      Date
                                  </label>
                                  <Calendar
                                      id="currentDateTime"
                                      value={currentDateTime}
                                      onChange={(e) => setCurrentDateTime(e.value)} // Update state on change
                                      showTime
                                      showIcon
                                      dateFormat="dd/mm/yy" // Customize the date format
                                      hourFormat="12" // Use 12-hour time format (or "12" for AM/PM)
                                      readOnlyInput
                                      className="w-full"
                                  />
                              </div>
                          </Col> */}

            <Col lg={12}>
              <div className="field">
                <label htmlFor="notes" className="block mb-0">
                  Notes
                </label>
                <InputTextarea
                  id="notes"
                  value={notesjobs}
                  onChange={(e) => setnotesjobs(e.target.value)} // Update the state on input change
                  rows={3} // Number of visible rows
                  cols={20} // Number of visible columns
                  className="w-full"
                  placeholder="Enter your notes here..."
                  autoResize // Automatically adjusts height as content grows
                />
              </div>
            </Col>

          </Row>
          <Row className="align-items-center">
            <Col lg={2}>
              {/* <div className="d-flex align-items-center">
                <Checkbox
                  inputId="checkbox"
                  checked={popchecked}
                  onChange={handlePopupCheckbox}
                />
                <label htmlFor="username" className="ms-2 mt-2">
                  Private
                </label>
              </div> */}
            </Col>
            <Col lg={6}>
              <div className="field notes-chip">
                <label htmlFor="userId" className="block mb-0">
                  User IDs
                </label>
                <InputText
                  value={uniqueUserId}
                  readOnly
                  placeholder="Select a User ID"
                  className="w-full activejobdrop" />
              </div>
            </Col>




          </Row>

          <Row>

            <Col lg={12}>
              <div className="d-flex justify-content-end">
                <button type="submit" class="btn btn-primary me-2 btn-main" >Add Note</button>
              </div>
            </Col>
          </Row>
        </form>

      </Dialog>
      <Dialog
        header="Select Contact"
        visible={linkJobVisible}
        onHide={() => { setSearchTextTo(""); setlinkJobVisible(false) }}
        style={{ width: "40vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        className="cand-details"
      >
        <Row>
          <Col lg={12}>
            <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
              <InputText
                placeholder="Search Contact"
                value={searchTextTo}
                onChange={handleSearchTo}
                style={{ paddingRight: "2rem" }}
              />
              <i
                className="pi pi-search"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "49%",
                  transform: "translateY(-50%)",
                }}
              ></i>
            </div>
          </Col>
        </Row>

        <DataTable
          value={toEmail?.filter(contact =>
            contact.first_name?.toLowerCase().includes(searchTextTo?.toLowerCase()) ||
            contact.job_title?.toLowerCase().includes(searchTextTo?.toLowerCase()) ||
            contact.email?.toLowerCase().includes(searchTextTo?.toLowerCase())
          ) || []}


          paginator
          first={lazyParamssubTO.page * lazyParamssubTO.rows}
          rows={lazyParamssubTO.rows}
          totalRecords={totalRecordsTO}
          onPage={onPageChangeTO}

          lazy
          selection={selectedJoblist}
          onSelectionChange={(e) => setselectedJoblist(e.value || [])}
          dataKey="id"
          rowsPerPageOptions={[10, 25]}
          size="small"
          // first={lazyParamsjoblist.first}
          // rows={lazyParamsjoblist.rows}
          // totalRecords={totalRecordsjoblist}

          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
        >
          <Column selectionMode="multiple" style={{ width: "3em" }} />
          <Column header="Contact Name" body={(rowData) => `${rowData.first_name || ''} ${rowData.middle_name || ''} ${rowData.last_name || ''}`} />
          <Column field="job_title" header="Designation" />
          <Column field="email" header="Email" />
        </DataTable>


        <div className="d-flex mt-3">
          <button
            type="button"
            className="btn btn-primary me-2 btn-main"
            onClick={() => {
              handleSaveContact();
              setSearchTextTo(""); // Reset search text when "Ok" is clicked
            }}
          >
            Ok
          </button>
          <button
            type="button"
            className="btn btn-primary btn-main"
            onClick={handleRefresh}
          >
            Refresh
          </button>
        </div>
      </Dialog>


      <Dialog
        header="Select Contact"
        visible={linkJobCCVisible}
        onHide={() => { setSearchTextTo(""); setlinkJobCCVisible(false) }}
        style={{ width: "40vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        className="cand-details"
      >
        <Row>
          <Col lg={12}>
            <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
              <InputText
                placeholder="Search Contact"
                value={searchTextTo}
                onChange={handleSearchTo}
                style={{ paddingRight: "2rem" }}
              />
              <i
                className="pi pi-search"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "49%",
                  transform: "translateY(-50%)",
                }}
              ></i>
            </div>
          </Col>
        </Row>

        <DataTable
          value={ccEmail?.filter(contact =>
            contact?.first_name?.toLowerCase().includes(searchTextTo?.toLowerCase()) ||
            contact?.job_title?.toLowerCase().includes(searchTextTo?.toLowerCase()) ||
            contact?.email?.toLowerCase().includes(searchTextTo?.toLowerCase())
          ) || []}


          paginator
          first={lazyParamssubCC.page * lazyParamssubCC.rows}
          rows={lazyParamssubCC.rows}
          totalRecords={totalRecordsCC}
          onPage={onPageChangeCC}

          lazy
          selection={selectedCCJoblist}
          onSelectionChange={(e) => setselectedCCJoblist(e.value || [])}
          dataKey="id"
          rowsPerPageOptions={[10, 25]}
          size="small"
          // first={lazyParamsjoblist.first}
          // rows={lazyParamsjoblist.rows}
          // totalRecords={totalRecordsjoblist}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"

        >
          <Column selectionMode="multiple" style={{ width: "3em" }} />
          <Column header="Contact Name" body={(rowData) => `${rowData.first_name || ''} ${rowData.middle_name || ''} ${rowData.last_name || ''}`} />
          <Column field="job_title" header="Designation" />
          <Column field="email" header="Email" />
        </DataTable>
        <div className="d-flex mt-3">
          <button
            type="button"
            className="btn btn-primary me-2 btn-main"
            onClick={() => {
              handleSaveccjob()
              setSearchTextTo(""); // Reset search text when "Ok" is clicked
            }}
          >
            Ok
          </button>
          <button
            type="button"
            className="btn btn-primary btn-main"
            onClick={handleRefresh1}
          >
            Refresh
          </button>
        </div>
      </Dialog>
<Dialog
  header="No Subject"
  visible={showNoSubjectConfirm}
  style={{ width: "400px" }}
  modal
  onHide={handleCancelSend}
  footer={
    <div>
      <Button label="Yes, Send" className="btn btn-primary me-2" onClick={handleConfirmSend} />
      <Button label="Cancel" className="btn btn-secondary" onClick={handleCancelSend} />
    </div>
  }
>
  <p>Do you want to send this email without a subject?</p>
</Dialog>

    {/* Candidate Sidebar */}
    <Row>
      <Col lg={12}>
        <Sidebar
          visible={candidateSidebarVisible}
          position="right"
          onHide={() => {
            dispatch(setCandidateSidebarVisible(false))
            resetCandidateSidebarForm();
            setFormData(prev => ({ ...prev, ...initialAddressState }))
            setTempAddressData({ ...initialAddressState })
            setIsDuplicateEmail(false)
            setDuplicateCandidateId(null)
            setEmailError("")
            setResumeError("")
          }}
          className="sidebar"
        >
          <div className="sidebar-header">
            <h3>Create a Candidate</h3>
            <div className="d-flex align-items-center">
              <Link to="/candidate-editform">
                <p className="mb-0 text-white">
                  {" "}
                  <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                </p>
              </Link>
              <Button
                icon="pi pi-times"
                className="p-button-text close-btn"
                onClick={() => {
                  dispatch(setCandidateSidebarVisible(false));
                  resetCandidateSidebarForm();
                  setFormData(prev => ({
                    ...prev,
                    ...initialAddressState,
                  }))
                  setTempAddressData({ ...initialAddressState })
                  setIsDuplicateEmail(false)
                  setDuplicateCandidateId(null)
                  setEmailError("")
                  setResumeError("")
                }}
              />
            </div>
          </div>
          <form onSubmit={handleSubmit(onSubmitCandidate)}>
            <div className="card sidebardetails">
              <Row className="mb-3">
                <Col lg={6}>
                  <label className="mb-0">
                    First Name <span className="text-danger">*</span>
                  </label>
                  <InputText
                    {...register("firstname", {
                      required: "First name is required *",
                      pattern: {
                        value: /^[A-Za-z][A-Za-z-\s&,]+$/,
                        message:
                          "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                      },
                      maxLength: {
                        value: 100,
                        message: "Minimum 100 Characters Are Allowed",
                      },
                      minLength: {
                        value: 1,
                        message: "Minimum 1 Characters Are Allowed",
                      },
                    })}
                    onKeyUp={() => {
                      trigger("firstname")
                    }}
                  />
                  {errors.firstname && (
                    <small
                      id="personalEmailHelp"
                      className="form-text text-danger"
                    >
                      {errors.firstname.message}
                    </small>
                  )}
                </Col>
                <Col lg={6}>
                  <label htmlFor="lastName" className="mb-0">
                    Last Name
                  </label>
                  <InputText
                    id="lastName"
                    name="lastName"
                    {...register("lastname", {
                      // required: "Last name is required",
                      pattern: {
                        value: /^[A-Za-z][A-Za-z-\s&]+$/,
                        message:
                          "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                      },
                      maxLength: {
                        value: 100,
                        message: "Minimum 100 Characters Are Allowed",
                      },
                      minLength: {
                        value: 1,
                        message: "Minimum 1 Characters Are Allowed",
                      },
                    })}
                    onKeyUp={() => {
                      trigger("lastname")
                    }}
                  />
                  {errors.lastname && (
                    <small
                      id="personalEmailHelp"
                      className="form-text text-danger"
                    >
                      {errors.lastname.message}
                    </small>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={6}>
                  <label htmlFor="email" className="mb-0">
                    Email <span className="text-danger">*</span>
                  </label>
                  {/* sais code */}
                  <InputText
                    id="email"
                    name="email"
                    inputRef={emailInputRef}
                    {...register("personal_email", {
                      required: "Email is required *",
                      pattern: emailValidation,
                      onChange: async event => {
                        const value = event.target.value.toLowerCase();
                        setValue("personal_email", value);

                        // Debounce logic starts here
                        if (emailDebounceRef.current) {
                          clearTimeout(emailDebounceRef.current);
                        }
                        emailDebounceRef.current = setTimeout(async () => {
                          if (value) {
                            try {
                              const response = await axios.post(
                                "/api/v1/candidates/check-email/",
                                { email: value }
                              );
                              if (response.data.duplicate) {
                                setIsDuplicateEmail(true);
                                setDuplicateCandidateId(response.data.candidate_id);
                                setEmailError("Candidate with this email already exists.");
                              } else {
                                setIsDuplicateEmail(false);
                                setDuplicateCandidateId(null);
                                setEmailError("");
                              }
                            } catch (err) {
                              setIsDuplicateEmail(false);
                              setDuplicateCandidateId(null);
                              setEmailError("Failed to check duplicate email.");
                            }
                          } else {
                            setIsDuplicateEmail(false);
                            setDuplicateCandidateId(null);
                            setEmailError("");
                          }
                        }, 700); // 700ms debounce
                        // Debounce logic ends here
                      },
                    })}
                  />
                  {(isDuplicateEmail && duplicateCandidateId) ||
                  emailError ? (
                    <div className="mt-2">
                      <small className="form-text text-danger">
                        {emailError ||
                          "Candidate with this email already exists."}
                      </small>
                      {isDuplicateEmail && duplicateCandidateId && (
                        <Button
                          className="btn btn-warning ms-2"
                          onClick={() =>{
                            dispatch(setCandidateSidebarVisible(false)); // Hide sidebar
                            navigate(
                              `/candidate-editform?candidate_id=${duplicateCandidateId}`
                            )
                          }}
                        >
                          Edit Candidate
                        </Button>
                      )}
                    </div>
                  ) : null}

                  {errors.personal_email && (
                    <small
                      id="personalEmailHelp"
                      className="form-text text-danger"
                    >
                      {errors.personal_email.message}
                    </small>
                  )}
                </Col>

                <Col lg={6}>
                  <label htmlFor="phoneNumber" className="mb-0">
                    Phone Number{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <InputText
                    id="phoneNumber"
                    name="phoneNumber"
                    {...register("phone", {
                      required: "Phone number is required *",
                      pattern: onlyNumbers,
                      minLength: MinLengthValidation(10),
                      maxLength: MaxLengthValidation(14),
                      validate: {
                        notAllZeros: value =>
                          !/^0+$/.test(value) ||
                          "Mobile number cannot be all zeros",
                        exactLength: value =>
                          value.length === 10 ||
                          "Mobile number must be exactly 10 digits",
                      },
                    })}
                    onKeyUp={e => {
                      trigger("phone")
                    }}
                  />{" "}
                  {errors.phone && (
                    <small
                      id="phoneNoHelp"
                      className="form-text text-danger"
                    >
                      {errors.phone.message}
                    </small>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={6}>
                  <label htmlFor="jobTitle" className="mb-0">
                    Job Title
                  </label>
                  <InputText
                    id="jobTitle"
                    name="jobTitle"
                    {...register("jobtitle", {
                      //   required: "This field is required",
                      pattern: onlyAlphabetsandSpaces,
                    })}
                    onKeyUp={() => {
                      trigger("jobtitle")
                    }}
                  />
                  {errors.jobtitle && (
                    <small
                      id="emailHelp"
                      className="form-text text-danger"
                    >
                      {errors.jobtitle.message}
                    </small>
                  )}
                </Col>
                <Col lg={6}>
                  <label htmlFor="company" className="mb-0">
                    Company
                  </label>
                  <Controller
                    name="Company"
                    control={control}
                    render={({ field }) => (
                      <InputText
                        {...field}
                        value={field.value || ""}
                        placeholder="Enter Company Name"
                        className="w-full border border-gray-300 rounded-md bg-white"
                        onChange={e => field.onChange(e.target.value)}
                      />
                    )}
                  />
                  {errors.Company && (
                    <small id="emailHelp" className="form-text text-danger">
                      {errors.Company.message}
                    </small>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={6}>
                  <label htmlFor="source" className="mb-0">
                    Source <span className="text-danger">*</span>
                  </label>
                  <Dropdown
                    id="source"
                    value={formData.source}
                    options={resumeSourceOptions}
                    placeholder="Select Source"
                    className={`w-full border border-gray-300 rounded-md bg-white ${formErrors.source ? 'p-invalid' : ''}`}
                    onChange={e => handleCandidateInputChange('source', e.value)}
                    filter
                    showClear={!!formData.source}
                    optionLabel="label"
                    optionValue="value"
                  />
                  {formErrors.source && (
                    <small className="text-danger d-block mt-1">
                      {formErrors.source}
                    </small>
                  )}
                </Col>
                <Col lg={6}>
                  <label htmlFor="primarySkills" className="mb-0">
                    Primary Skills
                  </label>
                  {/* <Dropdown
                    id="jobLocation"
                    value={primarySkillsview}
                    onChange={(e) => setprimarySkillsview(e.value)}
                    options={primarySkillsget}
                    optionLabel="name"
                    optionValue="id"
                    filter
                    filterPlaceholder="Search Location"
                    className="w-full activejobdrop"
                    placeholder="Enter job location..."Relocation
                  /> */}
                  <MultiSelect
                    id="primarySkills"
                    value={primarySkillsview}
                    onChange={e => setprimarySkillsview(e.value)} // e.value will be an array of selected IDs
                    options={candidatePrimarySkillsget}
                    optionLabel="name"
                    optionValue="id"
                    filter
                    display="chip" // optional: shows chips for selected values
                    className="w-full activejobdrop"
                    placeholder="Select primary skills..."
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={6}>
                  <label htmlFor="stage" className="mb-0">
                    Stage <span className="text-danger">*</span>
                  </label>
                  <Dropdown
                    id="stage"
                    value={formData.stage}
                    options={stages.filter(stage => stage).map(stage => ({
                      label: stage.charAt(0).toUpperCase() + stage.slice(1), // Capitalize first letter
                      value: stage
                    }))}
                    placeholder="Select Stage"
                    className={`w-full border border-gray-300 rounded-md bg-white ${formErrors.stage ? 'p-invalid' : ''}`}
                    onChange={e => handleCandidateInputChange('stage', e.value)}
                    filter
                    showClear={!!formData.stage}
                    optionLabel="label"
                    optionValue="value"
                  />
                  {formErrors.stage && (
                    <small className="text-danger d-block mt-1">
                      {formErrors.stage}
                    </small>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                {/* <Col lg={6} className="mb-2">
                  <label htmlFor="country" className="mb-0">
                    Country
                  </label>
                  <Dropdown
                    id="country"
                    value={selectedCountry}
                    onChange={(e) => { setSelectedCountry(e.value) }}
                    options={addCountry}
                    optionLabel="name"
                    filter
                    filterPlaceholder="Search Country"
                    className="w-full activejobdrop"
                    placeholder="Enter Country details..."
                  />
                </Col>
                <Col lg={6} className="mb-2">
                  <label htmlFor="state" className="mb-0">
                    State
                  </label>
                  <Dropdown
                    id="state"
                    value={selectedState}
                    onChange={(e) => { setSelectedState(e.value) }}
                    options={addStates}
                    optionLabel="name"
                    filter
                    filterPlaceholder="Search "
                    className="w-full activejobdrop"
                    placeholder="Enter state details..."
                  />
                </Col> */}
                {/* <Col lg={6}>
                  <label htmlFor="city" className="mb-0">
                    City
                  </label>
                  <Dropdown
                    id="city"
                    value={selectedCity}
                    onChange={e => {
                      setSelectedCity(e.value)
                    }}
                    optionValue="city_id"
                    options={addCities}
                    optionLabel="name"
                    filter
                    filterPlaceholder="Search City"
                    className="w-full activejobdrop"
                    placeholder="Enter city details..."
                  />
                </Col> */}

                <Col lg={12}>
                  <label
                    htmlFor="availabilityDate"
                    className="mb-0 avbdate"
                  >
                    Availability Date
                  </label>
                  <input
                    type="date"
                    id="availabilityDate"
                    name="availabilityDate"
                    className="form-control"
                    min={new Date().toISOString().split("T")[0]}
                    // max={MaxDateOfBith}
                    {...register("Availability", {})}
                  />
                  {errors.Availability && (
                    <small
                      id="emailHelp"
                      className="form-text text-danger"
                    >
                      {errors.Availability.message}
                    </small>
                  )}
                </Col>
              </Row>
              {/* sai's code */}
              <Row className="mb-3">
                <Col lg={12}>
                  <div
                    className="p-field companie-add"
                    style={{ position: "relative" }}
                  >
                    <label htmlFor="address">Address</label>
                    <InputTextarea
                      id="address"
                      value={formData.address}
                      readOnly
                      style={{ paddingRight: "2rem" }}
                      rows={3}
                      cols={30}
                      className={
                        formErrors.address
                          ? "p-invalid w-full"
                          : "w-full"
                      }
                    />
                    <i
                      className="pi pi-pencil"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "70%",
                        transform: "translateY(-50%)",
                        color: "#6c757d",
                        cursor: "pointer",
                      }}
                      onClick={openAddressDialog}
                    />
                    <Dialog
                      header="Edit Address"
                      className="address-popup"
                      visible={visible}
                      onHide={handleAddressDialogCancel}
                      style={{ width: "30vw" }}
                      breakpoints={{
                        "960px": "75vw",
                        "641px": "100vw",
                      }}
                      footer={
                        <div>
                          <Button
                            label="OK"
                            icon="pi pi-check"
                            onClick={handleAddressDialogOk}
                            className="p-button-primary"
                          />
                        </div>
                      }
                    >
                      <div className="card sidebardetails">
                        <form>
                          <Row className="mb-3">
                            <Col lg={6}>
                              <div className="p-field">
                                <label htmlFor="street_address">
                                  Street 1
                                </label>
                                <InputText
                                  id="street_address"
                                  value={
                                    tempAddressData.street_address
                                  }
                                  onChange={e =>
                                    handleTempAddressChange(
                                      "street_address",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Enter Street 1"
                                  className={
                                    formErrors.street_address
                                      ? "p-invalid w-full activejobdrop"
                                      : "w-full activejobdrop"
                                  }
                                />
                                {formErrors.street_address && (
                                  <small className="p-error">
                                    {formErrors.street_address}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="p-field">
                                <label htmlFor="street_address_line_2">
                                  Street 2
                                </label>
                                <InputText
                                  id="street_address_line_2"
                                  value={
                                    tempAddressData.street_address_line_2
                                  }
                                  onChange={e =>
                                    handleTempAddressChange(
                                      "street_address_line_2",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Enter Street 2 (Optional)"
                                  className={
                                    formErrors.street_address_line_2
                                      ? "p-invalid w-full activejobdrop"
                                      : "w-full activejobdrop"
                                  }
                                />
                                {formErrors.street_address_line_2 && (
                                  <small className="p-error">
                                    {formErrors.street_address_line_2}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg={6}>
                              <div className="p-field">
                                <label htmlFor="country">
                                  Country
                                </label>
                                <Dropdown
                                  id="country"
                                  value={tempAddressData.country}
                                  onChange={e =>
                                    handleTempAddressChange(
                                      "country",
                                      e.value
                                    )
                                  }
                                  options={countries}
                                  optionLabel="name"
                                  optionValue={option => option}
                                  filter
                                  filterPlaceholder="Search Country"
                                  className={
                                    formErrors.country
                                      ? "p-invalid w-full activejobdrop"
                                      : "w-full activejobdrop"
                                  }
                                  placeholder="Select Country"
                                  disabled={!countries.length}
                                />
                                {formErrors.country && (
                                  <small className="p-error">
                                    {formErrors.country}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="p-field">
                                <label htmlFor="state">State</label>
                                <Dropdown
                                  id="state"
                                  value={tempAddressData.state}
                                  onChange={e =>
                                    handleTempAddressChange(
                                      "state",
                                      e.value
                                    )
                                  }
                                  options={states}
                                  optionLabel="name"
                                  optionValue={option => option}
                                  filter
                                  filterPlaceholder="Search State"
                                  className={
                                    formErrors.state
                                      ? "p-invalid w-full activejobdrop"
                                      : "w-full activejobdrop"
                                  }
                                  placeholder="Select State"
                                  disabled={
                                    !tempAddressData.country ||
                                    !states.length
                                  }
                                />
                                {formErrors.state && (
                                  <small className="p-error">
                                    {formErrors.state}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg={6}>
                              <div className="p-field">
                                <label htmlFor="city">City</label>
                                <Dropdown
                                  id="city"
                                  value={tempAddressData.city}
                                  onChange={e =>
                                    handleTempAddressChange(
                                      "city",
                                      e.value
                                    )
                                  }
                                  options={cities}
                                  optionLabel="name"
                                  optionValue={option => option}
                                  filter
                                  filterPlaceholder="Search City"
                                  className={
                                    formErrors.city
                                      ? "p-invalid w-full activejobdrop"
                                      : "w-full activejobdrop"
                                  }
                                  placeholder="Select City"
                                  disabled={
                                    !tempAddressData.state ||
                                    !cities.length
                                  }
                                />
                                {formErrors.city && (
                                  <small className="p-error">
                                    {formErrors.city}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="p-field">
                                <label htmlFor="pincode">
                                  Postal Code
                                </label>
                                <InputText
                                  id="pincode"
                                  value={tempAddressData.pincode}
                                  onChange={e =>
                                    handleTempAddressChange(
                                      "pincode",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Enter Postal Code"
                                  className={
                                    formErrors.pincode
                                      ? "p-invalid w-full activejobdrop"
                                      : "w-full activejobdrop"
                                  }
                                />
                                {formErrors.pincode && (
                                  <small className="p-error">
                                    {formErrors.pincode}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg={12}>
                              <div className="pist-field">
                                <label htmlFor="label">Label</label>
                                <Dropdown
                                  id="label"
                                  value={tempAddressData.label}
                                  onChange={e =>
                                    handleTempAddressChange(
                                      "label",
                                      e.value
                                    )
                                  }
                                  options={addressLabels}
                                  optionLabel="label"
                                  optionValue="value"
                                  placeholder="Select Label"
                                  className={
                                    formErrors.label
                                      ? "p-invalid w-full activejobdrop"
                                      : "w-full activejobdrop"
                                  }
                                />
                                {formErrors.label && (
                                  <small className="p-error">
                                    {formErrors.label}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </form>
                      </div>
                    </Dialog>
                  </div>
                </Col>
              </Row>

              {/* <Row className="mb-3">
                <Col lg={12}>
                  <label
                    htmlFor="availabilityDate"
                    className="mb-0 avbdate"
                  >
                    Resume Attachment
                  </label>

                  <input
                    type="file"
                    accept="image/jpg,image/jpeg,image/png,application/pdf"
                    className="form-control addEmp_ProfilePhoto"
                    id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                    onChange={handleFileChange}
                  />
                  {error && (
                    <small className="text-danger">{error}</small>
                  )}
                  <small className="text-muted">
                    Eg: (jpeg,png,pdf,jpg)
                  </small>
                </Col>
              </Row> */}
              <Row className="mb-3">
                <Col lg={12}>
                  <label
                    htmlFor="availabilityDate"
                    className="mb-0 avbdate"
                  >
                    Resume Attachment
                  </label>
                  <input
                    type="file"
                    accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    className="form-control addEmp_ProfilePhoto"
                    id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                    onChange={handleCandidateFileChange}
                  />
                  {resumeError && (
                    <small className="text-danger">
                      {resumeError}
                    </small>
                  )}
                  <small className="text-muted">
                    Eg: (jpeg, png, pdf, jpg, doc, docx) upto 5MB
                  </small>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col lg={6}>
                  <div className="p-field">
                    <label htmlFor="company">Categories</label>
                    <TreeSelect
                      value={selectedCategoryNode}
                      options={categoryNodes}
                      onChange={e => setSelectedCategoryNode(e.value)}
                      className="w-full"
                      placeholder="Select Category"
                      filter
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="p-field">
                    <label htmlFor="company">Group</label>
                    <TreeSelect
                      value={selectedGroupNode}
                      options={groupNodes}
                      onChange={e => setSelectedGroupNode(e.value)}
                      className="w-full"
                      placeholder="Select Group"
                      filter
                    />
                  </div>
                </Col>
              </Row>

              <Row className="mb-2 align-items-end">
                <Col lg={6}>
                  <div className="p-field">
                    <label htmlFor="jobType">UserIDs</label>
                    <InputText
                      value={uniqueUserId}
                      disabled
                      placeholder="Select a User ID"
                      className="w-full activejobdrop"
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <Row>
                    <Col lg={6}>
                      <div className="mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <Controller
                            name="relocation"
                            control={control}
                            render={({ field }) => (
                              <Checkbox
                                inputId="relocation"
                                onChange={e =>
                                  field.onChange(e.checked)
                                }
                                checked={field.value}
                                onBlur={field.onBlur}
                              />
                            )}
                          />
                          <label
                            htmlFor="relocation"
                            className="mb-0"
                          >
                            Relocation
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <Controller
                            name="private"
                            control={control}
                            render={({ field }) => (
                              <>
                                <Checkbox
                                  inputId="private"
                                  inputRef={field.ref}
                                  checked={field.value}
                                  onChange={e => {
                                    field.onChange(e.checked)
                                    trigger("private")
                                  }}
                                />
                                <label
                                  htmlFor="private"
                                  className="mb-0"
                                >
                                  Private
                                </label>
                              </>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    {/* <Col lg={6}>
                      <div className="p-field">
                        <input
                          type="checkbox"
                          className="me-2"
                          {...register("private", {})}
                          onKeyUp={() => {
                            trigger("private")
                          }}
                        />
                        <label htmlFor="jobType">Private</label>
                      </div>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
              <Row>
                {candidateError && (
                  <Col lg={12}>
                    <div className="alert alert-danger mt-3">
                      {candidateError}
                    </div>
                  </Col>
                )}
                {candidateLoading && (
                  <div className="flex justify-content-center align-items-center mt-3">
                    <ProgressSpinner />
                  </div>
                )}
              </Row>
              <div className="buttons float-end">
                <Button
                  type="submit"
                  color="primary"
                  className="btn btn-primary me-2 sidebarbtn"
                  // onClick={() => setVisibleRight(false)}
                  disabled={candidateLoading}
                >
                  {candidateLoading ? "Saving..." : "Create"}
                </Button>
                <Button
                  color="primary"
                  className="btn btn-primary  outlinebtn"
                  // onClick={() => { reset(); setVisibleRight(false) }}
                  onClick={handleCanacelCreateCandidate}
                  disabled={candidateLoading || disable}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </form>
        </Sidebar>
      </Col>
    </Row>
    </React.Fragment>
  );
};
export default JobAllActive;